"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[289],{

/***/ 601:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RD": function() { return /* binding */ Logout; }
/* harmony export */ });
/* unused harmony exports LogoXing, LogoYelp, LogoYoutube, Loop, LoopAlt, LowSeverity, Mac, MacCommand, MacOption, MacShift, MachineLearning, MachineLearningModel, MagicWand, MagicWandFilled, MailAll, MailReply, ManageProtection, ManagedSolutions, Map, MapBoundary, MapBoundaryVegetation, MapCenter, MapIdentify, Marginal, MarineWarning, MaterialRequest, MathCurve, Maximize, MediaCast, MediaLibrary, MediaLibraryFilled, Medication, MedicationAlert, MedicationReminder, Menu, Merge, MergeNode, MessageQueue, Meter, MeterAlt, Microphone, MicrophoneFilled, MicrophoneOff, MicrophoneOffFilled, Microscope, Microservices_1, Microservices_2, Migrate, MigrateAlt, Milestone, MilitaryCamp, MinimapOff, MinimapOn, Minimize, Misuse, MisuseOutline, MixedRainHail, MlModelReference, Mobile, MobileAdd, MobileAudio, MobileCheck, MobileCrash, MobileDownload, MobileEvent, MobileLandscape, MobileRequest, MobileSession, MobileView, MobileViewOrientation, MobilityServices, Model, ModelAlt, ModelBuilder, ModelBuilderReference, ModelFoundation, ModelReference, ModelTuned, ModifiedNewest, ModifiedOldest, Money, Monster, Monument, Moon, Moonrise, Moonset, MostlyCloudy, MostlyCloudyNight, Mountain, Mov, Move, Movement, Mp3, Mp4, Mpeg, Mpg2, MultiuserDevice, Music, MusicAdd, MusicRemove, Mysql, NameSpace, NamingConventions, NavaidCivil, NavaidDme, NavaidHelipad, NavaidMilitary, NavaidMilitaryCivil, NavaidNdb, NavaidNdbDme, NavaidPrivate, NavaidSeaplane, NavaidTacan, NavaidVhfor, NavaidVor, NavaidVordme, NavaidVortac, Need, Network_1, Network_2, Network_3, QMatrix, WatsonHealthMagnify, WatsonHealthMammogram */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _circle, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _circle2, _path109, _path110, _circle3, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _switch, _switch2, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _circle4, _circle5, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _circle6, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _circle7, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _circle8, _path297, _path298, _path299, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _path300, _path301, _path302, _path303, _path304, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _path305, _path306, _path307, _path308, _circle33, _path309, _path310, _path311, _circle34, _path312, _circle35, _path313, _circle36, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329;
const didWarnAboutDeprecation = {};
const LogoXing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoXing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.42,8.29a1.25,1.25,0,0,0-1.13-.76h-4a.65.65,0,0,0-.55.25.63.63,0,0,0,0,.62l2.73,4.73v0L4.17,20.72a.6.6,0,0,0,0,.62.58.58,0,0,0,.52.28h4a1.22,1.22,0,0,0,1.1-.78l4.36-7.71S11.42,8.29,11.42,8.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.83,2.88a.65.65,0,0,0,0-.62A.61.61,0,0,0,27.3,2H23.22a1.19,1.19,0,0,0-1.08.77s-8.7,15.43-9,15.93l5.74,10.53A1.26,1.26,0,0,0,20,30h4a.59.59,0,0,0,.54-.26.62.62,0,0,0,0-.62l-5.69-10.4a0,0,0,0,1,0,0Z"
  })), children);
})));
if (false) {}
const LogoYelp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoYelp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5089,15.1845l5.0598,2.4675c.9733,.4747,.8229,1.9059-.2278,2.1679l-5.4618,1.3619c-.6813,.1699-1.3541-.3002-1.4345-.9977-.1719-1.492-.0021-2.9655,.4564-4.3296,.2227-.6625,.9797-.9764,1.6079-.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5348,25.6004l3.7659-4.1831c.7245-.8048,2.0589-.2657,2.0211,.8165l-.1964,5.6273c-.0245,.7012-.6613,1.2203-1.3532,1.1041-1.4551-.2444-2.8315-.8069-4.0331-1.6322-.5775-.3967-.6731-1.212-.2043-1.7327Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.464,20.0339l5.3529,1.7396c.6663,.2165,.9912,.9705,.6894,1.6027-.6279,1.3155-1.5387,2.4909-2.6766,3.4301-.5412,.4466-1.3521,.3154-1.724-.2796l-2.9838-4.7752c-.5738-.9184,.3123-2.0524,1.3421-1.7177Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.9076,16.619l-5.411,1.5515c-1.0409,.2984-1.8868-.8658-1.2812-1.7636l3.1481-4.6668c.3909-.5795,1.2034-.6861,1.7275-.2237,1.0791,.9521,1.9628,2.1433,2.56,3.5214,.2792,.6443-.0685,1.3877-.7434,1.5813Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.2638,3.4886c-.9739,.2609-1.903,.6058-2.7815,1.0247-.6096,.2907-.8399,1.0415-.5022,1.6264l5.2887,9.1604c.5934,1.0277,2.1643,.6067,2.1643-.5799V4.1427c0-.6754-.5749-1.2105-1.2481-1.1574-.9703,.0765-1.9474,.2424-2.9212,.5033Z"
  })), children);
})));
if (false) {}
const LogoYoutube = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LogoYoutube({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41,9.26a3.5,3.5,0,0,0-2.47-2.47C24.76,6.2,16,6.2,16,6.2s-8.76,0-10.94.59A3.5,3.5,0,0,0,2.59,9.26,36.13,36.13,0,0,0,2,16a36.13,36.13,0,0,0,.59,6.74,3.5,3.5,0,0,0,2.47,2.47C7.24,25.8,16,25.8,16,25.8s8.76,0,10.94-.59a3.5,3.5,0,0,0,2.47-2.47A36.13,36.13,0,0,0,30,16,36.13,36.13,0,0,0,29.41,9.26ZM13.2,20.2V11.8L20.47,16Z"
  })), children);
})));
if (false) {}
const Logout = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Logout({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M6,30H18a2.0023,2.0023,0,0,0,2-2V25H18v3H6V4H18V7h2V4a2.0023,2.0023,0,0,0-2-2H6A2.0023,2.0023,0,0,0,4,4V28A2.0023,2.0023,0,0,0,6,30Z"
  })), _path0 || (_path0 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M20.586 20.586 24.172 17 10 17 10 15 24.172 15 20.586 11.414 22 10 28 16 22 22 20.586 20.586z"
  })), children);
});
if (false) {}
const Loop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Loop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M23.59 19.41 26 22 21 22 21 24 26 24 23.59 26.59 25 28 30 23 25 18 23.59 19.41z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13,6A9,9,0,0,0,5.52,20l1.66-1.11A7,7,0,1,1,13,22H2v2H13A9,9,0,0,0,13,6Z"
  })), children);
})));
if (false) {}
const LoopAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LoopAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.271,10v9.9883h4.729v2.0117h-6.999v-12h2.27ZM23,25h3.7517c-1.2576,1.8159-3.3484,3-5.7517,3h-10c-3.8999,0-7-3.1001-7-7v-8h-2v8c0,5,4,9,9,9h9.9998c2.8477,0,5.3555-1.311,7.0002-3.3516v3.3516h2v-7h-7v2ZM21,2h-9.9998c-2.8477,0-5.3555,1.311-7.0002,3.3516v-3.3516h-2v7h7v-2h-3.7517c1.2576-1.8159,3.3484-3,5.7517-3h10c3.8999,0,7,3.1001,7,7v8h2v-8c0-5-4-9-9-9Z"
  })), children);
})));
if (false) {}
const LowSeverity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function LowSeverity({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === "glyph" || size === "glyph" || size === "glyphpx") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
      d: "M4 4H12V12H4z"
    })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
      d: "M12,4v8H4V4h8m1-1H3V13H13V3Z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 4H12V12H4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4v8H4V4h8m1-1H3V13H13V3Z"
  })), children);
})));
if (false) {}
const Mac = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mac({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,23h-6c-1.103,0-2-.8975-2-2v-10c0-1.103.897-2,2-2h6v2h-6v10h6v2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m18,9h-4c-1.103,0-2,.897-2,2v12h2v-5h4v5h2v-12c0-1.103-.897-2-2-2Zm-4,7v-5h4v5h-4Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M8 9 6.4849 14 6 15.977 5.535 14 4 9 2 9 2 23 4 23 4 15 3.8415 13.0039 4.4212 15 6 19.6263 7.5788 15 8.1588 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
})));
if (false) {}
const MacCommand = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MacCommand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24,13a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4H23a4,4,0,0,0-4,4v3H13V8A4,4,0,0,0,9,4H8A4,4,0,0,0,4,8V9a4,4,0,0,0,4,4h3v6H8a4,4,0,0,0-4,4v1a4,4,0,0,0,4,4H9a4,4,0,0,0,4-4V21h6v3a4,4,0,0,0,4,4h1a4,4,0,0,0,4-4V23a4,4,0,0,0-4-4H21V13ZM21,8a2,2,0,0,1,2-2h1a2,2,0,0,1,2,2V9a2,2,0,0,1-2,2H21ZM8,11A2,2,0,0,1,6,9V8A2,2,0,0,1,8,6H9a2,2,0,0,1,2,2v3H8Zm3,13a2,2,0,0,1-2,2H8a2,2,0,0,1-2-2V23a2,2,0,0,1,2-2h3Zm8-5H13V13h6Zm2,2h3a2,2,0,0,1,2,2v1a2,2,0,0,1-2,2H23a2,2,0,0,1-2-2Z"
  })), children);
})));
if (false) {}
const MacOption = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MacOption({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H28V7H18z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6 5 4 5 4 7 9.4 7 18.4 27 28 27 28 25 19.6 25z"
  })), children);
})));
if (false) {}
const MacShift = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MacShift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21,28H11a2.0023,2.0023,0,0,1-2-2V16H4a1,1,0,0,1-.707-1.707l12-12a.9994.9994,0,0,1,1.414,0l12,12A1,1,0,0,1,28,16H23V26A2.0027,2.0027,0,0,1,21,28ZM6.4141,14H11V26H21V14h4.5859L16,4.4141Z"
  })), children);
})));
if (false) {}
const MachineLearning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MachineLearning({
  children,
  size = 16,
  ...rest
}, ref) {
  if (false) {}
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,16,25Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,20,14Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,12,14Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16V14H28V10a4.0045,4.0045,0,0,0-4-4H22V2H20V6H12V2H10V6H8a4.0045,4.0045,0,0,0-4,4v4H2v2H4v5H2v2H4v3a4.0045,4.0045,0,0,0,4,4H24a4.0045,4.0045,0,0,0,4-4V23h2V21H28V16ZM26,26a2.0023,2.0023,0,0,1-2,2H8a2.0023,2.0023,0,0,1-2-2V10A2.0023,2.0023,0,0,1,8,8H24a2.0023,2.0023,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const MachineLearningModel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MachineLearningModel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8384-2.8157,2h-5.7703l7.3008-7.3008c.3911.1875.8235.3008,1.2852.3008,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.4619.1135.894.3005,1.2852l-8.3005,8.3008v-6.5859c0-1.1025.897-2,2-2h2v-2h-2c-1.2002,0-2.2661.5425-3,1.3823-.7339-.8398-1.7998-1.3823-3-1.3823h-1c-4.9624,0-9,4.0371-9,9v6c0,4.9629,4.0376,9,9,9h1c1.2002,0,2.2661-.5425,3-1.3823.7339.8398,1.7998,1.3823,3,1.3823h2v-2h-2c-1.103,0-2-.8975-2-2v-6.5859l8.3005,8.3008c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3c-.4617,0-.894.1133-1.2852.3008l-7.3008-7.3008h5.7703c.4141,1.1616,1.5137,2,2.8157,2Zm0-4c.5513,0,1,.4482,1,1s-.4487,1-1,1-1-.4482-1-1,.4487-1,1-1Zm0-11c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm-13,8h-2v2h2v4h-2c-1.6543,0-3,1.3457-3,3v2h2v-2c0-.5518.4487-1,1-1h2v4c0,1.1025-.897,2-2,2h-1c-3.5195,0-6.4324-2.6133-6.9202-6h1.9202v-2h-2v-4h3c1.6543,0,3-1.3457,3-3v-2h-2v2c0,.5518-.4487,1-1,1h-2.9202c.4878-3.3867,3.4006-6,6.9202-6h1c1.103,0,2,.8975,2,2v4Zm14,15c0,.5513-.4485,1-1,1s-1-.4487-1-1,.4485-1,1-1,1,.4487,1,1Z"
  })), children);
})));
if (false) {}
const MagicWand = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MagicWand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5ZM25.4131,28l-11-10.999L17,14.4141l11,11Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 14.586H5.414V17.414H2.586z",
    transform: "rotate(-45 4 16)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M14.586 2.586H17.414V5.414H14.586z",
    transform: "rotate(-45 16 4)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 2.586H5.414V5.414H2.586z",
    transform: "rotate(-45 4 4)"
  })), children);
})));
if (false) {}
const MagicWandFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MagicWandFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141,24,12,6.5859a2.0476,2.0476,0,0,0-2.8281,0l-2.586,2.586a2.0021,2.0021,0,0,0,0,2.8281L23.999,29.4141a2.0024,2.0024,0,0,0,2.8281,0l2.587-2.5865a1.9993,1.9993,0,0,0,0-2.8281ZM8,10.5859,10.5859,8l5,5-2.5866,2.5869-5-5Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 14.586H5.414V17.414H2.586z",
    transform: "rotate(-45 4 16)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14.586 2.586H17.414V5.414H14.586z",
    transform: "rotate(-45 16 4)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M2.586 2.586H5.414V5.414H2.586z",
    transform: "rotate(-45 4 4)"
  })), children);
})));
if (false) {}
const WatsonHealthMagnify = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthMagnify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12,21H4V4H22v8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V21a2,2,0,0,0,2,2h8Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28.58l-3.11-3.11a6,6,0,1,0-1.42,1.42L28.58,30ZM22,26a4,4,0,1,1,4-4A4,4,0,0,1,22,26Z"
  })), children);
})));
if (false) {}
const MailAll = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MailAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M16.59 20.41 20.17 24 20.17 24 16.58 27.59 18 29 23 24 18 19 16.59 20.41z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M23.59 20.41 27.17 24 27.17 24 23.58 27.59 25 29 30 24 25 19 23.59 20.41z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H4V7.91l11.43,7.91a1,1,0,0,0,1.14,0L28,7.91V17h2V7a2,2,0,0,0-2-2H4A2,2,0,0,0,2,7V23a2,2,0,0,0,2,2H14ZM25.8,7,16,13.78,6.2,7Z"
  })), children);
})));
if (false) {}
const MailReply = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MailReply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M25,18l-1.4141,1.4141L26.1672,22H18a4,4,0,0,0,0,8h2V28H18a2,2,0,0,1,0-4h8.1672l-2.5827,2.5874L25,28l5-5Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10,22H4L3.9966,6.9064l11.4341,7.9159a1.0008,1.0008,0,0,0,1.1386,0L28,6.9086,28,16h2V6a2.0025,2.0025,0,0,0-2-2H4A2,2,0,0,0,2,5.9965V22a2.0026,2.0026,0,0,0,2,2h6ZM25.7986,6,16,12.7837,6.2014,6Z"
  })), children);
})));
if (false) {}
const WatsonHealthMammogram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthMammogram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32 32 32 32 25 30 25 30 30 25 30 25 32z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M25,27H22V17h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,27Zm-1-2h1a1.0006,1.0006,0,0,0,1-1V20a1.0006,1.0006,0,0,0-1-1H24Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H14V23a2.002,2.002,0,0,1,2-2h2V19H14V17h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H16v2h4Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15H22V5h3a3.0033,3.0033,0,0,1,3,3v4A3.0033,3.0033,0,0,1,25,15Zm-1-2h1a1.0009,1.0009,0,0,0,1-1V8a1.0009,1.0009,0,0,0-1-1H24Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M18,5H14V7h4V9H15v2h3v2H14v2h4a2.0027,2.0027,0,0,0,2-2V7A2.0023,2.0023,0,0,0,18,5Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10,27H8V23.9541C3.2847,23.5117,2,19.9443,2,18c0-3.0146,2.082-4.5015,3.9189-5.814C7.5723,11.0054,9,9.9854,9,8V5h2V8c0,3.0146-2.082,4.5015-3.9189,5.814C5.4277,14.9946,4,16.0146,4,18c.0054.4033.1914,4,5,4a1,1,0,0,1,1,1Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M7 0 0 0 0 7 2 7 2 2 7 2 7 0z"
  })), children);
})));
if (false) {}
const ManageProtection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ManageProtection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M16,25.277V6h8V16.8048a7,7,0,0,1-3.7,6.1731Z"
  })), children);
})));
if (false) {}
const ManagedSolutions = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ManagedSolutions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30 23 25 23 25 18 23 18 23 23 18 23 18 25 23 25 23 30 25 30 25 25 30 25 30 23z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1273,11.8394l1.1807.2136a5.7919,5.7919,0,0,1,2.6247,1.1445A5.4219,5.4219,0,0,1,29.9532,18h2.0293a7.5022,7.5022,0,0,0-6.15-7.8848,10.0067,10.0067,0,0,0-7.9387-7.9336,10.0025,10.0025,0,0,0-11.72,7.9336A7.5055,7.5055,0,0,0,.0576,18.4088,7.6841,7.6841,0,0,0,7.7725,25H14V23H7.6978a5.6323,5.6323,0,0,1-5.6024-4.4859,5.5064,5.5064,0,0,1,4.4338-6.4306l1.3488-.2441.2138-1.11a8.2061,8.2061,0,0,1,6.7427-6.6426,7.9714,7.9714,0,0,1,3.0138.13,8.1442,8.1442,0,0,1,6.0526,6.4464Z"
  })), children);
})));
if (false) {}
const Map = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Map({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24l-6.09-8.6A8.14,8.14,0,0,1,16,2a8.08,8.08,0,0,1,8,8.13,8.2,8.2,0,0,1-1.8,5.13ZM16,4a6.07,6.07,0,0,0-6,6.13,6.19,6.19,0,0,0,1.49,4L16,20.52,20.63,14A6.24,6.24,0,0,0,22,10.13,6.07,6.07,0,0,0,16,4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "9",
    r: "2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H26v2h2V28H4V14H6V12H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V14A2,2,0,0,0,28,12Z"
  })), children);
})));
if (false) {}
const MapCenter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MapCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23 26H25V30H23z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18H25V22H23z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M26 23H30V25H26z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23H22V25H18z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3418,10.06l-22-8A1,1,0,0,0,2.06,3.3415l8,22A1.0011,1.0011,0,0,0,10.9839,26H11a1,1,0,0,0,.9287-.6289L15.77,15.7692l9.6015-3.8408a1,1,0,0,0-.0293-1.8687ZM14.6284,14.0709v0l-.3979.1591-.1591.3979,0,0-3.0268,7.5678L4.6719,4.6715l17.5244,6.3726Z"
  })), children);
})));
if (false) {}
const MapIdentify = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MapIdentify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8H17V14H15z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V24H15z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15H24V17H18z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H14V17H8z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M4,10H2V4A2.0021,2.0021,0,0,1,4,2h6V4H4Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M10,30H4a2.0021,2.0021,0,0,1-2-2V22H4v6h6Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H22V28h6V22h2v6A2.0021,2.0021,0,0,1,28,30Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10H28V4H22V2h6a2.0021,2.0021,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const MapBoundary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MapBoundary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V14H12z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18 14 16 12 16 12 20 16 20 16 18 14 18z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H28V16H16z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 29.997 11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.773 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 29.997z"
  })), children);
})));
if (false) {}
const MapBoundaryVegetation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MapBoundaryVegetation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28,16H18V14h5V10a2,2,0,0,1,2-2h1.5a1.5,1.5,0,0,0,.2837-2.9734l-.7109-.1355L25.9982,4.32a2.6322,2.6322,0,0,0-1.68-2.1823,2.5051,2.5051,0,0,0-3.0836,1.3042l-.3032.6472-.71-.0771a2.0185,2.0185,0,0,0-2.17,2.4343A2.0976,2.0976,0,0,0,20.1261,8H21v2h-.7817A4.1491,4.1491,0,0,1,16.012,6.3136a4.0047,4.0047,0,0,1,3.7414-4.306A4.5006,4.5006,0,0,1,27.8267,3.26a3.5051,3.5051,0,0,1,2.1422,3.7094A3.6283,3.6283,0,0,1,26.3172,10H25v4h3Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V20H18z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18 14 16 12 16 12 20 16 20 16 18 14 18z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H14V14H12z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17.885 30 11.819 26.142 4 27.989 4 4 14 4 14 8 12 8 12 6 6 6 6 25.461 12.181 24.001 18.115 27.776 22.818 26 26 26 26 20 24 20 24 18 28 18 28 28 23.182 28 17.885 30z"
  })), children);
})));
if (false) {}
const Marginal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Marginal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M10.56,23l-1.56-1.56,12.44-12.44,1.56,1.56s-12.44,12.44-12.44,12.44Z"
  })), children);
})));
if (false) {}
const MarineWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MarineWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M12,20H7a1,1,0,0,0-.97,1.2422L6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H14V3a1,1,0,0,0-1.7993-.6011L2.2075,15.3906A1,1,0,0,0,3,17h9ZM5.0308,15,12,5.94V15Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
})));
if (false) {}
const MaterialRequest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MaterialRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M30,19.1024c0,.8322-.3242,1.6136-.9141,2.2006l-7.2773,7.2504c-.9365.9328-2.1807,1.4466-3.5029,1.4466h-7.3057v-2l7.3057-.0004c.7891,0,1.5322-.3067,2.0908-.8644l7.2783-7.2504c.21-.2081.3252-.4865.3252-.7824.001-.296-.1152-.5743-.3252-.7833-.4277-.4279-1.127-.4279-1.5547,0l-5.8818,5.8595c-.5176.5138-1.3535.8205-2.2383.8205h-.9923c-.0033,0-.0063.001-.0096.001h-3.9981s-.0019-2-.0019-2h.002,0s4.0048-.0013,4.0048-.0013c.5484-.0038.9933-.4493.9933-.9987,0-.5518-.4482-1.0001-1-1.0001h-7c-1.6543,0-3,1.3457-3,3v1.3341l-3.3984,4.5254-1.5997-1.2012,2.9981-3.9922v-.6661c0-2.7568,2.2432-4.9999,5-4.9999h7c1.528,0,2.7784,1.1522,2.9627,2.631l4.7473-4.7292c1.207-1.2023,3.1719-1.2023,4.3789,0,.5889.587.9141,1.3685.9131,2.2006h0ZM29.8673,10.4804c-.1787.3105-.5088.502-.8672.502h-7c-.3584,0-.6885-.1914-.8672-.502s-.1768-.6924.0029-1.002l3.5-6c.3594-.6143,1.3691-.6143,1.7285,0l3.5,6c.1797.3096.1816.6914.0029,1.002h.0001ZM27.2589,8.9824l-1.7588-3.0151-1.7588,3.0151h3.5176ZM9,2v7H2V2h7ZM7,4h-3v3h3v-3ZM19,13c0,2.2061-1.7939,4-4,4s-4-1.7939-4-4,1.7939-4,4-4,4,1.7939,4,4ZM17,13c0-1.1025-.8975-2-2-2s-2,.8975-2,2,.8975,2,2,2,2-.8975,2-2Z"
  })), children);
})));
if (false) {}
const MathCurve = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MathCurve({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3555,23.0581C12.77,24.5918,15.6208,26,17.9514,26a3.8729,3.8729,0,0,0,2.856-1.084c2.2859-2.29.14-6.3979-1.938-10.3721L24.67,8.7427c1.07.686,2.1038,1.4253,3.0117,2.124L29,9.3486c-.7783-.6064-1.772-1.3383-2.8721-2.0634L30,3.4131,28.5859,2,24.3794,6.2061c-3.3164-1.91-7.1079-3.2461-9.2288-1.1216-2.0388,2.0425-.5512,5.5317,1.2683,9.082l-6.3071,6.3066c-1.0322-.7133-1.9985-1.4448-2.8-2.101L6,19.8848c.6145.5058,1.5513,1.2451,2.6653,2.0351L4,26.585V2H2V28a2,2,0,0,0,2,2H30V28H5.4133ZM16.5647,6.501c1.1357-1.1377,3.6931-.2862,6.3372,1.1831l-4.9947,4.9941C16.5942,10.0591,15.5562,7.5112,16.5647,6.501Zm.8215,9.5259c1.58,3.0317,3.1822,6.2959,2.0071,7.4726-1.3125,1.3145-4.5227-.0254-7.572-1.9077Z"
  })), children);
})));
if (false) {}
const QMatrix = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QMatrix({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13 18 4 16 4 16 6 13 6 13 8 16 8 16 13 13 13 13 15 21 15 21 13 18 13z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,20A3.5,3.5,0,1,1,13,23.5,3.5,3.5,0,0,1,16.5,20m0-2A5.5,5.5,0,1,0,22,23.5,5.5,5.5,0,0,0,16.5,18Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M8 30 2 30 2 2 8 2 8 4 4 4 4 28 8 28 8 30z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M30 30 24 30 24 28 28 28 28 4 24 4 24 2 30 2 30 30z"
  })), children);
})));
if (false) {}
const Maximize = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Maximize({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
      d: "M6 15 6 14 2.7 14 7 9.7 6.3 9 2 13.3 2 10 1 10 1 15z"
    })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
      d: "M10 1 10 2 13.3 2 9 6.3 9.7 7 14 2.7 14 6 15 6 15 1z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2 20 4 26.586 4 18 12.582 19.414 14 28 5.414 28 12 30 12 30 2 20 2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.416 12.592 18 4 26.586 4 20 2 20 2 30 12 30 12 28 5.414 28 14 19.416z"
  })), children);
})));
if (false) {}
const MediaLibrary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MediaLibrary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15 13 23 13 23 20 19 13 15z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H6a2.0021,2.0021,0,0,1-2-2V12a2.0021,2.0021,0,0,1,2-2H26a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28ZM6,12V26H26V12Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H24V4H8z"
  })), children);
})));
if (false) {}
const MediaLibraryFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MediaLibraryFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M13 15 13 23 13 23 20 19 13 15z",
    "data-icon-path": "inner-path"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M26,10H6a2.0023,2.0023,0,0,0-2,2V26a2.0023,2.0023,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V12A2.0023,2.0023,0,0,0,26,10ZM13,23h0V15l7,4Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H24V4H8z"
  })), children);
})));
if (false) {}
const MediaCast = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MediaCast({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M2,26H5a3,3,0,0,0-3-3Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M9,26H7a5.0057,5.0057,0,0,0-5-5V19A7.0078,7.0078,0,0,1,9,26Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M13,26H11a9.01,9.01,0,0,0-9-9V15A11.0125,11.0125,0,0,1,13,26Z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H15V24H28V8H4v5H2V8A2.0021,2.0021,0,0,1,4,6H28a2.0021,2.0021,0,0,1,2,2V24A2.0021,2.0021,0,0,1,28,26Z"
  })), children);
})));
if (false) {}
const Medication = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Medication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M24,2H8A2,2,0,0,0,6,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,24,2ZM10,14h3V24H10ZM22,28H10V26h5V12H10V10H22ZM8,8V4H24V8Z"
  })), children);
})));
if (false) {}
const MedicationAlert = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MedicationAlert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19H24V24H22z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M23,31a8,8,0,1,1,8-8A8,8,0,0,1,23,31Zm0-14a6,6,0,1,0,6,6A6,6,0,0,0,23,17Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "26",
    r: "1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2h8V28H6V26h5V12H6V10H18v3h2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM9,14V24H6V14ZM4,8V4H20V8Z"
  })), children);
})));
if (false) {}
const MedicationReminder = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MedicationReminder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2H4A2,2,0,0,0,2,4V8a2,2,0,0,0,2,2V28a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2V10a2,2,0,0,0,2-2V4A2,2,0,0,0,20,2ZM6,14H9V24H6ZM18,28H6V26h5V12H6V10H18ZM4,8V4H20V8Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), children);
})));
if (false) {}
const Menu = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Menu({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
      d: "M2 12H14V13H2z"
    })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
      d: "M2 9H14V10H2z"
    })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
      d: "M2 6H14V7H2z"
    })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
      d: "M2 3H14V4H2z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
      d: "M2 14.8H18V16H2z"
    })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
      d: "M2 11.2H18V12.399999999999999H2z"
    })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
      d: "M2 7.6H18V8.799999999999999H2z"
    })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
      d: "M2 4H18V5.2H2z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
      d: "M3 18H21V19.5H3z"
    })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
      d: "M3 13.5H21V15H3z"
    })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
      d: "M3 9H21V10.5H3z"
    })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
      d: "M3 4.5H21V6H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H28V8H4z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H28V26H4z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M4 12H28V14H4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18H28V20H4z"
  })), children);
})));
if (false) {}
const Merge = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Merge({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,13c-1.8584,0-3.4106,1.2798-3.8579,3h-6.1421c-2.7571,0-5-2.2432-5-5v-1.1421c1.7202-.4473,3-1.9995,3-3.8579,0-2.2056-1.7944-4-4-4s-4,1.7944-4,4c0,1.8584,1.2798,3.4106,3,3.8579v12.2842c-1.7202.4468-3,1.9995-3,3.8579,0,2.2061,1.7944,4,4,4s4-1.7939,4-4c0-1.8584-1.2798-3.4111-3-3.8579v-6.2524c1.2717,1.3003,3.042,2.1104,5,2.1104h6.1421c.4473,1.7202,1.9995,3,3.8579,3,2.2056,0,4-1.7944,4-4s-1.7944-4-4-4Zm-14,13c0,1.1025-.897,2-2,2s-2-.8975-2-2,.897-2,2-2,2,.8975,2,2ZM6,6c0-1.103.897-2,2-2s2,.897,2,2-.897,2-2,2-2-.897-2-2Zm18,13c-1.1028,0-2-.8975-2-2s.8972-2,2-2,2,.8975,2,2-.8972,2-2,2Z"
  })), children);
})));
if (false) {}
const MergeNode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MergeNode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,20h-4l-8-8-8,8h-4c-1.1028,0-2,.8975-2,2v8h2v-8h4l8,8,8-8h4v8h2v-8c0-1.1025-.8972-2-2-2Zm-12,7.1714l-6.1714-6.1714,6.1714-6.1716,6.1714,6.1716-6.1714,6.1714Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M11 7 16 12 21 7 19.5859 5.5859 17 8.1719 17 2 15 2 15 8.1719 12.4141 5.5859 11 7z"
  })), children);
})));
if (false) {}
const MessageQueue = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MessageQueue({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V21H4v5H28V21h2v5A2.0021,2.0021,0,0,1,28,28Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21H25V23H7z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16H25V18H7z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11H25V13H7z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6H25V8H7z"
  })), children);
})));
if (false) {}
const Meter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Meter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16a9.9283,9.9283,0,0,0-1.1392-4.6182l-1.4961,1.4961A7.9483,7.9483,0,0,1,24,16Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,10,22,8.5859l-4.7147,4.7147A2.9659,2.9659,0,0,0,16,13a3,3,0,1,0,3,3,2.9659,2.9659,0,0,0-.3006-1.2853ZM16,17a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,16,17Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a7.9515,7.9515,0,0,1,3.1223.6353l1.4961-1.4961A9.9864,9.9864,0,0,0,6,16H8A8.0092,8.0092,0,0,1,16,8Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const MeterAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MeterAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20a13.8535,13.8535,0,0,0-2.2291-7.5288l-1.4452,1.4453A11.8917,11.8917,0,0,1,28,20Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9.414,26.5859,8,18.019,16.5669A3.9521,3.9521,0,0,0,16,16a4,4,0,1,0,4,4,3.9533,3.9533,0,0,0-.5669-2.0191ZM16,22a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,16,22Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a11.9086,11.9086,0,0,1,6.0833,1.6743l1.4536-1.4536A13.9773,13.9773,0,0,0,2,20H4A12.0137,12.0137,0,0,1,16,8Z"
  })), children);
})));
if (false) {}
const Microphone = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Microphone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22ZM13,7a3,3,0,0,1,6,0V17a3,3,0,0,1-6,0Z"
  })), children);
})));
if (false) {}
const MicrophoneFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MicrophoneFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M23,14v3A7,7,0,0,1,9,17V14H7v3a9,9,0,0,0,8,8.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a5,5,0,0,0,5-5V7A5,5,0,0,0,11,7V17A5,5,0,0,0,16,22Z"
  })), children);
})));
if (false) {}
const MicrophoneOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MicrophoneOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18,18.57A7.41,7.41,0,0,1,9,17V14H7v3a8.84,8.84,0,0,0,.58,3.18Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M13,15V7a3,3,0,0,1,6,0V8.75l2-2A5,5,0,0,0,11,7v8Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Zm-4,0a3,3,0,0,1-4.9,2.31L19,14.42Z"
  })), children);
})));
if (false) {}
const MicrophoneOffFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MicrophoneOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17a7,7,0,0,1-11.73,5.14l1.42-1.41A5,5,0,0,0,21,17V12.42l9-9L28.59,2,2,28.59,3.41,30l6.44-6.44A8.91,8.91,0,0,0,15,25.94V28H11v2H21V28H17V25.94A9,9,0,0,0,25,17V14H23Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M9,17.32c0-.11,0-.21,0-.32V14H7v3a9,9,0,0,0,.25,2.09Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M20.76,5.58A5,5,0,0,0,11,7v8.34Z"
  })), children);
})));
if (false) {}
const Microscope = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Microscope({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3943,24a7.8772,7.8772,0,0,0-1.6707-8.5684,3.918,3.918,0,0,0-1.0844-4.414l2.7759-2.7759a2.0025,2.0025,0,0,0,0-2.8286L22.5869,2.5849a2.0021,2.0021,0,0,0-2.8286,0L6.5859,15.7573a2.0027,2.0027,0,0,0,0,2.8286l2.8282,2.8282a2.0024,2.0024,0,0,0,2.8286,0l4.7749-4.7754a3.9329,3.9329,0,0,0,5.5139.4326A5.9442,5.9442,0,0,1,23.1775,24H16v4H4v2H28V24ZM10.8281,20,8,17.1714,9.8787,15.293l2.8283,2.8281ZM16,14a3.9811,3.9811,0,0,0,.0762.7524L14.1211,16.707l-2.8284-2.8281,9.88-9.88L24.001,6.8271l-3.2488,3.2491A3.9771,3.9771,0,0,0,16,14Zm4,2a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,20,16Zm6,12H18V26h8Z"
  })), children);
})));
if (false) {}
const Microservices_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Microservices_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m11 21-4-2.2v-4.5l4-2.2 4 2.2v4.5L11 21zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM6 30l-4-2.2v-4.5L6 21l4 2.2v4.5L6 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM16 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L16 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM26 30l-4-2.2v-4.5l4-2.2 4 2.2v4.5L26 30zm-2-3.4 2 1.1 2-1.1v-2.2l-2-1.1-2 1.1v2.2zM24.6 11.6 22 14.2V9.4l3-1.7V3.2L21 1l-4 2.2v4.5l3 1.7v4.7l-2.6-2.6L16 13l5 5 5-5-1.4-1.4zM19 4.4l2-1.1 2 1.1v2.2l-2 1.1-2-1.1V4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
})));
if (false) {}
const Microservices_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Microservices_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch2 || (_switch2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16 22v-6h-6v-6H2v20h20v-8h-6zm-2-4v4h-4v-4h4zM4 12h4v4H4v-4zm4 6v4H4v-4h4zM4 28v-4h4v4H4zm10 0h-4v-4h4v4zm6 0h-4v-4h4v4zM29.6 13.6 27 16.2V10h3V2h-8v8h3v6.2l-2.6-2.6L21 15l5 5 5-5-1.4-1.4zM24 4h4v4h-4V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })))), children);
})));
if (false) {}
const Migrate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Migrate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V8a2,2,0,0,0,2,2h9v6.17l-2.59-2.58L11,15l5,5,5-5-1.41-1.41L17,16.17V10h9a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2ZM6,4h4V8H6ZM26,8H12V4H26Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M26,22H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V24A2,2,0,0,0,26,22ZM6,24H20v4H6Zm20,4H22V24h4Z"
  })), children);
})));
if (false) {}
const MigrateAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MigrateAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M28,4H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V6A2,2,0,0,0,28,4Zm0,22H12V20H10v6H4V17H20.1719l-3.586,3.5859L18,22l6-6-6-6-1.4141,1.4141L20.1719,15H4V6h6v6h2V6H28Z"
  })), children);
})));
if (false) {}
const Milestone = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Milestone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5857,6.5859A1.9865,1.9865,0,0,0,23.1714,6H16V2H14V6H6A2.0025,2.0025,0,0,0,4,8v6a2.0025,2.0025,0,0,0,2,2h8V30h2V16h7.1714a1.9865,1.9865,0,0,0,1.4143-.5859L29,11ZM23.1714,14H6V8H23.1716l3,3Z"
  })), children);
})));
if (false) {}
const MilitaryCamp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MilitaryCamp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M27,28v-10.48a2.0035,2.0035,0,0,0-.853-1.6387L17,9.48V8h6V2H15V9.48L5.8528,15.8823A2.0023,2.0023,0,0,0,5,17.5205V28H2v2H30V28ZM17,4h4V6H17ZM7,17.5205l9-6.3,9,6.3V28H17V20H15v8H7Z"
  })), children);
})));
if (false) {}
const MinimapOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MinimapOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,4.6c-.4-.4-.9-.6-1.4-.6H4c-.5,0-1,.2-1.4.6s-.6.9-.6,1.4v20c0,.5.2,1,.6,1.4s.9.6,1.4.6h5v-2h-5V6h24v6h2v-6c0-.5-.2-1-.6-1.4ZM28,15h-14c-1.1,0-2,.9-2,2v9c0,1.1.9,2,2,2h14c1.1,0,2-.9,2-2v-9c0-1.1-.9-2-2-2ZM28,26h-14v-9h14v9Z"
  })), children);
})));
if (false) {}
const MinimapOn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MinimapOn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4,4.6c-.4-.4-.9-.6-1.4-.6H4c-.5,0-1,.2-1.4.6s-.6.9-.6,1.4v20c0,.5.2,1,.6,1.4s.9.6,1.4.6h5v-2h-5V6h24v6h2v-6c0-.5-.2-1-.6-1.4ZM14,15h14c1.1046,0,2,.8954,2,2v9c0,1.1046-.8954,2-2,2h-14c-1.1046,0-2-.8954-2-2v-9c0-1.1046.8954-2,2-2Z"
  })), children);
})));
if (false) {}
const Minimize = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Minimize({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
      d: "M2 9 2 10 5.3 10 1 14.3 1.7 15 6 10.7 6 14 7 14 7 9z"
    })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
      d: "M14 7 14 6 10.7 6 15 1.7 14.3 1 10 5.3 10 2 9 2 9 7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18 4 20 10.586 20 2 28.582 3.414 30 12 21.414 12 28 14 28 14 18 4 18z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.416 28.592 2 20 10.586 20 4 18 4 18 14 28 14 28 12 21.414 12 30 3.416z"
  })), children);
})));
if (false) {}
const Misuse = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Misuse({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2 l2.7-2.7l0.8,0.8L8.8,8l2.7,2.7L10.7,11.5z"
    })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7,11.5L8,8.8l-2.7,2.7l-0.8-0.8L7.2,8L4.5,5.3l0.8-0.8L8,7.2l2.7-2.7l0.8,0.8L8.8,8 l2.7,2.7L10.7,11.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
      d: "M10,1c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4,9-9S15,1,10,1z M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1 L11,10l3.5,3.5L13.5,14.5z"
    })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M13.5,14.5L10,11l-3.5,3.5l-1-1L9,10L5.5,6.5l1-1L10,9l3.5-3.5l1,1L11,10l3.5,3.5L13.5,14.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
      d: "M12,1C6,1,1,6,1,12s5,11,11,11s11-4.9,11-11S18.1,1,12,1z M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3 l4.2,4.2l4.2-4.2l1.3,1.3L13.3,12l4.2,4.2L16.2,17.5z"
    })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
      fill: "none",
      d: "M16.2,17.5L12,13.3l-4.2,4.2l-1.3-1.3l4.2-4.2L6.5,7.8l1.3-1.3l4.2,4.2l4.2-4.2l1.3,1.3 L13.3,12l4.2,4.2L16.2,17.5z",
      "data-icon-path": "inner-path",
      opacity: "0"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9 l5.4,5.4L21.4,9l1.6,1.6L17.6,16l5.4,5.4L21.4,23z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M21.4,23L16,17.6L10.6,23L9,21.4l5.4-5.4L9,10.6L10.6,9l5.4,5.4L21.4,9l1.6,1.6L17.6,16 l5.4,5.4L21.4,23z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
})));
if (false) {}
const MisuseOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MisuseOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M8,14c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S11.3,14,8,14z"
    })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
      d: "M10.7 11.5 8 8.8 5.3 11.5 4.5 10.7 7.2 8 4.5 5.3 5.3 4.5 8 7.2 10.7 4.5 11.5 5.3 8.8 8 11.5 10.7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.2,2,2,8.2,2,16s6.2,14,14,14s14-6.2,14-14S23.8,2,16,2z M16,28C9.4,28,4,22.6,4,16S9.4,4,16,4s12,5.4,12,12 S22.6,28,16,28z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4 23 16 17.6 10.6 23 9 21.4 14.4 16 9 10.6 10.6 9 16 14.4 21.4 9 23 10.6 17.6 16 23 21.4z"
  })), children);
})));
if (false) {}
const MixedRainHail = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MixedRainHail({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "25.5",
    r: "1.5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "29.5",
    r: "1.5"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M15.868 30.496 14.132 29.504 17.276 24 11.277 24 16.132 15.504 17.868 16.496 14.723 22 20.724 22 15.868 30.496z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), children);
})));
if (false) {}
const MlModelReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MlModelReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 19 4 21 8.5859 21 2 27.5859 3.4141 29 10 22.4141 10 27 12 27 12 19 4 19z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8384-2.8157,2h-5.7703l7.3008-7.3008c.3911.1875.8235.3008,1.2852.3008,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3-3,1.3457-3,3c0,.4619.1135.894.3005,1.2852l-8.3005,8.3008v-6.5859c0-1.1025.897-2,2-2h2v-2h-2c-1.2002,0-2.2661.5425-3,1.3823-.7339-.8398-1.7998-1.3823-3-1.3823h-1c-4.9624,0-9,4.0371-9,9v4h2v-3h3c1.6543,0,3-1.3457,3-3v-2h-2v2c0,.5518-.4487,1-1,1h-2.9202c.4878-3.3867,3.4006-6,6.9202-6h1c1.103,0,2,.8975,2,2v4h-2v2h2v10c0,2.2056,1.7944,4,4,4h2v-2h-2c-1.1028,0-2-.8975-2-2v-6.5859l8.3005,8.3008c-.187.3911-.3005.8232-.3005,1.2852,0,1.6543,1.3457,3,3,3s3-1.3457,3-3-1.3457-3-3-3c-.4617,0-.894.1133-1.2852.3008l-7.3008-7.3008h5.7703c.4141,1.1616,1.5137,2,2.8157,2Zm0-4c.5513,0,1,.4482,1,1s-.4487,1-1,1-1-.4482-1-1,.4487-1,1-1Zm0-11c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm0,22c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Z"
  })), children);
})));
if (false) {}
const Mobile = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mobile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2H22a2.0027,2.0027,0,0,0,2-2V6A2.0023,2.0023,0,0,0,22,4Zm0,2,0,2H10V6ZM10,28V10H22l0,18Z"
  })), children);
})));
if (false) {}
const MobileAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28 24 24 24 24 20 22 20 22 24 18 24 18 26 22 26 22 30 24 30 24 26 28 26 28 24z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v7h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6l0-2ZM10,6H22l0,2H10Z"
  })), children);
})));
if (false) {}
const MobileAudio = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileAudio({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H30V15H28z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7H26V20H24z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H22V16H20z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9H18V18H16z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14V15H12z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "13.5",
    cy: "24.5",
    r: "1.5"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M20,30H7a2.0023,2.0023,0,0,1-2-2V4A2.0023,2.0023,0,0,1,7,2H20V4H7V28H20V24h2v4A2.0023,2.0023,0,0,1,20,30Z"
  })), children);
})));
if (false) {}
const MobileCheck = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileCheck({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.18 17.41 24.59 16 26 20 30 28 22 26.59 20.59 20 27.18z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v9h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h4V28ZM10,6H22l0,2H10Z"
  })), children);
})));
if (false) {}
const MobileCrash = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileCrash({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M30 20 26 16 24.5859 17.4141 27.1714 20 24.1714 23 27.1714 26 24.5859 28.5859 26 30 30 26 27 23 30 20z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M23 20 19 16 17.5859 17.4141 20.1714 20 17.1714 23 20.1714 26 17.5859 28.5859 19 30 23 26 20 23 23 20z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m15,28h-6V8h14v6h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM9,4h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const MobileDownload = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileDownload({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25 26.586 23.586 24 26.172 24 18 22 18 22 26.172 19.414 23.586 18 25 23 30 28 25z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28V10H22v5h2V6a2.0023,2.0023,0,0,0-2-2H10A2.002,2.002,0,0,0,8,6V28a2.0023,2.0023,0,0,0,2,2h6V28ZM10,6H22l0,2H10Z"
  })), children);
})));
if (false) {}
const MobileEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileEvent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m27.3803,28h-6.7625l3.3822-6.7642,3.3803,6.7642Zm-3.3803-10c-.3915,0-.7305.2251-.8947.5527l-5,10c-.0674.1348-.1053.2866-.1053.4473,0,.5522.4477,1,1,1h10c.5523,0,1-.4478,1-1,0-.1382-.028-.2695-.0786-.3892l-5.0269-10.0581c-.1641-.3276-.5031-.5527-.8946-.5527h0Z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "m15,28h-6V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM9,4h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const MobileLandscape = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileLandscape({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M3,10V22a2.002,2.002,0,0,0,2,2H27a2.0023,2.0023,0,0,0,2-2V10a2.0027,2.0027,0,0,0-2-2H5A2.0023,2.0023,0,0,0,3,10Zm2,0,2,0V22H5ZM27,22H9V10H27Z"
  })), children);
})));
if (false) {}
const MobileRequest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileRequest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m30,28c0-2.9668-2.167-5.4312-5-5.9097v-1.0903h1v-2h-4v2h1v1.0903c-2.833.4785-5,2.9429-5,5.9097h-1v2h14v-2h-1Zm-10,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4h-8Z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v8h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const MobileSession = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileSession({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18c-3.3083,0-6,2.6914-6,6s2.6917,6,6,6,6-2.6914,6-6-2.6917-6-6-6Zm0,10c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4v4h4c0,2.2056-1.7944,4-4,4Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m16,28h-7V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h7v-2ZM9,4h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const MobileView = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "24",
    r: "2"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m30.7769,23.4785c-1.4229-3.3287-4.4761-5.4785-7.7769-5.4785s-6.3538,2.1499-7.7769,5.4785l-.2231.5215.2231.5215c1.4231,3.3287,4.4761,5.4785,7.7769,5.4785s6.354-2.1499,7.7769-5.4785l.2231-.5215-.2231-.5215Zm-7.7769,4.5215c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m14,28h-5V8h14v7h2V4c0-1.103-.8975-2-2-2h-14c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h5v-2ZM9,4h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const MobileViewOrientation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobileViewOrientation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m28,12h-8v2h8v14h-8v2h8c1.1025,0,2-.897,2-2v-14c0-1.1025-.8975-2-2-2Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "m19,16l-1.4141,1.4141,2.5859,2.5859h-4.1719c-2.2056,0-4-1.7944-4-4v-2h-2v2c0,3.3086,2.6917,6,6,6h4.1719l-2.5859,2.5859,1.4141,1.4141,5-5-5-5Z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "m12,28h-6V8h16v-4c0-1.103-.8975-2-2-2H6c-1.103,0-2,.897-2,2v24c0,1.1025.897,2,2,2h6v-2ZM6,4h14v2H6v-2Z"
  })), children);
})));
if (false) {}
const MobilityServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MobilityServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2H24a2.0023,2.0023,0,0,0-2,2v8a2.0023,2.0023,0,0,0,2,2h4a2.0023,2.0023,0,0,0,2-2V4A2.0023,2.0023,0,0,0,28,2Zm0,2V6H24V4Zm-4,8V8h4v4Z"
  })), children);
})));
if (false) {}
const Model = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Model({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,24.1841V7.8159c1.1616-.4146,2-1.5142,2-2.8159,0-1.6543-1.3457-3-3-3s-3,1.3457-3,3c0,.3916.0806.7632.2173,1.106l-9.2173,8.0654L6.7827,6.1064c.137-.3433.2173-.7148.2173-1.1064,0-1.6543-1.3457-3-3-3S1,3.3457,1,5c0,1.3018.8384,2.4014,2,2.8154v16.3691c-1.1616.4141-2,1.5137-2,2.8154,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.6665-.2258-1.2769-.5952-1.7754l5.3335-4.667,2.3645,4.1377c-.6677.5508-1.1028,1.3735-1.1028,2.3047,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-.9312-.4353-1.7539-1.1028-2.3047l2.3645-4.1377,5.3335,4.667c-.3694.4985-.5952,1.1089-.5952,1.7754,0,1.6543,1.3457,3,3,3s3-1.3457,3-3c0-1.3018-.8384-2.4014-2-2.8159Zm-1-20.1841c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm-3.822,5.6729l-4.4397,7.7695-2.2197-1.9424,6.6594-5.8271Zm-9.6965,5.8271l-2.22,1.9424-4.4397-7.7695,6.6597,5.8271ZM4,4c.5515,0,1,.4487,1,1s-.4485,1-1,1-1-.4487-1-1,.4485-1,1-1Zm0,24c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm1-4.2036v-15.0308l5.7261,10.0205-5.7261,5.0103Zm11,4.2036c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Zm0-4.0151l-2.7261-4.771,2.7261-2.3853,2.7261,2.3853-2.7261,4.771Zm11-15.2197v15.0312l-5.7261-5.0103,5.7261-10.021Zm1,19.2349c-.5515,0-1-.4487-1-1s.4485-1,1-1,1,.4487,1,1-.4485,1-1,1Z"
  })), children);
})));
if (false) {}
const ModelAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4473,16.1055,23,13.3818V7a1,1,0,0,0-.5527-.8945l-6-3a1.0008,1.0008,0,0,0-.8946,0l-6,3A1,1,0,0,0,9,7v6.3818L3.5527,16.1055A1,1,0,0,0,3,17v7a1,1,0,0,0,.5527.8945l6,3a1.001,1.001,0,0,0,.8946,0L16,25.1182l5.5527,2.7763a1.001,1.001,0,0,0,.8946,0l6-3A1,1,0,0,0,29,24V17A1,1,0,0,0,28.4473,16.1055ZM21,13.3818l-4,2V10.6182l4-2ZM16,5.1182,19.7637,7,16,8.8818,12.2363,7Zm-5,3.5,4,2v4.7636l-4-2ZM9,25.3818l-4-2V18.6182l4,2Zm1-6.5L6.2363,17,10,15.1182,13.7637,17Zm1,1.7364,4-2v4.7636l-4,2Zm10,4.7636-4-2V18.6182l4,2Zm1-6.5L18.2363,17,22,15.1182,25.7637,17Zm5,4.5-4,2V20.6182l4-2Z"
  })), children);
})));
if (false) {}
const ModelFoundation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelFoundation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2h-5.7703l7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8385,2.8157-2h5.7703l-7.3005,7.3006c-.3911-.1871-.8237-.3006-1.2854-.3006-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.302,0,2.4016-.8385,2.8157-2h16.3687c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-.4617,0-.8943.1135-1.2854.3006l-7.3005-7.3006h5.7703c.4141,1.1615,1.5137,2,2.8157,2Zm0-4c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM7.8157,6h16.3687c.0349.0976.072.1927.1162.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0815-.1877.1162-.2853Zm19.1843-2c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1Zm-23,1c0-.5513.4482-1,1-1s1,.4487,1,1-.4482,1-1,1-1-.4487-1-1Zm1,12c-.5518,0-1-.4487-1-1s.4482-1,1-1,1,.4487,1,1-.4482,1-1,1Zm19.1843,9H7.8157c-.0347-.0976-.072-.1927-.1162-.2853l8.3005-8.3006,8.3005,8.3006c-.0442.0927-.0815.1877-.1162.2853Zm-19.1843,2c-.5518,0-1-.4487-1-1s.4482-1,1-1,1,.4487,1,1-.4482,1-1,1Zm23-1c0,.5513-.4482,1-1,1s-1-.4487-1-1,.4482-1,1-1,1,.4487,1,1Z"
  })), children);
})));
if (false) {}
const ModelReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20 4 22 8.5859 22 2 28.5859 3.4141 30 10 23.4141 10 28 12 28 12 20 4 20z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27,19c1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2h-5.7703l7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3v1h2v-1c0-.5513.4482-1,1-1s1,.4487,1,1v1h9.5859l8.7146,8.7147c-.0442.0927-.0815.1877-.1162.2853h-10.1843v2h10.1843c.4141,1.1615,1.5137,2,2.8157,2,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3c-.4617,0-.8943.1135-1.2854.3006l-7.3005-7.3006h5.7703c.4141,1.1615,1.5137,2,2.8157,2Zm1,8c0,.5513-.4482,1-1,1s-1-.4487-1-1,.4482-1,1-1,1,.4487,1,1Zm-1-12c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM7.8157,6h16.3687c.0349.0976.072.1927.1162.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0815-.1877.1162-.2853Zm19.1843-2c.5518,0,1,.4487,1,1s-.4482,1-1,1-1-.4487-1-1,.4482-1,1-1ZM4,5c0-.5513.4482-1,1-1s1,.4487,1,1-.4482,1-1,1-1-.4487-1-1Z"
  })), children);
})));
if (false) {}
const ModelTuned = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelTuned({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m24,30v-2.2773c.5952-.3464,1-.9841,1-1.7227s-.4048-1.3762-1-1.7227v-4.2773h-2v4.2773c-.5952.3464-1,.9844-1,1.7227s.4048,1.3762,1,1.7227v2.2773h2Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m31,24c0-.7383-.4048-1.376-1-1.7227v-2.2773h-2v2.2773c-.5952.3467-1,.9844-1,1.7227s.4048,1.376,1,1.7227v4.2773h2v-4.2773c.5952-.3467,1-.9844,1-1.7227Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m7.8157,17h5.7703s-7.3005,7.3006-7.3005,7.3006c-.3911-.1871-.8237-.3006-1.2854-.3006-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,1.302,0,2.4016-.8385,2.8157-2h10.1843s0-2,0-2H7.8157c-.0347-.0976-.072-.1927-.1162-.2853l8.7146-8.7147h9.5859s0-1,0-1c0-.5513.4482-1,1-1s1,.4487,1,1v1s2,0,2,0v-1c0-1.6543-1.3457-3-3-3-1.302,0-2.4016.8385-2.8157,2h-5.7703s7.3005-7.3006,7.3005-7.3006c.3911.1871.8237.3006,1.2854.3006,1.6543,0,3-1.3457,3-3,0-1.6543-1.3457-3-3-3-1.302,0-2.4016.8385-2.8157,2H7.8157c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,.4617,0,.8943-.1135,1.2854-.3006l7.3005,7.3006h-5.7703c-.4141-1.1615-1.5137-2-2.8157-2-1.6543,0-3,1.3457-3,3,0,1.6543,1.3457,3,3,3,1.302,0,2.4016-.8385,2.8157-2Zm-2.8157,9c.5518,0,1,.4487,1,1,0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1Zm1-10c0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1s1,.4487,1,1ZM24.3005,6.2853l-8.3005,8.3006L7.6995,6.2853c.0442-.0927.0813-.1877.1162-.2853h16.3687c.0347.0976.072.1927.1162.2853Zm-18.3005-1.2853c0,.5513-.4482,1-1,1s-1-.4487-1-1c0-.5513.4482-1,1-1s1,.4487,1,1Zm21,1c-.5518,0-1-.4487-1-1,0-.5513.4482-1,1-1s1,.4487,1,1c0,.5513-.4482,1-1,1Z"
  })), children);
})));
if (false) {}
const ModelBuilder = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelBuilder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12v8A3.0037,3.0037,0,0,1,13,23H10V20H2v8h8V25H13A5.0062,5.0062,0,0,0,18,20V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8ZM8,26H4V22H8ZM28,10H24V6h4Z"
  })), children);
})));
if (false) {}
const ModelBuilderReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModelBuilderReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M22,4V7H10V4H2v8h8V9h7.0234A4.9463,4.9463,0,0,0,16,12V28h2V12a2.9982,2.9982,0,0,1,2.9971-3H22v3h8V4ZM8,10H4V6H8Zm20,0H24V6h4Z"
  })), children);
})));
if (false) {}
const ModifiedNewest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModifiedNewest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3197,24.7l-4.3-4.3v-6.4h2v5.6l3.7,3.7s-1.4,1.4-1.4,1.4ZM16,12c4.4,0,8,3.6,8,8s-3.6,8-8,8-7.9803-3.6-7.9803-8,3.6-8,8-8M16,10c-5.5,0-10.0099,4.5-10.0099,10s4.5099,10,10.0099,10,10-4.5,10-10-4.4901-10-9.9901-10h-.0099ZM16,2l-5,6h10l-5-6Z"
  })), children);
})));
if (false) {}
const ModifiedOldest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ModifiedOldest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3,16.7l-4.3-4.3v-6.4h2v5.6l3.7,3.7s-1.4,1.4-1.4,1.4ZM16,4c4.4,0,8,3.6,8,8s-3.6,8-8,8-8-3.6-8-8,3.6-8,8-8M16,2c-5.5,0-10,4.5-10,10s4.5,10,10,10,10-4.5,10-10S21.5,2,16,2h0ZM16,30l5-6h-10l5,6Z"
  })), children);
})));
if (false) {}
const Money = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Money({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22H30V24H2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M2 26H30V28H2z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M24,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,16a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,16Zm0-6a2,2,0,1,0,2,2A2.002,2.002,0,0,0,16,10Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2.0051,2.0051,0,0,1-2-2V6A2.0051,2.0051,0,0,1,4,4H28a2.0051,2.0051,0,0,1,2,2V18A2.0027,2.0027,0,0,1,28,20ZM28,6H4V18H28Z"
  })), children);
})));
if (false) {}
const Monster = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Monster({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22 21 22 21 20 19 20 19 22 17 22 17 20 15 20 15 22 13 22 13 20 11 20 11 22 9 22 9 24 11 24 11 26 13 26 13 24 15 24 15 26 17 26 17 24 19 24 19 26 21 26 21 24 23 24 23 22z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11H27V4a2.0025,2.0025,0,0,0-2-2H7A2.0025,2.0025,0,0,0,5,4v7H4a2.0025,2.0025,0,0,0-2,2v4a2.0025,2.0025,0,0,0,2,2H5v4a7.0078,7.0078,0,0,0,7,7h8a7.0078,7.0078,0,0,0,7-7V19h1a2.0025,2.0025,0,0,0,2-2V13A2.0025,2.0025,0,0,0,28,11ZM25,4V7.3818L22.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L18,7.8818,14.4473,6.1055a1.0008,1.0008,0,0,0-.8946,0L10,7.8818l-3-1.5V4Zm3,13H25v6a5.0057,5.0057,0,0,1-5,5H12a5.0057,5.0057,0,0,1-5-5V17H4V13H7V8.6182L9.5527,9.8945a1.0008,1.0008,0,0,0,.8946,0L14,8.1182l3.5527,1.7763a1.001,1.001,0,0,0,.8946,0L22,8.1182l3,1.5V13h3Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M9 14H14V16H9z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H23V16H18z"
  })), children);
})));
if (false) {}
const Monument = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Monument({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28V6L16,2,12,6V28H2v2H30V28Zm-6,0V6.8281l2-2,2,2V28Z"
  })), children);
})));
if (false) {}
const Moon = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Moon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5025,5.4136A15.0755,15.0755,0,0,0,25.096,23.6082a11.1134,11.1134,0,0,1-7.9749,3.3893c-.1385,0-.2782.0051-.4178,0A11.0944,11.0944,0,0,1,13.5025,5.4136M14.98,3a1.0024,1.0024,0,0,0-.1746.0156A13.0959,13.0959,0,0,0,16.63,28.9973c.1641.006.3282,0,.4909,0a13.0724,13.0724,0,0,0,10.702-5.5556,1.0094,1.0094,0,0,0-.7833-1.5644A13.08,13.08,0,0,1,15.8892,4.38,1.0149,1.0149,0,0,0,14.98,3Z"
  })), children);
})));
if (false) {}
const Moonrise = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Moonrise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2 11 7 12.41 8.41 15 5.83 15 6 15 14 17 14 17 6 17 5.83 19.59 8.41 21 7 16 2z"
  })), children);
})));
if (false) {}
const Moonset = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Moonset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M26,26H24a7.987,7.987,0,0,0-2.0371-5.3335l1.49-1.334A9.9835,9.9835,0,0,1,26,26Z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H14a9.9268,9.9268,0,0,1,3.7539-7.804A7.89,7.89,0,0,0,16,18a8.0092,8.0092,0,0,0-8,8H6A10.0113,10.0113,0,0,1,16,16a9.8923,9.8923,0,0,1,4.4458,1.0515,1,1,0,0,1,0,1.79A7.9567,7.9567,0,0,0,16,26Z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14 11 9 12.41 7.59 15 10.17 15 10 15 2 17 2 17 10 17 10.17 19.59 7.59 21 9 16 14z"
  })), children);
})));
if (false) {}
const MostlyCloudy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MostlyCloudy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M21.743,18.6872A6.05,6.05,0,0,0,22.8,17.6006a5.9977,5.9977,0,1,0-10.7334-4.4444,7.5568,7.5568,0,0,0-5.7158,5.0879A5.9926,5.9926,0,0,0,8,30H19a5.9854,5.9854,0,0,0,2.743-11.3128ZM18,10a4.0042,4.0042,0,0,1,4,4,3.9613,3.9613,0,0,1-.8,2.3994,4.0122,4.0122,0,0,1-.94.8917,7.5416,7.5416,0,0,0-6.1339-4.2395A3.9985,3.9985,0,0,1,18,10Zm1,18H8a3.9928,3.9928,0,0,1-.6729-7.93L7.99,19.958l.1456-.6562a5.4958,5.4958,0,0,1,10.729,0l.1464.6562.6622.1123A3.9928,3.9928,0,0,1,19,28Z",
    transform: "translate(0 .005)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M26 13.005H30V15.005H26z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.071 5.929H27.071V7.929H23.071z",
    transform: "rotate(-45 25.077 6.931)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2.005H19V6.005H17z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M9.929 4.929H11.929V8.929H9.929z",
    transform: "rotate(-45 10.935 6.931)"
  })), children);
})));
if (false) {}
const MostlyCloudyNight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MostlyCloudyNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8438,15.0347a1.5169,1.5169,0,0,0-1.23-.8658,5.3547,5.3547,0,0,1-3.4094-1.7158A6.4653,6.4653,0,0,1,23.918,6.0605a1.6025,1.6025,0,0,0-.2989-1.5459,1.4543,1.4543,0,0,0-1.36-.4931l-.0191.0039a7.927,7.927,0,0,0-6.22,7.4307A7.3638,7.3638,0,0,0,13.5,11a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,28H19a5.9771,5.9771,0,0,0,5.6147-8.0884,7.5054,7.5054,0,0,0,5.1324-3.3569A1.5372,1.5372,0,0,0,29.8438,15.0347ZM19,26H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,26Zm4.4653-8.001h-.0217a5.9581,5.9581,0,0,0-2.7942-1.7549,7.5068,7.5068,0,0,0-2.6008-3.6767c-.01-.1016-.0361-.1978-.041-.3008a6.078,6.078,0,0,1,3.7907-6.05,8.4577,8.4577,0,0,0,1.94,7.5967A7.4007,7.4007,0,0,0,27.64,16.041,5.4286,5.4286,0,0,1,23.4653,17.999Z"
  })), children);
})));
if (false) {}
const Mountain = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mountain({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6343,26,17.7888,5.1055a2,2,0,0,0-3.5879.021L4.3657,26H2v2H30V26ZM15.99,5.979,20.9473,16.5,19,17.7979l-3-2-3,2-1.9551-1.3033ZM10.1846,18.3247,13,20.2021l3-2,3,2,2.8091-1.873L25.4233,26H6.5752Z"
  })), children);
})));
if (false) {}
const Mov = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mov({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9 26 22 24 9 22 9 24.52 23 27.48 23 30 9 28 9z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V21A2,2,0,0,1,18,23ZM14,11V21h4V11Z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
})));
if (false) {}
const Move = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Move({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11 23.59 12.41 26.17 15 17 15 17 5.83 19.59 8.41 21 7 16 2 11 7 12.41 8.41 15 5.83 15 15 5.83 15 8.41 12.41 7 11 2 16 7 21 8.41 19.59 5.83 17 15 17 15 26.17 12.41 23.59 11 25 16 30 21 25 19.59 23.59 17 26.17 17 17 26.17 17 23.59 19.59 25 21 30 16 25 11z"
  })), children);
})));
if (false) {}
const Movement = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Movement({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24,20l-1.41,1.41L26.17,25H10a4,4,0,0,1,0-8H22A6,6,0,0,0,22,5H5.83L9.41,1.41,8,0,2,6l6,6,1.41-1.41L5.83,7H22a4,4,0,0,1,0,8H10a6,6,0,0,0,0,12H26.17l-3.58,3.59L24,32l6-6Z"
  })), children);
})));
if (false) {}
const Mp3 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mp3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9H22v2h6v4H24v2h4v4H22v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,28,9Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
})));
if (false) {}
const Mp4 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mp4({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10v8h0V10m1-1H27v8H24V9H22V19h5v4h2V19h1V17H29V9Z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H12V9h6a2,2,0,0,1,2,2v5a2,2,0,0,1-2,2H14Zm0-7h4V11H14Z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9 6.49 14 6 15.98 5.54 14 4 9 2 9 2 23 4 23 4 15 3.84 13 4.42 15 6 19.63 7.58 15 8.16 13 8 15 8 23 10 23 10 9 8 9z"
  })), children);
})));
if (false) {}
const Mpeg = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mpeg({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M32,21H28a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H28v6h2V17H29l0-2h3Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M24 13 24 11.024 18 11.024 18 21 24 21 24 19 20 19 20 17 22 17 22 15 20 15 20 13 24 13z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11 5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
})));
if (false) {}
const Mpg2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mpg2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M32,21H26V17a2.002,2.002,0,0,1,2-2h2V13H26V11h4a2.0023,2.0023,0,0,1,2,2v2a2.0023,2.0023,0,0,1-2,2H28v2h4Z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M24,21H20a2.0023,2.0023,0,0,1-2-2V13a2.002,2.002,0,0,1,2-2h4v2H20v6h2V17H21l0-2h3Z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11H9V21h2V18h3a2.0027,2.0027,0,0,0,2-2V13A2.0023,2.0023,0,0,0,14,11Zm-3,5V13h3l.001,3Z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11 5 11 3.5 15 2 11 0 11 0 21 2 21 2 14 3.5 18 5 14 5 21 7 21 7 11z"
  })), children);
})));
if (false) {}
const MultiuserDevice = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MultiuserDevice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25h-6c-1.66,0-3,1.34-3,3v2h2v-2c0-.55.45-1,1-1h6c.55,0,1,.45,1,1v2h2v-2c0-1.66-1.34-3-3-3ZM13,20c0,2.21,1.79,4,4,4s4-1.79,4-4-1.79-4-4-4-4,1.79-4,4ZM19,20c0,1.1-.9,2-2,2s-2-.9-2-2,.9-2,2-2,2,.9,2,2ZM22,18c1.1,0,2,.9,2,2s-.9,2-2,2v2c2.21,0,4-1.79,4-4s-1.79-4-4-4v2ZM25,25h-1v2h1c.55,0,1,.45,1,1v2h2v-2c0-1.66-1.34-3-3-3ZM6,4h16v10h2V4c0-1.1-.9-2-2-2H6c-1.1,0-2,.9-2,2v24c0,1.1.9,2,2,2h3v-2h-3V4Z"
  })), children);
})));
if (false) {}
const Music = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Music({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M25,4H10A2.002,2.002,0,0,0,8,6V20.5563A3.9551,3.9551,0,0,0,6,20a4,4,0,1,0,4,4V12H25v8.5562A3.9545,3.9545,0,0,0,23,20a4,4,0,1,0,4,4V6A2.0023,2.0023,0,0,0,25,4ZM6,26a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,26Zm17,0a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,23,26ZM10,6H25v4H10Z"
  })), children);
})));
if (false) {}
const MusicAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MusicAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6 26 6 26 2 24 2 24 6 20 6 20 8 24 8 24 12 26 12 26 8 30 8 30 6z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
})));
if (false) {}
const MusicRemove = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function MusicRemove({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 7 30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15v7.5562A3.9552,3.9552,0,0,0,22,22a4,4,0,1,0,4,4V15ZM22,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,22,28Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M17,6H10A2.002,2.002,0,0,0,8,8V22.5562A3.9557,3.9557,0,0,0,6,22a4,4,0,1,0,4,4V8h7ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
})));
if (false) {}
const Mysql = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Mysql({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "m28.2471,11.9248h3.1748l-4.6465,13.938c-.3066.9351-.7402,1.6255-1.2998,2.0703-.5596.4443-1.3604.667-2.4033.667h-2.1162v-2.645h2.2773l.4141-1.334-4.2324-12.6963h3.3818l1.7705,5.6353.874,3.4961h.1377l.8975-3.4961,1.7705-5.6353Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2178 13.4658 14.1484 13.4658 12.9756 15.812 9.8477 21.4932 6.7891 15.835 5.5693 13.3052 5.501 13.3052 5.501 24 2.2119 24 2.2119 7.9458 5.915 7.9458 9.8477 15.4668 9.8936 15.4668 13.7812 7.9458 17.5068 7.9458 17.5068 24 14.2178 24 14.2178 13.4658z"
  })), children);
})));
if (false) {}
const NameSpace = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NameSpace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12H4a2.0023,2.0023,0,0,1-2-2V6A2.0023,2.0023,0,0,1,4,4H7V6H4v4H7Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10H15V12H9z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H23V12H17z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H25V10h3V6H25V4h3a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,12Z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4H23V6H17z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4H15V6H9z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0023,2.0023,0,0,1-2-2V22a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,28ZM4,22v4H28V22Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), children);
})));
if (false) {}
const NamingConventions = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NamingConventions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8h-8v2h8v-2ZM14,16h8v-2h-8v2ZM10,14h-2v-4h2v-2h-2v-4h18v12h2V4c0-1.1046-.8954-2-2-2H8c-1.1046,0-2,.8954-2,2v4h-2v2h2v4h-2v2h6v-2ZM13.1055,20h-2.2109c-1.0444,0-1.8945.8496-1.8945,1.8945v6.2109c0,1.0449.8501,1.8945,1.8945,1.8945h2.2109c1.0444,0,1.8945-.8496,1.8945-1.8945v-6.2109c0-1.0449-.8501-1.8945-1.8945-1.8945ZM13,28h-2v-6h2v6ZM1,22v6c0,1.1025.897,2,2,2h4v-2H3v-6h4v-2H3c-1.103,0-2,.8975-2,2ZM21,26l-2-6h-2v10h2v-6l2,6h2v-10h-2v6ZM29,20l-1,8-1-8h-2l2,10h2l2-10h-2Z"
  })), children);
})));
if (false) {}
const NavaidCivil = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidCivil({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
})));
if (false) {}
const NavaidDme = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidDme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M24,24H8a2.0021,2.0021,0,0,1-2-2V10A2.0021,2.0021,0,0,1,8,8H24a2.0021,2.0021,0,0,1,2,2V22A2.0021,2.0021,0,0,1,24,24ZM8,10V22H24V10Z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28H4a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,4,4H28a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,28,28ZM4,6V26H28V6Z"
  })), children);
})));
if (false) {}
const NavaidHelipad = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidHelipad({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9 18 15 14 15 14 9 12 9 12 23 14 23 14 17 18 17 18 23 20 23 20 9 18 9z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const NavaidMilitary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), children);
})));
if (false) {}
const NavaidMilitaryCivil = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidMilitaryCivil({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
})));
if (false) {}
const NavaidNdb = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidNdb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,16,24Zm0-14a6,6,0,1,0,6,6A6.0067,6.0067,0,0,0,16,10Z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "4",
    r: "2"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "28",
    r: "2"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "16",
    r: "2"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "16",
    r: "2"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "7.515",
    r: "2"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "24.485",
    r: "2"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.485",
    cy: "7.515",
    r: "2"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: "7.515",
    cy: "24.485",
    r: "2"
  })), children);
})));
if (false) {}
const NavaidNdbDme = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidNdbDme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M4,12H2V4A2.0021,2.0021,0,0,1,4,2h8V4H4Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V20H4v8h8Z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20V28h8V20h2v8A2.0021,2.0021,0,0,1,28,30Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12H28V4H20V2h8a2.0021,2.0021,0,0,1,2,2Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a6,6,0,1,1,6-6A6.0067,6.0067,0,0,1,16,22Zm0-10a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,12Z"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "7",
    r: "1"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "3",
    r: "1"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "25",
    r: "1"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "29",
    r: "1"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "16",
    r: "1"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: "29",
    cy: "16",
    r: "1"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "16",
    r: "1"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: "3",
    cy: "16",
    r: "1"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "9.636",
    r: "1"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "7",
    r: "1"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "22.364",
    r: "1"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "25",
    r: "1"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: "22.364",
    cy: "9.636",
    r: "1"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: "25",
    cy: "7",
    r: "1"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: "9.636",
    cy: "22.364",
    r: "1"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "25",
    r: "1"
  })), children);
})));
if (false) {}
const NavaidPrivate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidPrivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M20,15V11a2.0023,2.0023,0,0,0-2-2H12V23h2V17h1.4807l2.3345,6H19.96l-2.333-6H18A2.0027,2.0027,0,0,0,20,15Zm-6-4h4v4H14Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14.0158,14.0158,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12.0137,12.0137,0,0,0,16,4Z"
  })), children);
})));
if (false) {}
const NavaidSeaplane = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidSeaplane({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M20,18a3.9962,3.9962,0,0,1-3,3.8579V17h2V15H17V13.8159a3.0007,3.0007,0,1,0-2,0V15H13v2h2v4.8579A3.9962,3.9962,0,0,1,12,18H10a6,6,0,0,0,12,0Zm-4-8a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,16,10Z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H27.8193A12.0112,12.0112,0,0,0,18,4.1807V2H14V4.1807A12.0112,12.0112,0,0,0,4.1807,14H2v4H4.1807A12.0112,12.0112,0,0,0,14,27.8193V30h4V27.8193A12.0112,12.0112,0,0,0,27.8193,18H30ZM16,26A10,10,0,1,1,26,16,10.0114,10.0114,0,0,1,16,26Z"
  })), children);
})));
if (false) {}
const NavaidTacan = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidTacan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M20,28H12a1,1,0,0,1-1-1V21.2656L7.2612,14.7231,2.4854,11.8574a1,1,0,0,1-.3536-1.3535l4-7a1,1,0,0,1,1.3828-.3613L12.2769,6h7.4462l4.7623-2.8574a1,1,0,0,1,1.3828.3613l4,7a1,1,0,0,1-.3536,1.3535l-4.7758,2.8657L21,21.2656V27A1,1,0,0,1,20,28Zm-7-2h6V20.7346l4.2616-7.4578,4.3844-2.6306L24.6387,5.3831,20.277,8H11.723L7.3613,5.3831,4.354,10.6462l4.3844,2.6306L13,20.7346Z"
  })), children);
})));
if (false) {}
const NavaidVhfor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidVhfor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M22,28H10a1,1,0,0,1-.8438-.4631l-7-11a1,1,0,0,1,0-1.0738l7-11A1,1,0,0,1,10,4H22a1,1,0,0,1,.8438.4631l7,11a1,1,0,0,1,0,1.0738l-7,11A1,1,0,0,1,22,28ZM10.5488,26H21.4512l6.3633-10L21.4512,6H10.5488L4.1855,16Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5,24h-7a1.0005,1.0005,0,0,1-.8413-.4592l-4.5-7a1.0016,1.0016,0,0,1,0-1.0816l4.5-7A1.0005,1.0005,0,0,1,12.5,8h7a1.0005,1.0005,0,0,1,.8413.4592l4.5,7a1.0016,1.0016,0,0,1,0,1.0816l-4.5,7A1.0005,1.0005,0,0,1,19.5,24Zm-6.4541-2h5.9082l3.8569-6-3.8569-6H13.0459L9.189,16Z"
  })), children);
})));
if (false) {}
const NavaidVor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidVor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8638,15.4961l-7-12A1,1,0,0,0,23,3H9a1,1,0,0,0-.8638.4961l-7,12a1,1,0,0,0,0,1.0078l7,12A1,1,0,0,0,9,29H23a1,1,0,0,0,.8638-.4961l7-12a1,1,0,0,0,0-1.0078ZM22.4258,27H9.5742L3.1577,16,9.5742,5H22.4258l6.4165,11Z"
  })), children);
})));
if (false) {}
const NavaidVordme = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidVordme({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,6V26a2.0023,2.0023,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2Zm-2,6.9258L22.9636,6H28ZM27.7637,16,20.491,26H11.509L4.2363,16,11.509,6h8.982ZM9.0364,6,4,12.9248V6ZM4,19.0752,9.0364,26H4ZM22.9636,26l5.0374-6.9263L28,26Z"
  })), children);
})));
if (false) {}
const NavaidVortac = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function NavaidVortac({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "14",
    r: "2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8682,10.5039l-4-7a.9992.9992,0,0,0-1.3828-.3613L19.7231,6H12.2769L7.5146,3.1426a.9992.9992,0,0,0-1.3828.3613l-4,7a1,1,0,0,0,.3536,1.3535l4.7758,2.8657L11,21.2656V27a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1V21.2656l3.7388-6.5425,4.7758-2.8657A1,1,0,0,0,29.8682,10.5039ZM18.8484,21H13.1516L8.5757,12.9922,11.4287,8h9.1426l2.853,4.9922Z"
  })), children);
})));
if (false) {}
const Need = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Need({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1211,16.8789A2.98,2.98,0,0,0,27.01,16H27a2.9774,2.9774,0,0,0-2.1211.8789L19.9778,21.78A2.9943,2.9943,0,0,0,17,19H10a5.0059,5.0059,0,0,0-5,5v.667L2,28.6631l1.6,1.2L7,25.333V24a3.0033,3.0033,0,0,1,3-3h7a1,1,0,0,1,0,2H13v2h4.9287a3.9717,3.9717,0,0,0,2.8286-1.1719L26.293,18.293A.9929.9929,0,0,1,27,18h.0034a1,1,0,0,1,.7036,1.707l-7.414,7.4141A2.9791,2.9791,0,0,1,18.1714,28H11v2h7.1714a4.9665,4.9665,0,0,0,3.5356-1.4648l7.4141-7.4141a2.9989,2.9989,0,0,0,0-4.2422Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M21.586 8.586 18 12 18 2 16 2 16 12 12.414 8.586 11 10 17 16 23 10 21.586 8.586z"
  })), children);
})));
if (false) {}
const Network_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M16,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,16,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,16,14Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M5,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,5,20Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,5,14Z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M10,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,25Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M22,31a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,31Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,25Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M27,20a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,27,20Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,27,14Z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M22,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,22,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,22,3Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M10,9a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,9Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,3Z"
  })), children);
})));
if (false) {}
const Network_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M17,17h5.1421a4,4,0,1,0,0-2H17V7h5.1421a4,4,0,1,0,0-2H17a2.0023,2.0023,0,0,0-2,2v8H9.8579a4,4,0,1,0,0,2H15v8a2.0023,2.0023,0,0,0,2,2h5.1421a4,4,0,1,0,0-2H17Zm9-3a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,14ZM26,4a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,4ZM6,18a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,18Zm20,6a2,2,0,1,1-2,2A2.0023,2.0023,0,0,1,26,24Z"
  })), children);
})));
if (false) {}
const Network_3 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Network_3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H22V22h8Zm-6-2h4V24H24Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M20,27H8A6,6,0,0,1,8,15h2v2H8a4,4,0,0,0,0,8H20Z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20H12V12h8Zm-6-2h4V14H14Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M24,17H22V15h2a4,4,0,0,0,0-8H12V5H24a6,6,0,0,1,0,12Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M10,10H2V2h8ZM4,8H8V4H4Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 2522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vc": function() { return /* binding */ Save; }
/* harmony export */ });
/* unused harmony exports QS, QSAlt, RainDrop, RainHeavy, RainScattered, RainScatteredNight, Raw, ReadMe, ReadingGlasses, Receipt, RecentlyViewed, Recommend, Recording, RecordingFilled, RecordingFilledAlt, Recycle, RedHatAiInstructlabOnIbmCloud, Redefinition, Redo, RefEvapotranspiration, ReferenceArchitecture, ReflectHorizontal, ReflectVertical, Reminder, ReminderMedical, RemoteConnection, Renew, Repeat, RepeatOne, Replicate, Reply, ReplyAll, RepoArtifact, RepoSourceCode, Report, ReportData, RequestQuote, RequirementDefinition, RequirementUsage, Reset, ResetAlt, Restart, Restaurant, RestaurantFine, Result, ResultDraft, ResultNew, ResultOld, RetryFailed, Return, Review, Rewind_10, Rewind_30, Rewind_5, Rexx, RightPanelClose, RightPanelCloseFilled, RightPanelOpen, RightPanelOpenFilled, Road, RoadWeather, Roadmap, Rocket, Rotate, RotateClockwise, RotateClockwiseAlt, RotateClockwiseAltFilled, RotateClockwiseFilled, RotateCounterclockwise, RotateCounterclockwiseAlt, RotateCounterclockwiseAltFilled, RotateCounterclockwiseFilled, Router, RouterVoice, RouterWifi, Row, RowCollapse, RowDelete, RowExpand, RowInsert, Rss, Rule, RuleCancelled, RuleDataQuality, RuleDraft, RuleFilled, RuleGroupingDataQuality, RuleLocked, RulePartial, RuleTest, Ruler, RulerAlt, Run, RunMirror, RunViewIcon, Running, SailboatCoastal, SailboatOffshore, SalesOps, SankeyDiagram, SankeyDiagramAlt, Sap, Satellite, SatelliteRadar, SatelliteWeather, SatisfyDefinition, SatisfyUsage, SaveModel, Scale, Scales, ScalesTipped, Scalpel, Scan, WatsonHealthRegionAnalysisArea, WatsonHealthRegionAnalysisVolume, WatsonHealthRegistration, WatsonHealthRotate_180, WatsonHealthRotate_360, WatsonHealthSaveAnnotation, WatsonHealthSaveImage, WatsonHealthSaveSeries, WatsonHealthScalpelCursor, WatsonHealthScalpelLasso, WatsonHealthScalpelSelect */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _circle, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _circle2, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _circle3, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _circle4, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _switch, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319;
const RainHeavy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RainHeavy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,17,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,8,30Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15.5a6.5323,6.5323,0,0,0-5.1992-6.3638,8.9943,8.9943,0,0,0-17.6006,0A6.4905,6.4905,0,0,0,5.7026,21.3584L4.106,24.5527a1,1,0,1,0,1.7885.8946L7.6174,22l6.7644,0L13.106,24.5527a1,1,0,1,0,1.7885.8946L16.6177,22h6.7641L22.106,24.5527a1,1,0,1,0,1.7885.8946l1.9444-3.89A6.5058,6.5058,0,0,0,30,15.5ZM23.5,20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20Z"
  })), children);
})));
if (false) {}
const RainScattered = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RainScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0127,1.0127,0,0,1-.4485-.1054.9986.9986,0,0,1-.4486-1.3418l1.4934-3.0005a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0013,1.0013,0,0,1,8.5084,32Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.232 15.733H29.232V18.733H27.232z",
    transform: "rotate(-45.01 28.232 17.233)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.768 3.268H14.768V6.268H12.768z",
    transform: "rotate(-45 13.768 4.768)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11ZM19,23H8a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm3.9268-8.5107a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), children);
})));
if (false) {}
const RainScatteredNight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RainScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5084,32a1.0115,1.0115,0,0,1-.4485-.1055.9986.9986,0,0,1-.4486-1.3418l1.4934-3a1.0025,1.0025,0,0,1,1.7943.8945l-1.4934,3A1.0015,1.0015,0,0,1,8.5084,32Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8442,13.0347a1.5184,1.5184,0,0,0-1.2309-.8658,5.3587,5.3587,0,0,1-3.4094-1.7163,6.4648,6.4648,0,0,1-1.285-6.393,1.6031,1.6031,0,0,0-.3-1.5459,1.4535,1.4535,0,0,0-1.3594-.4922l-.0191.0029a7.8549,7.8549,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25h7.3818L14.106,27.5527a1,1,0,1,0,1.7885.8946L17.6177,25H19a5.9549,5.9549,0,0,0,5.88-7.1455,7.5,7.5,0,0,0,4.8672-3.3A1.5381,1.5381,0,0,0,29.8442,13.0347ZM19,23H8a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23Zm5.1509-7.0479a5.9639,5.9639,0,0,0-3.5015-2.708A7.5076,7.5076,0,0,0,18.0286,9.55a6.01,6.01,0,0,1,3.77-5.334,8.4581,8.4581,0,0,0,1.9395,7.5972A7.4007,7.4007,0,0,0,27.64,14.041,5.4392,5.4392,0,0,1,24.1509,15.9521Z"
  })), children);
})));
if (false) {}
const RainDrop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RainDrop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24V22a3.2965,3.2965,0,0,0,3-3h2A5.2668,5.2668,0,0,1,16,24Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28a9.0114,9.0114,0,0,1-9-9,9.9843,9.9843,0,0,1,1.4941-4.9554L15.1528,3.4367a1.04,1.04,0,0,1,1.6944,0l6.6289,10.5564A10.0633,10.0633,0,0,1,25,19,9.0114,9.0114,0,0,1,16,28ZM16,5.8483l-5.7817,9.2079A7.9771,7.9771,0,0,0,9,19a7,7,0,0,0,14,0,8.0615,8.0615,0,0,0-1.248-3.9953Z"
  })), children);
})));
if (false) {}
const Raw = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Raw({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9 28.86 17 28.6 21.54 28.19 18 27.51 12.54 25.49 12.54 24.81 18 24.4 21.54 24.14 17 23.8 9 22 9 23 23 25.27 23 26.03 18.07 26.49 14 26.5 13.97 26.51 14 26.97 18.07 27.73 23 30 23 31 9 29.2 9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18,9H14a2,2,0,0,0-2,2V23h2V18h4v5h2V11A2,2,0,0,0,18,9Zm-4,7V11h4v5Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10,15V11A2,2,0,0,0,8,9H2V23H4V17H5.48l2.34,6H10L7.63,17H8A2,2,0,0,0,10,15ZM4,11H8v4H4Z"
  })), children);
})));
if (false) {}
const ReadMe = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReadMe({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M20,7H5v-2h15v2ZM20,10H5v2h15v-2ZM12,15h-7v2h7v-2ZM10,20h-5v2h5v-2ZM20,20c-1.1,0-2,.9-2,2s.9,2,2,2,2-.9,2-2-.9-2-2-2ZM28,22l-.22.52c-1.42,3.33-4.48,5.48-7.78,5.48s-6.35-2.15-7.78-5.48l-.22-.52.22-.52c1.42-3.33,4.48-5.48,7.78-5.48s6.35,2.15,7.78,5.48l.22.52ZM24,22c0-2.21-1.79-4-4-4s-4,1.79-4,4,1.79,4,4,4,4-1.79,4-4Z"
  })), children);
})));
if (false) {}
const ReadingGlasses = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReadingGlasses({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4141,6.9968l-4.0001-3.9968-1.414,1.4144,4.0001,3.9968v10.5888h-7.0001c-1.4702,0-2.691,1.0646-2.9457,2.4624-.6383-.2906-1.333-.4624-2.0543-.4624s-1.416.1718-2.0543.4623c-.2548-1.3978-1.4755-2.4623-2.9457-2.4623H3.9999v-10.5888l4.0001-3.9968-1.414-1.4144-4.0001,3.9968c-.3779.378-.5859.8801-.5859,1.4144v16.5888c0,2.2061,1.7944,4,4,4h3c2.7568,0,5-2.2432,5-5v-.2139c.5444-.4899,1.2498-.7861,2-.7861s1.4553.2962,2,.7861v.2139c0,2.7568,2.2432,5,5,5h3c2.2061,0,4-1.7939,4-4V8.4112c0-.5343-.208-1.0364-.5859-1.4144ZM12,24c0,1.6543-1.3457,3-3,3h-3c-1.103,0-2-.8975-2-2v-4h7c.5513,0,1,.4482,1,1v2ZM28,25c0,1.1025-.8975,2-2,2h-3c-1.6543,0-3-1.3457-3-3v-2c0-.5518.4482-1,1-1h7v4Z"
  })), children);
})));
if (false) {}
const Receipt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Receipt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21 16H23V18H21z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16H17V18H9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H23V14H21z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12H17V14H9z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H23V10H9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2H7A2.002,2.002,0,0,0,5,4V29a1,1,0,0,0,1,1H7a.9987.9987,0,0,0,.8-.4L10,26.667,12.2,29.6a1.0353,1.0353,0,0,0,1.6,0L16,26.667,18.2,29.6a1.0353,1.0353,0,0,0,1.6,0L22,26.667,24.2,29.6a.9993.9993,0,0,0,.8.4h1a1,1,0,0,0,1-1V4A2.0023,2.0023,0,0,0,25,2Zm0,25.333L22.8,24.4a1.0353,1.0353,0,0,0-1.6,0L19,27.333,16.8,24.4a1.0353,1.0353,0,0,0-1.6,0L13,27.333,10.8,24.4a1.0353,1.0353,0,0,0-1.6,0L7,27.333V4H25Z"
  })), children);
})));
if (false) {}
const RecentlyViewed = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RecentlyViewed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22 15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.94,13.94,0,0,0,6,6.23V2H4v8h8V8H7.08A12,12,0,1,1,4,16H2A14,14,0,1,0,16,2Z"
  })), children);
})));
if (false) {}
const Recommend = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Recommend({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2a9,9,0,0,0-6,15.69V30l6-4,6,4V17.69A9,9,0,0,0,16,2Zm4,24.26-2.89-1.92L16,23.6l-1.11.74L12,26.26V19.05a8.88,8.88,0,0,0,8,0ZM20.89,16A7,7,0,1,1,23,11,7,7,0,0,1,20.89,16Z"
  })), children);
})));
if (false) {}
const Recording = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Recording({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4A12,12,0,1,1,4,16,12,12,0,0,1,16,4m0-2A14,14,0,1,0,30,16,14,14,0,0,0,16,2Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a4,4,0,1,1-4,4,4,4,0,0,1,4-4m0-2a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  })), children);
})));
if (false) {}
const RecordingFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RecordingFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6 S19.3,22,16,22z"
  })), children);
})));
if (false) {}
const RecordingFilledAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RecordingFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2C8.3,2,2,8.3,2,16s6.3,14,14,14s14-6.3,14-14S23.7,2,16,2z M16,22c-3.3,0-6-2.7-6-6s2.7-6,6-6s6,2.7,6,6S19.3,22,16,22 z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S19.3,10,16,10z",
    "data-icon-path": "inner-path",
    opacity: "0"
  })), children);
})));
if (false) {}
const Recycle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Recycle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5081,22.2549l-2.0781-3.7402-1.7485,.9707,2.0781,3.7412c.3247,.584,.3162,1.2769-.0229,1.8535-.3391,.5762-.9407,.9199-1.6091,.9199h-7.2974l2.5801-2.5898-1.4102-1.4102-5,5,5,5,1.4102-1.4102-2.5801-2.5898h7.2974c1.3848,0,2.6306-.7124,3.3328-1.9058,.7024-1.1938,.7202-2.6284,.0479-3.8394Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8726,26c-.6685,0-1.27-.3438-1.6091-.9199-.3391-.5767-.3477-1.2695-.0229-1.8535l4.1111-7.4004,1.0479,3.52,1.9121-.5664-2.0083-6.7798-6.7798,2.0083,.5664,1.9121,3.4934-1.0298-4.0913,7.3643c-.6724,1.2109-.6545,2.6455,.0479,3.8394,.7021,1.1934,1.948,1.9058,3.3328,1.9058h6.1274v-2H5.8726Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M25.51,9.6538l-1.0476,3.519L19.3503,3.9712c-.6858-1.2344-1.9382-1.9712-3.3503-1.9712s-2.6646,.7368-3.3503,1.9712l-3.0796,5.5435,1.7485,.9707,3.0796-5.543c.3276-.5898,.9265-.9424,1.6018-.9424s1.2742,.3525,1.6018,.9424l5.0925,9.167-3.4939-1.0298-.5664,1.9121,6.78,2.0083,2.0083-6.7798-1.9124-.5664Z"
  })), children);
})));
if (false) {}
const Redefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Redefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28v-4h7v-2h-7v-4h7c.3564,0,.686-.1899.865-.498.179-.3086.1802-.6885.0032-.998L12.8682,2.5039c-.356-.623-1.3804-.623-1.7363,0L3.1318,16.5039c-.177.3096-.1758.6895.0032.998.179.3081.5085.498.865.498h7v4h-7v2h7v4c0,1.1045.8955,2,2,2h15v-2h-15ZM5.7231,16l6.2769-10.9844,6.2769,10.9844H5.7231Z"
  })), children);
})));
if (false) {}
const RedHatAiInstructlabOnIbmCloud = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RedHatAiInstructlabOnIbmCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M21,10c-1.3016,0-2.3906.8409-2.805,2.002l-8.195-.002v2l8.1945.002c.4138,1.162,1.5032,1.998,2.8055,1.998,1.6543,0,3-1.3457,3-3s-1.3457-3-3-3ZM21,14c-.5513,0-1-.4487-1-1s.4487-1,1-1,1,.4487,1,1-.4487,1-1,1ZM24,18l-8.1796.001c-.4146-1.1608-1.519-2.001-2.8204-2.001-1.6543,0-3,1.3457-3,3s1.3457,3,3,3c1.3025,0,2.4076-.8367,2.8213-1.999l8.1787-.001v-2ZM13,20c-.5513,0-1-.4487-1-1s.4487-1,1-1,1,.4487,1,1-.4487,1-1,1ZM29.8801,16.4801l-6,11c-.1799.3198-.51.5199-.88.5199h-14c-.37,0-.7001-.2001-.88-.5199l-6-11c-.16-.3-.16-.6602,0-.9601l4.11-7.53,1.74,1-3.83,7.01,5.45,10h12.8201l5.45-10-5.45-10h-13.41v-2h14c.37,0,.7001.2001.88.52l6,11c.1599.2999.1599.66,0,.9601h-.0001Z"
  })), children);
})));
if (false) {}
const Redo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Redo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H24.1851L20.5977,6.4141,22,5,28,11,22,17l-1.4023-1.4146L24.1821,12H12a6,6,0,0,0,0,12h8v2H12a8,8,0,0,1,0-16Z"
  })), children);
})));
if (false) {}
const RefEvapotranspiration = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RefEvapotranspiration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M14,12a3.8978,3.8978,0,0,1-4-3.777,3.9017,3.9017,0,0,1,.6533-2.0639L13.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L17.3154,6.11A3.9693,3.9693,0,0,1,18,8.223,3.8978,3.8978,0,0,1,14,12Zm.0005-7.2368L12.3438,7.2257A1.89,1.89,0,0,0,12,8.223,1.9,1.9,0,0,0,14,10a1.9,1.9,0,0,0,2-1.777,1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5,26A5.385,5.385,0,0,1,2,20.751,5.3837,5.3837,0,0,1,2.874,17.92L6.49,12.5383a1.2168,1.2168,0,0,1,2.02-.0006l3.55,5.2777A5.4923,5.4923,0,0,1,13,20.751,5.385,5.385,0,0,1,7.5,26Zm0-11.38L4.5649,18.9868A3.3586,3.3586,0,0,0,4,20.751,3.3855,3.3855,0,0,0,7.5,24,3.3855,3.3855,0,0,0,11,20.751a3.4354,3.4354,0,0,0-.63-1.867Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M25,2,20,7l1.4141,1.4141L24,5.8281V16a4.0045,4.0045,0,0,1-4,4H16v2h4a6.0066,6.0066,0,0,0,6-6V5.8281l2.5859,2.586L30,7Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), children);
})));
if (false) {}
const ReferenceArchitecture = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReferenceArchitecture({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "26",
    r: "1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "m28,20c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-5c0-1.1025-.8972-2-2-2h-5v-1c0-1.1025-.8972-2-2-2h-4c-1.1028,0-2,.8975-2,2v1h-5c-1.1028,0-2,.8975-2,2v5.1421c-1.7202.4473-3,1.9995-3,3.8579s1.2798,3.4106,3,3.8579v5.1421c0,1.1025.8972,2,2,2h7v1c0,1.1025.8972,2,2,2h12c1.1028,0,2-.8975,2-2v-4c0-1.1025-.8972-2-2-2h-1v-2h1Zm0-2h-4v-4h4v4ZM14,4h4v4h-4v-4Zm-2,3v1c0,1.1025.8972,2,2,2h4c1.1028,0,2-.8975,2-2v-1h5v5h-1c-1.1028,0-2,.8975-2,2v1h-12.1421c-.3638-1.3989-1.4592-2.4941-2.8579-2.8579v-5.1421h5Zm-8,9c0-1.1025.8972-2,2-2s2,.8975,2,2-.8972,2-2,2-2-.8975-2-2Zm24,12h-12v-4h12v4Zm-3-6h-9c-1.1028,0-2,.8975-2,2v1h-7v-5.1421c1.3987-.3638,2.4941-1.459,2.8579-2.8579h12.1421v1c0,1.1025.8972,2,2,2h1v2Z"
  })), children);
})));
if (false) {}
const ReflectHorizontal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReflectHorizontal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M19.386,15.2105l9-7A1,1,0,0,1,30,9V23a1,1,0,0,1-1.614.79l-9-7a1,1,0,0,1,0-1.5791Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "matrix(-1 0 0 -1 32 32)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13,16a1.001,1.001,0,0,1-.386.79l-9,7A1,1,0,0,1,2,23V9a1,1,0,0,1,1.614-.79l9,7A1.001,1.001,0,0,1,13,16ZM4,20.9556,10.3711,16,4,11.0444Z"
  })), children);
})));
if (false) {}
const ReflectVertical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReflectVertical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M16.79,19.386l7,9A1,1,0,0,1,23,30H9a1,1,0,0,1-.79-1.614l7-9a1,1,0,0,1,1.5791,0Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V30H15z",
    transform: "rotate(-90 16 16)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16,13a1.001,1.001,0,0,1-.79-.386l-7-9A1,1,0,0,1,9,2H23a1,1,0,0,1,.79,1.614l-7,9A1.001,1.001,0,0,1,16,13ZM11.0444,4,16,10.3711,20.9556,4Z"
  })), children);
})));
if (false) {}
const WatsonHealthRegionAnalysisArea = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthRegionAnalysisArea({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16H28A12,12,0,1,0,16,28Z"
  })), children);
})));
if (false) {}
const WatsonHealthRegionAnalysisVolume = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthRegionAnalysisVolume({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23V21H28V19H26v2H23V19H21v2H19v2h2v3H19v2h2v2h2V28h3v2h2V28h2V26H28V23Zm-4,3H23V23h3Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M4.8305,20.3555A24.9534,24.9534,0,0,0,15,22.9644v-2A22.9014,22.9014,0,0,1,4.1335,17.6919,11.979,11.979,0,0,1,4,16a11.9847,11.9847,0,0,1,.1332-1.69,22.9282,22.9282,0,0,1,23.7336,0A11.9847,11.9847,0,0,1,28,16h2A14,14,0,1,0,16,30V28A12.01,12.01,0,0,1,4.8305,20.3555ZM16,4a12.01,12.01,0,0,1,11.17,7.6465,24.8982,24.8982,0,0,0-22.3406,0A12.01,12.01,0,0,1,16,4Z"
  })), children);
})));
if (false) {}
const WatsonHealthRegistration = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthRegistration({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M28,25H20a2.0027,2.0027,0,0,1-2-2V20h2v3h8V9H20v3H18V9a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2V23A2.0027,2.0027,0,0,1,28,25Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15H12V17H8z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15H24V17H20z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15H18V17H14z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12,25H4a2.0023,2.0023,0,0,1-2-2V9A2.002,2.002,0,0,1,4,7h8a2.002,2.002,0,0,1,2,2v3H12V9H4V23h8V20h2v3A2.0023,2.0023,0,0,1,12,25Z"
  })), children);
})));
if (false) {}
const Reminder = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Reminder({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M30,23.3818l-2-1V20a6.0046,6.0046,0,0,0-5-5.91V12H21v2.09A6.0046,6.0046,0,0,0,16,20v2.3818l-2,1V28h6v2h4V28h6ZM28,26H16V24.6182l2-1V20a4,4,0,0,1,8,0v3.6182l2,1Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M28,6a2,2,0,0,0-2-2H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V6h4V8h2V6h8V8h2V6h4v6h2Z"
  })), children);
})));
if (false) {}
const ReminderMedical = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReminderMedical({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27,12v2h1v4a3,3,0,0,1-6,0V14h1V12H20v6a5.0083,5.0083,0,0,0,4,4.8989V24a4,4,0,0,1-8,0V21.8157a3,3,0,1,0-2,0V24a6,6,0,0,0,12,0V22.8989A5.0083,5.0083,0,0,0,30,18V12ZM15,18a1,1,0,1,1-1,1A1.0009,1.0009,0,0,1,15,18Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H22V2H20V4H12V2H10V4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2l4,0V26L6,26V6h4V8h2V6h8V8h2V6h4v4h2V6A2,2,0,0,0,26,4Z"
  })), children);
})));
if (false) {}
const RemoteConnection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RemoteConnection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,12c-5.2,0-9.5,4.3-9.5,9.5v.5H4V6h24v6h2v-6c0-1.1-.9-2-2-2H4c-1.1,0-2,.9-2,2v16c0,1.1.9,2,2,2h8.3c.4,1.5,1.2,2.9,2.2,4h-6.6v2h9.3c1.3.6,2.7,1,4.2,1,5.2,0,9.5-4.3,9.5-9.5s-4.3-9.5-9.5-9.5h0ZM21.5,29c-4.1,0-7.5-3.4-7.5-7.5s3.4-7.5,7.5-7.5,7.5,3.4,7.5,7.5-3.4,7.5-7.5,7.5ZM18.7,24.7l-1.4-1.4,2.3-2.3-2.3-2.3,1.4-1.4,3.7,3.7s-3.7,3.7-3.7,3.7ZM26,25h-4v-2h4v2Z"
  })), children);
})));
if (false) {}
const Renew = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Renew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10H6.78A11,11,0,0,1,27,16h2A13,13,0,0,0,6,7.68V4H4v8h8Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M20,22h5.22A11,11,0,0,1,5,16H3a13,13,0,0,0,23,8.32V28h2V20H20Z"
  })), children);
})));
if (false) {}
const Repeat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Repeat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z"
  })), children);
})));
if (false) {}
const RepeatOne = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RepeatOne({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M6,6H26.1719l-3.586-3.5859L24,1l6,6-6,6-1.4141-1.4141L26.1719,8H6v7H4V8A2.0024,2.0024,0,0,1,6,6Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4141,20.4141,5.8281,24H26V17h2v7a2.0024,2.0024,0,0,1-2,2H5.8281L9.414,29.5859,8,31,2,25l6-6Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19 17 11 15 11 15 12 13 12 13 14 15 14 15 19 13 19 13 21 19 21 19 19 17 19z"
  })), children);
})));
if (false) {}
const Replicate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Replicate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8h2V4a2.0021,2.0021,0,0,0-2-2H24V4h4Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H21V4H17z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M28 11H30V15H28z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v4H24V10a2.0023,2.0023,0,0,0-2-2H10V4h4V2H10A2.0023,2.0023,0,0,0,8,4V8H4a2.0023,2.0023,0,0,0-2,2V28a2.0023,2.0023,0,0,0,2,2H22a2.0023,2.0023,0,0,0,2-2V24h4a2.0023,2.0023,0,0,0,2-2V18ZM22,28H4V10H22Z"
  })), children);
})));
if (false) {}
const Reply = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Reply({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M28.88,30a1,1,0,0,1-.88-.5A15.19,15.19,0,0,0,15,22v6a1,1,0,0,1-.62.92,1,1,0,0,1-1.09-.21l-12-12a1,1,0,0,1,0-1.42l12-12a1,1,0,0,1,1.09-.21A1,1,0,0,1,15,4v6.11a17.19,17.19,0,0,1,15,17,16.34,16.34,0,0,1-.13,2,1,1,0,0,1-.79.86ZM14.5,20A17.62,17.62,0,0,1,28,26,15.31,15.31,0,0,0,13.91,12,1,1,0,0,1,13,11V6.41L3.41,16,13,25.59V21a1,1,0,0,1,1-1h.54Z"
  })), children);
})));
if (false) {}
const ReplyAll = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReplyAll({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M19,29a.9989.9989,0,0,1-.768-.36l-10-12a1,1,0,0,1,0-1.28l10-12A1,1,0,0,1,20,4v7.0325c7.0074.4629,11,5.86,11,14.9677a1,1,0,0,1-1.8.6c-2.8218-3.7623-5.3912-5.3463-9.2-5.5716V28a1,1,0,0,1-1,1ZM10.3016,16,18,25.238V20a1,1,0,0,1,1-1,12.7127,12.7127,0,0,1,9.8414,4.0909C28.0864,16.5553,24.6587,13,19,13a1,1,0,0,1-1-1V6.7618Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639,28.9182,1.2318,16.64a1,1,0,0,1,0-1.28L11.4638,3.0792,13,4.36,3.3016,16,13,27.638Z"
  })), children);
})));
if (false) {}
const RepoArtifact = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RepoArtifact({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V16h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H16v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V30h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H30z M23,26 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S24.7,26,23,26z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h10v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v5h2v-5 C30,8.9,29.1,8,28,8z"
  })), children);
})));
if (false) {}
const RepoSourceCode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RepoSourceCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6 21.4 27.2 25 27.2 25 23.6 28.6 25 30 30 25 25 20z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4 21.4 16.8 25 16.8 25 20.4 28.6 19 30 14 25 19 20z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H16l-3.4-3.4C12.2,4.2,11.7,4,11.2,4H4C2.9,4,2,4.9,2,6v20c0,1.1,0.9,2,2,2h7v-2H4V6h7.2l3.4,3.4l0.6,0.6H28v8h2v-8 C30,8.9,29.1,8,28,8z"
  })), children);
})));
if (false) {}
const Report = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Report({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H18V20H10z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H22V15H10z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H15V25H10z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
})));
if (false) {}
const ReportData = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ReportData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20H17V24H15z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H22V24H20z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14H12V24H10z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
})));
if (false) {}
const RequestQuote = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RequestQuote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M22,22v6H6V4H16V2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V22Z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M29.54,5.76l-3.3-3.3a1.6,1.6,0,0,0-2.24,0l-14,14V22h5.53l14-14a1.6,1.6,0,0,0,0-2.24ZM14.7,20H12V17.3l9.44-9.45,2.71,2.71ZM25.56,9.15,22.85,6.44l2.27-2.27,2.71,2.71Z"
  })), children);
})));
if (false) {}
const RequirementDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RequirementDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.1788,17.4959c0-2.8367,1.5301-4.6764,4.1606-4.6764,2.8025,0,4.0919,2.0631,4.0919,4.5217v.7221h-5.9658v.2235c0,1.2894.7392,2.1663,2.1834,2.1663,1.0833,0,1.7365-.5158,2.2867-1.2207l1.1863,1.3239c-.7392,1.0143-2.0459,1.6505-3.7137,1.6505-2.6475,0-4.2293-1.8397-4.2293-4.7109Zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152,0-1.9083.8597-1.9083,2.0975Z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.2694,22h-2.2693v-12h5.4154c2.1835,0,3.5416,1.4441,3.5416,3.7135,0,1.6504-.7565,2.9054-2.2349,3.4039l2.4584,4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247Zm3.1215-6.533c.8769,0,1.4097-.4813,1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227Z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
})));
if (false) {}
const RequirementUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RequirementUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.1788,17.4959c0-2.8367,1.5301-4.6764,4.1606-4.6764,2.8025,0,4.0919,2.0631,4.0919,4.5217v.7221h-5.9658v.2235c0,1.2894.7392,2.1663,2.1834,2.1663,1.0833,0,1.7365-.5158,2.2867-1.2207l1.1863,1.3239c-.7392,1.0143-2.0459,1.6505-3.7137,1.6505-2.6475,0-4.2293-1.8397-4.2293-4.7109Zm2.2867-.9284v.1377h3.6791v-.1548c0-1.2379-.6362-2.0803-1.7709-2.0803-1.152,0-1.9083.8597-1.9083,2.0975Z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9.2694,22h-2.2693v-12h5.4154c2.1835,0,3.5416,1.4441,3.5416,3.7135,0,1.6504-.7565,2.9054-2.2349,3.4039l2.4584,4.8826h-2.5271l-2.2349-4.6247h-2.1492v4.6247Zm3.1215-6.533c.8769,0,1.4097-.4813,1.4097-1.3581v-.7909c0-.8769-.5328-1.341-1.4097-1.341h-2.9227v3.4899h2.9227Z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const Reset = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Reset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M18,28A12,12,0,1,0,6,16v6.2L2.4,18.6,1,20l6,6,6-6-1.4-1.4L8,22.2V16H8A10,10,0,1,1,18,26Z"
  })), children);
})));
if (false) {}
const ResetAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ResetAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M27,8H6.83l3.58-3.59L9,3,3,9l6,6,1.41-1.41L6.83,10H27V26H7V19H5v7a2,2,0,0,0,2,2H27a2,2,0,0,0,2-2V10A2,2,0,0,0,27,8Z"
  })), children);
})));
if (false) {}
const Restart = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Restart({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
      d: "M13,9c0,2.8-2.2,5-5,5s-5-2.2-5-5s2.2-5,5-5h3.1L9.3,5.8L10,6.5l3-3l-3-3L9.3,1.2L11.1,3H8C4.7,3,2,5.7,2,9s2.7,6,6,6 s6-2.7,6-6H13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18A10,10,0,1,1,16,8h6.1821l-3.5844,3.5854L20,13l6-6L20,1,18.5977,2.414,22.1851,6H16A12,12,0,1,0,28,18Z"
  })), children);
})));
if (false) {}
const Restaurant = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Restaurant({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2H11V12H9z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M14,11a4,4,0,0,1-8,0V2H4v9a6,6,0,0,0,5,5.91V30h2V16.91A6,6,0,0,0,16,11V2H14Z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2H21V30h2V20h3a2,2,0,0,0,2-2V8A5.78,5.78,0,0,0,22,2Zm4,16H23V4.09c2.88.56,3,3.54,3,3.91Z"
  })), children);
})));
if (false) {}
const RestaurantFine = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RestaurantFine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M30,11.0005v-8a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1v8A6.0039,6.0039,0,0,0,23,16.91V28H19v2H29V28H25V16.91A6.0039,6.0039,0,0,0,30,11.0005Zm-10,0V4h8v7.0005a4,4,0,1,1-8,0Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12,2v9.02a3.9644,3.9644,0,0,1-3.96,3.96A4.0052,4.0052,0,0,1,4,11.02V2H2v9.02a5.9888,5.9888,0,0,0,5,5.8652V30H9V16.8953A5.9646,5.9646,0,0,0,14,11.02V2Z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M7 2H9V11.98H7z"
  })), children);
})));
if (false) {}
const Result = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Result({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H22V25H14z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H22V20H14z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z"
  })), children);
})));
if (false) {}
const ResultDraft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ResultDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7,19.3l-3-3c-0.4-0.4-1-0.4-1.4,0L16,25.6V30h4.4l9.3-9.3C30.1,20.3,30.1,19.7,29.7,19.3z M19.6,28H18v-1.6l5-5l1.6,1.6 L19.6,28z M26,21.6L24.4,20l1.6-1.6l1.6,1.6L26,21.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H18V20H14z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3h12V7h3v6h2V7c0-1.1-0.9-2-2-2h-3V4c0-1.1-0.9-2-2-2h-8c-1.1,0-2,0.9-2,2v1H7C5.9,5,5,5.9,5,7v21 c0,1.1,0.9,2,2,2h5v-2H7z M12,4h8v4h-8V4z"
  })), children);
})));
if (false) {}
const ResultNew = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ResultNew({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "26",
    r: "4"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M14 18H22V20H14z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M14 23H18V25H14z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3H22V7h3V18h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H18V28ZM12,4h8V8H12Z"
  })), children);
})));
if (false) {}
const ResultOld = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ResultOld({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13H12V15H10z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H22V15H14z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18H12V20H10z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23H12V25H10z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7,28V7h3v3H22V7h3v8h2V7a2,2,0,0,0-2-2H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2h9V28ZM12,4h8V8H12Z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M18,19v2.4131A6.996,6.996,0,1,1,24,32V30a5,5,0,1,0-4.5762-7H22v2H16V19Z"
  })), children);
})));
if (false) {}
const RetryFailed = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RetryFailed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M26.41 25 30 21.41 28.59 20 25 23.59 21.41 20 20 21.41 23.59 25 20 28.59 21.41 30 25 26.41 28.59 30 30 28.59 26.41 25z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M18,2A12.0351,12.0351,0,0,0,6,14v6.2L2.4,16.6,1,18l6,6,6-6-1.4-1.4L8,20.2V14a10,10,0,0,1,20,0v3h2V14A12.0351,12.0351,0,0,0,18,2Z"
  })), children);
})));
if (false) {}
const Return = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Return({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "m22,8v2c2.2061,0,4,1.7944,4,4s-1.7939,4-4,4h-12v-5l-6,6,6,6v-5h12c3.3086,0,6-2.6914,6-6s-2.6914-6-6-6Z"
  })), children);
})));
if (false) {}
const Review = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Review({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8 17.912 11.703 22 12.297 19 15 20 19 16 16.75 12 19 13 15 10 12.297 14.2 11.703 16 8z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7358,30,16,29l4-7h6a1.9966,1.9966,0,0,0,2-2V8a1.9966,1.9966,0,0,0-2-2H6A1.9966,1.9966,0,0,0,4,8V20a1.9966,1.9966,0,0,0,2,2h9v2H6a3.9993,3.9993,0,0,1-4-4V8A3.9988,3.9988,0,0,1,6,4H26a3.9988,3.9988,0,0,1,4,4V20a3.9993,3.9993,0,0,1-4,4H21.1646Z"
  })), children);
})));
if (false) {}
const Rewind_10 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rewind_10({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,22.13a2.84,2.84,0,0,1-1.28-.27,2.44,2.44,0,0,1-.89-.77,3.57,3.57,0,0,1-.52-1.25,7.69,7.69,0,0,1-.17-1.68,7.83,7.83,0,0,1,.17-1.68,3.65,3.65,0,0,1,.52-1.25,2.44,2.44,0,0,1,.89-.77,2.84,2.84,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.23,5.23,0,0,1,.7,2.93,5.23,5.23,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.63,22.13Zm0-1.22a1.07,1.07,0,0,0,1-.55A3.38,3.38,0,0,0,21,18.85V17.47a3.31,3.31,0,0,0-.29-1.5,1.23,1.23,0,0,0-2.06,0,3.31,3.31,0,0,0-.29,1.5v1.38a3.38,3.38,0,0,0,.29,1.51A1.06,1.06,0,0,0,19.63,20.91Z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10.63,22V20.82h2V15.63l-1.86,1-.55-1.06,2.32-1.3H14v6.5h1.78V22Z"
  })), children);
})));
if (false) {}
const Rewind_30 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rewind_30({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64,22.13a2.81,2.81,0,0,1-1.28-.27,2.36,2.36,0,0,1-.89-.77A3.39,3.39,0,0,1,17,19.84a7.12,7.12,0,0,1-.17-1.68A7.24,7.24,0,0,1,17,16.48a3.46,3.46,0,0,1,.52-1.25,2.36,2.36,0,0,1,.89-.77,2.81,2.81,0,0,1,1.28-.27,2.44,2.44,0,0,1,2.16,1,5.31,5.31,0,0,1,.7,2.93,5.31,5.31,0,0,1-.7,2.93A2.44,2.44,0,0,1,19.64,22.13Zm0-1.22a1,1,0,0,0,1-.55,3.24,3.24,0,0,0,.3-1.51V17.47a3.17,3.17,0,0,0-.3-1.5,1.22,1.22,0,0,0-2.05,0,3.18,3.18,0,0,0-.29,1.5v1.38a3.25,3.25,0,0,0,.29,1.51A1,1,0,0,0,19.64,20.91Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M12.62,17.42a1.46,1.46,0,0,0,1-.27.84.84,0,0,0,.31-.68v-.08a.94.94,0,0,0-.3-.74,1.2,1.2,0,0,0-.83-.27,1.65,1.65,0,0,0-.89.24,2.1,2.1,0,0,0-.68.68l-.93-.83a5.37,5.37,0,0,1,.44-.51,2.7,2.7,0,0,1,.54-.4,2.55,2.55,0,0,1,.7-.27,3.25,3.25,0,0,1,.87-.1,3.94,3.94,0,0,1,1.06.14,2.33,2.33,0,0,1,.82.4,1.91,1.91,0,0,1,.54.63,1.87,1.87,0,0,1,.18.83,2,2,0,0,1-.11.67,1.82,1.82,0,0,1-.32.52,1.79,1.79,0,0,1-.47.36,2.27,2.27,0,0,1-.57.2V18a2.34,2.34,0,0,1,.63.21,1.7,1.7,0,0,1,.51.38,1.89,1.89,0,0,1,.34.55,2.07,2.07,0,0,1,.12.73,2,2,0,0,1-.2.92,2,2,0,0,1-.58.72,2.66,2.66,0,0,1-.89.45,3.76,3.76,0,0,1-1.15.16,4.1,4.1,0,0,1-1-.11A3.1,3.1,0,0,1,11,21.7a2.76,2.76,0,0,1-.56-.45A4.22,4.22,0,0,1,10,20.7l1.07-.81a3.07,3.07,0,0,0,.28.42,1.94,1.94,0,0,0,.36.34,1.57,1.57,0,0,0,.45.22,2,2,0,0,0,.57.07,1.45,1.45,0,0,0,1-.3,1.12,1.12,0,0,0,.34-.85v-.08a1,1,0,0,0-.37-.8,1.78,1.78,0,0,0-1.06-.28h-.76V17.42Z"
  })), children);
})));
if (false) {}
const Rewind_5 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rewind_5({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M4,18A12,12,0,1,0,16,6H12V1L6,7l6,6V8h4A10,10,0,1,1,6,18Z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M18.58,15.58H15.13L15,18.15H15a4.83,4.83,0,0,1,.26-.45,1.59,1.59,0,0,1,.33-.35,1.53,1.53,0,0,1,.44-.23,2,2,0,0,1,.6-.08,2.54,2.54,0,0,1,.92.16,2.06,2.06,0,0,1,.74.48,2.28,2.28,0,0,1,.5.77,2.73,2.73,0,0,1,.18,1,2.87,2.87,0,0,1-.19,1.07,2.36,2.36,0,0,1-.55.84,2.44,2.44,0,0,1-.89.55,3.23,3.23,0,0,1-1.21.2,3.79,3.79,0,0,1-.94-.11,3,3,0,0,1-.74-.32,2.45,2.45,0,0,1-.55-.45,4.13,4.13,0,0,1-.41-.55l1.06-.81.27.41a1.82,1.82,0,0,0,.34.34,1.59,1.59,0,0,0,.43.22,1.52,1.52,0,0,0,.55.08,1.29,1.29,0,0,0,1-.36,1.41,1.41,0,0,0,.33-1V19.5a1.18,1.18,0,0,0-1.28-1.27,1.44,1.44,0,0,0-.77.18,1.94,1.94,0,0,0-.48.39l-1.19-.17.29-4.31h4.52Z"
  })), children);
})));
if (false) {}
const Rexx = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rexx({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,16l2.5,5h-2l-1.5-3-1.5,3h-2l2.5-5-2.5-5h2l1.5,3,1.5-3h2l-2.5,5ZM32,11h-2l-1.5,3-1.5-3h-2l2.5,5-2.5,5h2l1.5-3,1.5,3h2l-2.5-5,2.5-5ZM14,12.9761v-1.9761h-6v9.9761h6v-2h-4v-2h2v-2h-2v-2s4,0,4,0ZM6,13v2c0,1-.7,1.8-1.6,2l1.6,4h-2l-1.6-4h-.4v4H0v-10h4c1.1,0,2,.9,2,2ZM4,13h-2v2h2v-2Z"
  })), children);
})));
if (false) {}
const RightPanelClose = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RightPanelClose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), children);
})));
if (false) {}
const RightPanelCloseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RightPanelCloseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v20H4v-9h10.1699s-3.5801,3.5898-3.5801,3.5898l1.4102,1.4102,6-6-6-6-1.4102,1.4102,3.5801,3.5898H4V6Z"
  })), children);
})));
if (false) {}
const RightPanelOpen = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RightPanelOpen({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm20,0h6v20h-6V6Zm-18,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), children);
})));
if (false) {}
const RightPanelOpenFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RightPanelOpenFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,6v20c0,1.1045.8955,2,2,2h24c1.1045,0,2-.8955,2-2V6c0-1.1045-.8955-2-2-2H4c-1.1045,0-2,.8955-2,2Zm2,0h16v9h-10.1699s3.5798-3.5898,3.5798-3.5898l-1.4099-1.4102-6,6,6,6,1.4099-1.4102-3.5798-3.5898h10.1699v9H4V6Z"
  })), children);
})));
if (false) {}
const Road = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Road({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13H19V15H13z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4409,8,24.1687,3.45A2.009,2.009,0,0,0,22.2456,2H9.7544A2.0089,2.0089,0,0,0,7.8313,3.4507L6.5315,8H4v2H6v7a2.0025,2.0025,0,0,0,2,2v3h2V19H22v3h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM9.7544,4H22.2458l1.4285,5H8.3257ZM24,13H22v2h2v2H8V15h2V13H8V11H24Z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H4V30H2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V30H28z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21H17V24H15z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
})));
if (false) {}
const RoadWeather = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RoadWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M16,31H14v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091L8.5215,26.6384A3.9034,3.9034,0,0,1,6,23H8a1.8946,1.8946,0,0,0,1.2236,1.7659L12.7554,26.09A5.0226,5.0226,0,0,1,16,30.772Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M30,31H28v-.228a3.0135,3.0135,0,0,0-1.9468-2.8091l-3.5317-1.3245A3.9034,3.9034,0,0,1,20,23h2a1.8946,1.8946,0,0,0,1.2236,1.7659L26.7554,26.09A5.0226,5.0226,0,0,1,30,30.772Z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M11 13H17V15H11z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4409,8,22.1687,3.45A2.009,2.009,0,0,0,20.2456,2H7.7544A2.0089,2.0089,0,0,0,5.8313,3.4507L4.5315,8H2v2H4v7a2.0025,2.0025,0,0,0,2,2v2H8V19H20v2h2V19a2.0025,2.0025,0,0,0,2-2V10h2V8ZM7.7544,4H20.2458l1.4285,5H6.3257ZM22,13H20v2h2v2H6V15H8V13H6V11H22Z"
  })), children);
})));
if (false) {}
const Roadmap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Roadmap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0023,2.0023,0,0,1-2-2V24a2.0023,2.0023,0,0,1,2-2h8a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,12,30ZM4,24v4h8V24Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H12a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2v4A2.0023,2.0023,0,0,1,28,20ZM12,14v4H28V14Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H16a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,16,10ZM4,4V8H16V4Z"
  })), children);
})));
if (false) {}
const Rocket = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rocket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34 19H17.65V21H6.34z",
    transform: "rotate(-45 11.995 20.002)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M17,30a1,1,0,0,1-.37-.07,1,1,0,0,1-.62-.79l-1-7,2-.28.75,5.27L21,24.52V17a1,1,0,0,1,.29-.71l4.07-4.07A8.94,8.94,0,0,0,28,5.86V4H26.14a8.94,8.94,0,0,0-6.36,2.64l-4.07,4.07A1,1,0,0,1,15,11H7.48L4.87,14.26l5.27.75-.28,2-7-1a1,1,0,0,1-.79-.62,1,1,0,0,1,.15-1l4-5A1,1,0,0,1,7,9h7.59l3.77-3.78A10.92,10.92,0,0,1,26.14,2H28a2,2,0,0,1,2,2V5.86a10.92,10.92,0,0,1-3.22,7.78L23,17.41V25a1,1,0,0,1-.38.78l-5,4A1,1,0,0,1,17,30Z"
  })), children);
})));
if (false) {}
const Rotate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rotate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M17.91,26.82l.35,2a12.9,12.9,0,0,0,4.24-1.54l-1-1.73A10.88,10.88,0,0,1,17.91,26.82Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M24.42,23.07,26,24.35a13,13,0,0,0,2.24-3.91l-1.87-.68A11,11,0,0,1,24.42,23.07Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5,27.25a12.9,12.9,0,0,0,4.24,1.54l.35-2a10.88,10.88,0,0,1-3.59-1.3Z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67,19.76l-1.87.68A13,13,0,0,0,6,24.35l.32-.26,1.22-1h0a11,11,0,0,1-1.91-3.31Z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M29,16a12.85,12.85,0,0,0-.8-4.44l-1.87.68A11.18,11.18,0,0,1,27,16Z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7.65a13,13,0,0,0-20,0V4H4v8h8V10H6.81A11,11,0,0,1,24.42,8.93Z"
  })), children);
})));
if (false) {}
const WatsonHealthRotate_180 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthRotate_180({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0913,26.8235l-.3467,1.968a12.8956,12.8956,0,0,1-4.24-1.5418l1-1.7307A10.9086,10.9086,0,0,0,14.0913,26.8235Z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5767,23.0682,6.0449,24.3533a12.9811,12.9811,0,0,1-2.25-3.9112l1.8775-.6834A10.9808,10.9808,0,0,0,7.5767,23.0682Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4951,27.25a12.8956,12.8956,0,0,1-4.24,1.5418l-.3467-1.968a10.9086,10.9086,0,0,0,3.5869-1.3045Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3271,19.7587l1.8775.6834a12.9811,12.9811,0,0,1-2.2495,3.9112l-.3115-.2614-1.22-1.0237h0a10.9822,10.9822,0,0,0,1.9038-3.3093Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6616,5.2559c-.1592.0346-.3144.08-.4712.1215-.2131.0562-.4258.1138-.6335.1822-.1643.0547-.325.1167-.4859.1782-.1926.0742-.3835.1509-.57.2349-.1611.0727-.3193.15-.4763.23q-.2677.1363-.5262.2867c-.153.0893-.3046.18-.4531.2758-.1679.1089-.3308.2242-.4922.3413-.1406.1026-.2817.2037-.417.3125-.1616.1294-.3156.2676-.47.4063-.1225.11-.2478.2168-.3652.332-.1668.1636-.3223.3379-.4785.5117A10.9438,10.9438,0,0,0,5,16H3A12.9363,12.9363,0,0,1,6.05,7.65l-.0047-.0039c.0918-.1094.197-.2061.2925-.3125.1841-.2051.3672-.41.5635-.603.1382-.1358.2856-.2613.43-.3907.1831-.1645.3657-.3286.5581-.4824.1592-.1279.3244-.2466.4895-.3667.1921-.14.3855-.2768.5854-.4062.1743-.1128.3523-.2188.5322-.3238q.3081-.1786.6253-.3408c.1846-.0942.37-.1846.56-.27.2224-.1.449-.1914.678-.2793.1894-.0723.3777-.1455.5713-.209.2463-.0815.498-.1494.7507-.2163.1848-.0493.3674-.1025.5554-.1431.29-.0634.5865-.1074.8833-.1508.159-.023.3145-.0552.4754-.0728A12.9331,12.9331,0,0,1,26,7.7031V4h2v8H20V10h5.1885A10.961,10.961,0,0,0,16,5a11.1114,11.1114,0,0,0-1.189.0669c-.1362.0146-.268.042-.4026.0615C14.1575,5.165,13.907,5.2026,13.6616,5.2559Z"
  })), children);
})));
if (false) {}
const WatsonHealthRotate_360 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthRotate_360({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M25.95,7.65l.0047-.0039c-.0918-.1094-.197-.2061-.2925-.3125-.1841-.2051-.3672-.41-.5635-.603-.1382-.1358-.2856-.2613-.43-.3907-.1831-.1645-.3657-.3286-.5581-.4824-.1592-.1279-.3244-.2466-.4895-.3667-.1921-.14-.3855-.2768-.5854-.4062-.1743-.1128-.3523-.2188-.5322-.3238q-.3081-.1786-.6253-.3408c-.1846-.0942-.37-.1846-.56-.27-.2224-.1-.449-.1914-.678-.2793-.1894-.0723-.3777-.1455-.5713-.209-.2463-.0815-.498-.1494-.7507-.2163-.1848-.0493-.3674-.1025-.5554-.1431-.29-.0634-.5865-.1074-.8833-.1508-.159-.023-.3145-.0552-.4754-.0728A12.9331,12.9331,0,0,0,6,7.7031V4H4v8h8V10H6.8115A10.961,10.961,0,0,1,16,5a11.1114,11.1114,0,0,1,1.189.0669c.1362.0146.268.042.4026.0615.2509.0366.5014.0742.7468.1275.1592.0346.3144.08.4712.1215.2131.0562.4258.1138.6335.1822.1643.0547.325.1167.4859.1782.1926.0742.3835.1509.5705.2349.1611.0727.3193.15.4763.23q.2677.1363.5262.2867c.153.0893.3046.18.4531.2758.1679.1089.3308.2242.4922.3413.1406.1026.2817.2037.417.3125.1616.1294.3156.2676.47.4063.1225.11.2478.2168.3652.332.1668.1636.3223.3379.4785.5117A10.9928,10.9928,0,1,1,5,16H3A13,13,0,1,0,25.95,7.65Z"
  })), children);
})));
if (false) {}
const RotateClockwise = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateClockwise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30ZM16,16V28H28.0012L28,16Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z"
  })), children);
})));
if (false) {}
const RotateClockwiseAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateClockwiseAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30ZM4,16V28H16.0012L16,16Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z"
  })), children);
})));
if (false) {}
const RotateClockwiseAltFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateClockwiseAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H4a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,16,30Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M30,15l-1.41-1.41L26,16.17V11a7.0078,7.0078,0,0,0-7-7H14V6h5a5.0057,5.0057,0,0,1,5,5v5.17l-2.59-2.58L20,15l5,5Z"
  })), children);
})));
if (false) {}
const RotateClockwiseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateClockwiseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H16a2.0023,2.0023,0,0,1-2-2V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,28,30Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2,13.59,3.41,16.17,6H11a7.0078,7.0078,0,0,0-7,7v5H6V13a5.0057,5.0057,0,0,1,5-5h5.17l-2.58,2.59L15,12l5-5Z"
  })), children);
})));
if (false) {}
const RotateCounterclockwise = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateCounterclockwise({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28ZM4,16,3.9988,28H16V16Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z"
  })), children);
})));
if (false) {}
const RotateCounterclockwiseAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateCounterclockwiseAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Zm2-12-.0012,12H28V16Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z"
  })), children);
})));
if (false) {}
const RotateCounterclockwiseAltFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateCounterclockwiseAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M14,28V16a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H16A2.0023,2.0023,0,0,1,14,28Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M2,15l1.41-1.41L6,16.17V11a7.0078,7.0078,0,0,1,7-7h5V6H13a5.0057,5.0057,0,0,0-5,5v5.17l2.59-2.58L12,15,7,20Z"
  })), children);
})));
if (false) {}
const RotateCounterclockwiseFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RotateCounterclockwiseFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M2,28V16a2.0023,2.0023,0,0,1,2-2H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,28Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M17,2l1.41,1.41L15.83,6H21a7.0078,7.0078,0,0,1,7,7v5H26V13a5.0057,5.0057,0,0,0-5-5H15.83l2.58,2.59L17,12,12,7Z"
  })), children);
})));
if (false) {}
const Router = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Router({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M21 7 16 2 11 7 12.409 8.419 15 5.847 15 13 17 13 17 5.794 19.591 8.419 21 7z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), children);
})));
if (false) {}
const RouterVoice = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RouterVoice({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4289,5.8227v1.63a1.1269,1.1269,0,0,1-.6767,1.026l-1.39.5967A1.1218,1.1218,0,0,1,9.14,8.8424L7.3208,7.0233a1.1165,1.1165,0,0,1,.0125-1.579l.0348-.0328c7.393-6.527,14.6913-2.0374,17.2127-.0473a1.1166,1.1166,0,0,1,.1746,1.5693,1.1011,1.1011,0,0,1-.0873.0971L22.9108,8.7878a1.1114,1.1114,0,0,1-1.2225.2329l-1.39-.5967a1.1112,1.1112,0,0,1-.68-1.0223v-1.63S15.9726,3.0648,12.4289,5.8227Z"
  })), children);
})));
if (false) {}
const RouterWifi = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RouterWifi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13.5",
    r: "1.5"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5356,10.4648a5,5,0,0,0-7.0717,0L11.05,9.0508a6.9992,6.9992,0,0,1,9.9,0Z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0713,6.929a10,10,0,0,0-14.1426,0L7.5146,5.5144a12.0011,12.0011,0,0,1,16.9708,0Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25 16 30 11 25 12.409 23.581 15 26.153 15 19 17 19 17 26.206 19.591 23.581 21 25z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M24 11 19 16 24 21 25.419 19.591 22.847 17 30 17 30 15 22.794 15 25.419 12.409 24 11z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11 13 16 8 21 6.581 19.591 9.153 17 2 17 2 15 9.206 15 6.581 12.409 8 11z"
  })), children);
})));
if (false) {}
const Row = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Row({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24H28V26H4z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M26,18H6V14H26v4m2,0V14a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2Z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H28V8H4z"
  })), children);
})));
if (false) {}
const RowCollapse = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RowCollapse({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20H6a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V22A2,2,0,0,0,26,20Zm0,6H6V22H26Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.828 19.586 10.414 21 9 16 4 11 9 12.414 10.414 15 7.828 15 14 4 14 4 16 28 16 28 14 17 14 17 7.828z"
  })), children);
})));
if (false) {}
const RowDelete = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RowDelete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30H4a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H24a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,24,30ZM4,22H3.9985L4,28H24V22Z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.41 28.59 2 25 5.59 21.41 2 20 3.41 23.59 7 20 10.59 21.41 12 25 8.41 28.59 12 30 10.59 26.41 7 30 3.41z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M4,14V8H18V6H4A2.0023,2.0023,0,0,0,2,8v6a2.0023,2.0023,0,0,0,2,2H26V14Z"
  })), children);
})));
if (false) {}
const RowExpand = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RowExpand({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M4 18 15 18 15 24.172 12.414 21.586 11 23 16 28 21 23 19.586 21.586 17 24.172 17 18 28 18 28 16 4 16 4 18z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,6H6V6H26Z"
  })), children);
})));
if (false) {}
const RowInsert = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RowInsert({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H10a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12ZM10,4v6H28V4Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H10a2.0021,2.0021,0,0,1-2-2V22a2.0021,2.0021,0,0,1,2-2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,30ZM10,22v6H28V22Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16 3.414 10.414 2 11.828 6.172 16 2 20.172 3.414 21.586 9 16z"
  })), children);
})));
if (false) {}
const Rss = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rss({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M8,18c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6C14,20.7,11.3,18,8,18z M8,28c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4 C12,26.2,10.2,28,8,28z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24h-2C28,13,19,4,8,4V2C20.1,2,30,11.9,30,24z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M22,24h-2c0-6.6-5.4-12-12-12v-2C15.7,10,22,16.3,22,24z"
  })), children);
})));
if (false) {}
const Rule = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Rule({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16H22V18H10z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H22V12H10z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30,9.8242,26.7071A10.9815,10.9815,0,0,1,4,17V4A2.0022,2.0022,0,0,1,6,2H26a2.0022,2.0022,0,0,1,2,2V17a10.9815,10.9815,0,0,1-5.8242,9.7069ZM6,4V17a8.9852,8.9852,0,0,0,4.7656,7.9423L16,27.7333l5.2344-2.791A8.9852,8.9852,0,0,0,26,17V4Z"
  })), children);
})));
if (false) {}
const RuleCancelled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleCancelled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M30,24a6,6,0,1,0-6,6A6.0066,6.0066,0,0,0,30,24Zm-2,0a3.9521,3.9521,0,0,1-.5669,2.019L21.981,20.5669A3.9529,3.9529,0,0,1,24,20,4.0045,4.0045,0,0,1,28,24Zm-8,0a3.9521,3.9521,0,0,1,.5669-2.019l5.4521,5.4521A3.9529,3.9529,0,0,1,24,28,4.0045,4.0045,0,0,1,20,24Z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7334l-5.2344-2.791A8.9858,8.9858,0,0,1,4,17V4H24l0,11h2L26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L14,30Z"
  })), children);
})));
if (false) {}
const RuleDataQuality = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleDataQuality({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: "1",
    height: "1",
    x: "0",
    y: "0",
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,28.6l-2.8-2.8C27.7,25,28,24,28,23c0-2.8-2.2-5-5-5s-5,2.2-5,5s2.2,5,5,5c1,0,2-0.3,2.8-0.8l2.8,2.8 L30,28.6z M20,23c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S20,24.7,20,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,27.7l-5.2-2.8C5.8,23.4,4,20.3,4,17V4h20v11h2V4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7L14,30 V27.7z"
  })))), children);
})));
if (false) {}
const RuleDraft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleDraft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M29.707,19.293l-3-3a.9994.9994,0,0,0-1.414,0L16,25.5859V30h4.4141l9.2929-9.293A.9994.9994,0,0,0,29.707,19.293ZM19.5859,28H18V26.4141l5-5L24.5859,23ZM26,21.5859,24.4141,20,26,18.4141,27.5859,20Z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H18V18H8z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
})));
if (false) {}
const RuleFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 16H23V18H9z",
    "data-icon-path": "inner-path"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M9 10H23V12H9z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2.0023,2.0023,0,0,0,4,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L16,30l6.1758-3.293A10.9814,10.9814,0,0,0,28,17V4A2.0023,2.0023,0,0,0,26,2ZM23,18H9V16H23Zm0-6H9V10H23Z"
  })), children);
})));
if (false) {}
const RuleLocked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleLocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M28,22v-3c0-2.2-1.8-4-4-4s-4,1.8-4,4v3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2v-5C30,22.9,29.1,22,28,22z M22,19c0-1.1,0.9-2,2-2s2,0.9,2,2v3h-4V19z M20,29v-5h8v5H20z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v8h2V4z"
  })), children);
})));
if (false) {}
const RulePartial = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RulePartial({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M23,16c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S26.9,16,23,16z M23,28V18c2.8,0,5,2.2,5,5S25.8,28,23,28z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4c0-1.1-0.9-2-2-2H4C2.9,2,2,2.9,2,4v13c0,4.1,2.2,7.8,5.8,9.7l5.2,2.8v-2.3l-4.2-2.3C5.8,23.4,4,20.3,4,17V4h20v9h2V4z"
  })), children);
})));
if (false) {}
const RuleTest = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleTest({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,23,30Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,23,18Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M26 24.586 24 22.586 24 20 22 20 22 23.414 24.586 26 26 24.586z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H14V18H8z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H20V12H8z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V17a10.9814,10.9814,0,0,0,5.8242,9.707L13,29.4668V27.2L8.7656,24.9424A8.9858,8.9858,0,0,1,4,17V4H24v9h2Z"
  })), children);
})));
if (false) {}
const RuleGroupingDataQuality = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RuleGroupingDataQuality({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M31,29.5829l-2.8325-2.8306c.5237-.7905.8325-1.7354.8325-2.7524,0-2.7568-2.2432-5-5-5s-5,2.2432-5,5,2.2432,5,5,5c1.0171,0,1.9619-.3086,2.7524-.8325l2.8306,2.8325,1.417-1.417ZM21,23.9999c0-1.6543,1.3457-3,3-3s3,1.3457,3,3-1.3457,3-3,3-3-1.3457-3-3ZM28.42,6.9999H10.58c-.87,0-1.58.7-1.58,1.57v12.2201c0,3.19.27,6.12,3.11,7.62l4.89,2.59v-2.26l-3.95-2.09c-2.19-1.16-2.05-3.41-2.05-5.86v-11.7901h17v8.0001h2v-8.4301c0-.87-.71-1.57-1.58-1.57ZM21.42.9999H3.58c-.87,0-1.58.7-1.58,1.57v12.22c0,3.19.27,6.12,3.11,7.62l1.89,1v-2.2599l-.95-.5c-2.19-1.16-2.05-3.41-2.05-5.86V2.9999h17v2h2v-2.43c0-.87-.71-1.57-1.58-1.57ZM24,13h-11v-2h11v2ZM22,17h-9v-2h9v2Z"
  })), children);
})));
if (false) {}
const Ruler = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Ruler({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M29,10H3a1,1,0,0,0-1,1V21a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V11A1,1,0,0,0,29,10ZM28,20H4V12H8v4h2V12h5v4h2V12h5v4h2V12h4Z"
  })), children);
})));
if (false) {}
const RulerAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RulerAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M29.41,21.67,10.34,2.58a2,2,0,0,0-2.83,0L2.59,7.51a2,2,0,0,0,0,2.82L21.66,29.42a2,2,0,0,0,1.42.58,2,2,0,0,0,1.41-.58l4.92-4.93A2,2,0,0,0,29.41,21.67ZM23.08,28,4,8.92,8.92,4l3.79,3.79L10.46,10l1.41,1.41L14.12,9.2l4.13,4.13L16,15.58,17.42,17l2.25-2.25,4.13,4.13-2.25,2.25L23,22.54l2.25-2.25L28,23.08Z"
  })), children);
})));
if (false) {}
const Run = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Run({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16a6,6,0,1,1-6,6,6,6,0,0,1,6-6m0-2a8,8,0,1,0,8,8,8,8,0,0,0-8-8Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2h4V26H6V12H28V6A2,2,0,0,0,26,4ZM6,10V6H26v4Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19 19 25 24 22 19 19z"
  })), children);
})));
if (false) {}
const RunMirror = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RunMirror({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M9 19 9 25 14 22z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16c3.3,0,6,2.7,6,6s-2.7,6-6,6s-6-2.7-6-6S7.7,16,11,16 M11,14c-4.4,0-8,3.6-8,8s3.6,8,8,8s8-3.6,8-8S15.4,14,11,14 L11,14z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M4,6v6h22v14h-4v2h4c1.1,0,2-0.9,2-2V6c0-1.1-0.9-2-2-2H6C4.9,4,4,4.9,4,6z M6,10V6h20v4H6z"
  })), children);
})));
if (false) {}
const RunViewIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function RunViewIcon({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28.48,14.1201L8.48,3.1201c-.1499-.0801-.3101-.1201-.48-.1201-.55,0-1,.4502-1,1v11h2V5.6899l16.9199,9.3101-7.04,3.8799,1.4702,1.4702,8.1299-4.4702c.1699-.0996.3-.23.3999-.3999.2603-.48.0901-1.0898-.3999-1.3599ZM13.9748,26.0001h2.0254v-2h-2v-1.5c0-.0276-.0037-.0542-.0042-.0818l2.7112-2.7112-1.4141-1.4141-1.8374,1.8374c-.8876-1.8481-2.7725-3.1304-4.9556-3.1304s-4.068,1.2822-4.9556,3.1304l-1.8374-1.8374-1.4141,1.4141,2.7112,2.7112c-.0005.0276-.0042.0542-.0042.0818v1.5H1.0002v2h2.0254c.0398.4397.1337.8632.2712,1.2671l-2.8513,1.9009,1.1094,1.6641,2.7219-1.8147c1.0098,1.2104,2.5278,1.9827,4.2234,1.9827s3.2136-.7722,4.2234-1.9827l2.7219,1.8147,1.1094-1.6641-2.8513-1.9009c.1376-.4039.2314-.8274.2712-1.2671ZM8.5002,19.0001c1.3909,0,2.585.8218,3.1489,2h-6.2979c.564-1.1782,1.7581-2,3.1489-2ZM8.5002,29.0001c-1.9297,0-3.5-1.5703-3.5-3.5v-2.5h7v2.5c0,1.9297-1.5703,3.5-3.5,3.5Z"
  })), children);
})));
if (false) {}
const Running = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Running({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m21.707,20.293l-5-5c-.1951-.1953-.451-.293-.707-.293s-.512.0977-.707.293L2,28.5859l1.4143,1.4141,12.5857-12.5859,3.5857,3.5859-5.5857,5.5859,1.4143,1.4141,2.292-2.292,4.0007-4.001c.1953-.1953.293-.4512.293-.707s-.0977-.5117-.293-.707Z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m28.5859,9l-5.5859,5.5859-6.0012-6.0015c-.392-.3918-.9073-.5865-1.422-.5845-.5096.002-1.0185.1968-1.4063.5845l-6.1704,6.1753,1.4143,1.4141,6.1704-6.1748,6.7083,6.708c.1951.1953.4512.293.707.293s.512-.0977.707-.293l6.293-6.293-1.4141-1.4141Z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5,9c-1.9299,0-3.5-1.5701-3.5-3.5s1.5701-3.5,3.5-3.5,3.5,1.5701,3.5,3.5-1.5701,3.5-3.5,3.5Zm0-5c-.8271,0-1.5.6729-1.5,1.5s.6729,1.5,1.5,1.5,1.5-.6729,1.5-1.5-.6729-1.5-1.5-1.5Z"
  })), children);
})));
if (false) {}
const QS = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QS({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H14v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,23Z"
  })), children);
})));
if (false) {}
const QSAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QSAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M24 9 22 9 22 7 20 7 20 9 18 9 18 11 20 11 20 17 22 17 22 11 24 11 24 9z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M14,23H8V21h6V17H10a2,2,0,0,1-2-2V11a2,2,0,0,1,2-2h6v2H10v4h4a2,2,0,0,1,2,2v4A2,2,0,0,1,14,23Z"
  })), children);
})));
if (false) {}
const SailboatCoastal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SailboatCoastal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7808,26,25.97,21.2422A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422L7.2192,26H2v2H30V26ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15ZM22.7192,26H9.2808l-1-4H23.7192Z"
  })), children);
})));
if (false) {}
const SailboatOffshore = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SailboatOffshore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9692,25H9.0308l-.75-3H23.7192l-.75,3h2.0616l.9394-3.7578A1,1,0,0,0,25,20H20V17h5a1,1,0,0,0,.9082-1.4189l-6-13a1.0006,1.0006,0,0,0-1.7021-.19L8.2075,15.3906A1,1,0,0,0,9,17h9v3H7a1,1,0,0,0-.97,1.2422ZM20,7.5527,23.437,15H20ZM11.0308,15,18,5.94V15Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9058,25.751A2.998,2.998,0,0,1,24,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,20,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,16,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,12,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,8,28a2.998,2.998,0,0,1-2.9058-2.249l-1.9365.498A4.9965,4.9965,0,0,0,8,30a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,24,30a4.9965,4.9965,0,0,0,4.8423-3.751Z"
  })), children);
})));
if (false) {}
const SalesOps = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SalesOps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "m30,6v-2h-3v-2h-2v2h-1c-1.1028,0-2,.8975-2,2v2c0,1.1025.8972,2,2,2h4v2h-6v2h3v2h2v-2h1c1.1028,0,2-.8975,2-2v-2c0-1.1025-.8972-2-2-2h-4v-2h6Z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m24,20v2h2.5859l-3.5857,3.5859-2.2917-2.293c-.1875-.1875-.4419-.293-.707-.293h-.0015c-.2651,0-.5183.1055-.7058.293l-5.2942,5.293,1.4143,1.4141,4.5867-4.5859,2.2917,2.293c.1875.1875.4419.293.7073.293.2651,0,.5195-.1055.707-.293l4.293-4.293v2.5859h2v-6h-6Z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m4,30h-2v-5c0-3.8599,3.1401-7,7-7h6c1.9885,0,3.8901.8502,5.217,2.3328l-1.4902,1.334c-.948-1.0592-2.3064-1.6667-3.7268-1.6667h-6c-2.7571,0-5,2.243-5,5v5Z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m12,16c3.866,0,7-3.134,7-7s-3.134-7-7-7-7,3.134-7,7,3.134,7,7,7Zm0-12c2.7615,0,5,2.2385,5,5s-2.2385,5-5,5-5-2.2385-5-5c.0032-2.7601,2.2399-4.9968,5-5Z"
  })), children);
})));
if (false) {}
const SankeyDiagram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SankeyDiagram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M28,2V8.0439c-1.9634.1968-6.3162,1.2325-10.5637,6.2764-.198-.2768-.3982-.5464-.5882-.8506C11.9736,5.6714,6.3191,4.2759,4,4.042V2H2V30H4V26.0464a14.8661,14.8661,0,0,0,9.9185-3.96C18.47,27.46,25.2363,28.0381,27.9341,28.0381c.0244,0,.0422-.001.0659-.001V30h2V2Zm0,8.0552v9.99a12.8834,12.8834,0,0,1-9.2756-4.1328C22.5032,11.2666,26.2915,10.26,28,10.0552ZM15.1519,14.53c.3242.5185.663.9907,1.0078,1.4409-.3384.4741-.6753.9707-1.0078,1.5029a16.1346,16.1346,0,0,1-1.0313,1.4531c-.0825-.1372-.1675-.27-.2466-.4126C9.3279,10.3315,5.7871,8.4438,4,8.0684V6.0508C5.9932,6.2905,10.8228,7.6035,15.1519,14.53ZM4,24.0488V10.1406c1.3254.4644,4.2034,2.2847,8.126,9.3448.1894.3413.396.6523.6.9667A12.8784,12.8784,0,0,1,4,24.0488Zm11.3179-3.4209a18.0563,18.0563,0,0,0,1.53-2.0937c.2212-.354.4454-.67.6687-.9951A14.8686,14.8686,0,0,0,28,22.0425v3.9863C25.67,26.019,19.374,25.5088,15.3179,20.6279Z"
  })), children);
})));
if (false) {}
const SankeyDiagramAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SankeyDiagramAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M30,2H2V16H8.1113a7.0359,7.0359,0,0,1,3.13.7393L15.7637,19l-4.522,2.2607A7.0359,7.0359,0,0,1,8.1113,22H2v8H9.2231a9.0446,9.0446,0,0,0,4.0249-.95L21.87,24.7393A7.0359,7.0359,0,0,1,25,24h5V14H25a7.0359,7.0359,0,0,1-3.13-.7393L15.3481,10H30ZM8,4H24V8H8ZM4,4H6V14H4ZM4,24H6v4H4Zm16.9751-1.05-8.6216,4.3105A7.0359,7.0359,0,0,1,9.2231,28H8V24h.1113a9.0446,9.0446,0,0,0,4.0249-.95L18,20.1182l1.8638.9316a9.0446,9.0446,0,0,0,4.0249.95H24v.0586A9.0515,9.0515,0,0,0,20.9751,22.95ZM28,22H26V16h2ZM12.3535,10.7393l8.6216,4.31A9.0515,9.0515,0,0,0,24,15.9414V20h-.1113a7.0359,7.0359,0,0,1-3.13-.7393l-8.6221-4.31A9.0446,9.0446,0,0,0,8.1113,14H8V10H9.2231A7.0359,7.0359,0,0,1,12.3535,10.7393ZM28,8H26V4h2Z"
  })), children);
})));
if (false) {}
const Sap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Sap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M29,8h-6.1843c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157,2H4c-1.1046,0-2,.8954-2,2v12c0,1.1046.8954,2,2,2h1.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h4.1843c.2653,0,.5197-.1054.7073-.293l14-14c.6299-.6299.1836-1.707-.7073-1.707ZM20,8c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1ZM8,24c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1ZM14.5857,22h-3.77c-.4141-1.1611-1.5137-2-2.8157-2s-2.4016.8389-2.8157,2h-1.1843v-12h13.1843c.4141,1.1611,1.5137,2,2.8157,2s2.4016-.8389,2.8157-2h3.77s-12,12-12,12Z"
  })), children);
})));
if (false) {}
const Satellite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Satellite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9141,16.5l2.7929-2.793a.9994.9994,0,0,0,0-1.414L23.4141,10,25.5,7.9141,28.5859,11,30,9.5859,22.4141,2,21,3.4141,24.0859,6.5,22,8.5859,19.707,6.293a.9994.9994,0,0,0-1.414,0L15.5,9.0859,8.707,2.293a.9994.9994,0,0,0-1.414,0l-5,5a.9994.9994,0,0,0,0,1.414L9.0859,15.5,6.293,18.293a.9994.9994,0,0,0,0,1.414L8.5859,22,6.5,24.0859,3.4141,21,2,22.4141,9.5859,30,11,28.5859,7.9141,25.5,10,23.4141l2.293,2.2929a.9995.9995,0,0,0,1.414,0L16.5,22.9141l6.793,6.7929a.9995.9995,0,0,0,1.414,0l5-5a.9994.9994,0,0,0,0-1.414ZM4.4141,8,8,4.4141,10.0859,6.5,6.5,10.0859Zm3.5,3.5L11.5,7.9141,14.0859,10.5,10.5,14.0859ZM13,23.5859,8.4141,19,19,8.4141,23.5859,13ZM17.9141,21.5,21.5,17.9141,24.0859,20.5,20.5,24.0859ZM24,27.5859,21.9141,25.5,25.5,21.9141,27.5859,24Z"
  })), children);
})));
if (false) {}
const SatelliteRadar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SatelliteRadar({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14H28A10.0113,10.0113,0,0,0,18,4V2A12.0137,12.0137,0,0,1,30,14Z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14H24a6.0067,6.0067,0,0,0-6-6V6A8.0092,8.0092,0,0,1,26,14Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28V24.96a9.9124,9.9124,0,0,0,7.3179-2.208,1.8482,1.8482,0,0,0,.6777-1.3344,1.8,1.8,0,0,0-.5239-1.36L18.4141,15,21,12.4141,19.5859,11,17,13.5859,11.9419,8.5273a1.8145,1.8145,0,0,0-1.36-.5229,1.845,1.845,0,0,0-1.3339.6782,9.9566,9.9566,0,0,0-.5127,11.95L6.2793,28H2v2H30V28ZM10.68,10.0938,21.9058,21.32A8.0011,8.0011,0,0,1,10.68,10.0938ZM14,28H8.3875l1.8757-5.627A9.9894,9.9894,0,0,0,14,24.5435Z"
  })), children);
})));
if (false) {}
const SatelliteWeather = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SatelliteWeather({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5,12H19a4,4,0,0,1,0-8h.0835A4.7864,4.7864,0,0,1,23,2a4.9816,4.9816,0,0,1,4.6543,3.2034A3.4667,3.4667,0,0,1,30,8.5,3.5041,3.5041,0,0,1,26.5,12ZM19,6a2,2,0,0,0,0,4h7.5A1.5017,1.5017,0,0,0,28,8.5a1.4855,1.4855,0,0,0-1.2778-1.4739L26.061,6.927l-.1616-.6487a2.9568,2.9568,0,0,0-5.4873-.7121L20.1143,6Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M13,28V24.8882a7.9363,7.9363,0,0,0,4.707-2.2818.9995.9995,0,0,0,0-1.414L13.4644,16.95,16,14.4141,14.5859,13,12.05,15.5356,7.8076,11.293a.9994.9994,0,0,0-1.414,0,7.9993,7.9993,0,0,0,0,11.3134c.1621.1622.3327.3125.5058.459L4.4321,28H2v2H30V28Zm-2,0H6.6685L8.59,24.1567A7.8927,7.8927,0,0,0,11,24.873ZM7.8076,21.1924a6.0036,6.0036,0,0,1-.6489-7.72l8.3686,8.3681a6.0026,6.0026,0,0,1-7.72-.6484Z"
  })), children);
})));
if (false) {}
const SatisfyDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SatisfyDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.3945,19.5537c0-1.8433,1.3953-2.7563,3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337,0-1.6194.5168-2.05,1.137l-1.3093-1.1714c.6545-1.0337,1.7056-1.7228,3.5144-1.7228,2.429,0,3.7209,1.1543,3.7209,3.2042v4.2379h.896v1.7572h-1.2231c-.9475,0-1.5332-.6201-1.6711-1.5504h-.1033c-.293,1.1542-1.2749,1.7572-2.6187,1.7572-1.8259,0-2.8596-1.0509-2.8596-2.6531Zm5.3624-.2412v-1.1886h-1.4126c-1.1541,0-1.7227.3962-1.7227,1.1025v.2928c0,.7235.4995,1.0853,1.3608,1.0853.9819,0,1.7744-.4479,1.7744-1.2921Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6195,20.2084l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,30H4c-1.1046,0-2-.8954-2-2V4c0-1.1046.8954-2,2-2h24c1.1046,0,2,.8954,2,2v24c0,1.1046-.8954,2-2,2Zm-24-2h24V4H4v24Z"
  })), children);
})));
if (false) {}
const SatisfyUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SatisfyUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m17.3934,19.5537c0-1.8433,1.3953-2.7563,3.8416-2.7563h1.5332v-.6545c0-.9993-.4995-1.585-1.6709-1.585-1.0337,0-1.6194.5168-2.05,1.137l-1.3093-1.1714c.6545-1.0337,1.7056-1.7228,3.5144-1.7228,2.429,0,3.7209,1.1543,3.7209,3.2042v4.2379h.896v1.7572h-1.2231c-.9475,0-1.5332-.6201-1.6711-1.5504h-.1033c-.293,1.1542-1.2749,1.7572-2.6187,1.7572-1.8259,0-2.8596-1.0509-2.8596-2.6531Zm5.3624-.2412v-1.1886h-1.4126c-1.1541,0-1.7227.3962-1.7227,1.1025v.2928c0,.7235.4995,1.0853,1.3608,1.0853.9819,0,1.7744-.4479,1.7744-1.2921Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m6.6184,20.2084l1.5332-1.4816c.8269.9647,1.8433,1.4816,3.0837,1.4816,1.3953,0,2.1189-.6719,2.1189-1.6882,0-.8097-.3789-1.3093-1.6367-1.5332l-1.137-.1724c-2.429-.3789-3.6003-1.5332-3.6003-3.4971,0-2.1534,1.6709-3.5488,4.3584-3.5488,1.8088,0,3.1526.6202,4.1172,1.7744l-1.5503,1.4644c-.5857-.7408-1.4126-1.2404-2.6875-1.2404-1.292,0-1.9639.5168-1.9639,1.4126,0,.9131.5168,1.292,1.6711,1.4988l1.1196.2067c2.429.4308,3.5662,1.516,3.5662,3.4972,0,2.2739-1.6367,3.8245-4.5137,3.8245-2.05,0-3.4626-.8097-4.479-1.9984Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const Save = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Save({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path290 || (_path290 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M13.9,4.6l-2.5-2.5C11.3,2.1,11.1,2,11,2H3C2.4,2,2,2.4,2,3v10c0,0.6,0.4,1,1,1h10c0.6,0,1-0.4,1-1V5 C14,4.9,13.9,4.7,13.9,4.6z M6,3h4v2H6V3z M10,13H6V9h4V13z M11,13V9c0-0.6-0.4-1-1-1H6C5.4,8,5,8.4,5,9v4H3V3h2v2c0,0.6,0.4,1,1,1 h4c0.6,0,1-0.4,1-1V3.2l2,2V13H11z"
    })), children);
  }
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path291 || (_path291 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M17.8,5.5l-3.3-3.3C14.3,2.1,14.2,2,14,2H3.3C2.6,2,2,2.6,2,3.3v13.3C2,17.4,2.6,18,3.3,18h13.3c0.7,0,1.4-0.5,1.4-1.2V6.1 C18,5.7,17.9,5.7,17.8,5.5z M7.3,3.3h5.3v3.3H7.3V3.3z M12.7,16.7H7.3v-5.3h5.3L12.7,16.7L12.7,16.7z M14,16.7v-5.3 c0-0.7-0.6-1.3-1.3-1.3H7.3C6.6,10,6,10.6,6,11.3v5.3H3.3V3.3H6v3.3C6,7.4,6.6,8,7.3,8h5.3C13.4,8,14,7.4,14,6.7v-3l2.7,2.7v10.4 L14,16.7L14,16.7z"
    })), children);
  }
  if (size === 24 || size === "24" || size === "24px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      fill: "currentColor",
      ...rest
    }, _path292 || (_path292 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M20.8,7L17,3.2C16.9,3.1,16.7,3,16.5,3h-12C3.7,3,3,3.7,3,4.5v15C3,20.3,3.7,21,4.5,21h15c0.8,0,1.5-0.7,1.5-1.5v-12 C21,7.3,20.9,7.1,20.8,7z M9,4.5h6v3H9V4.5z M15,19.5H9v-6h6V19.5z M16.5,19.5v-6c0-0.8-0.7-1.5-1.5-1.5H9c-0.8,0-1.5,0.7-1.5,1.5v6 h-3v-15h3v3C7.5,8.3,8.2,9,9,9h6c0.8,0,1.5-0.7,1.5-1.5V4.8l3,3v11.7H16.5z"
    })), children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path293 || (_path293 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M27.71,9.29l-5-5A1,1,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V10A1,1,0,0,0,27.71,9.29ZM12,6h8v4H12Zm8,20H12V18h8Zm2,0V18a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V26Z"
  })), children);
});
if (false) {}
const WatsonHealthSaveAnnotation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthSaveAnnotation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H8V7H6V4A2,2,0,0,1,8,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H26V8H20z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10H26V12H22z"
  })), children);
})));
if (false) {}
const WatsonHealthSaveImage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthSaveImage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H25V18h3V4H14V7H12V4a2,2,0,0,1,2-2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20Z"
  })), children);
})));
if (false) {}
const SaveModel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function SaveModel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M26,20l1.4272,1.9028L23,26.9629l-4.4272-5.06L20,20h6m1-2H19l-3,4,7,8,7-8-3-4Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26H12V18h2V16H12a2,2,0,0,0-2,2v8H6V6h4v4a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V6.41l4,4V16h2V10a1,1,0,0,0-.29-.71l-5-5A.9989.9989,0,0,0,22,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H16ZM12,6h8v4H12Z"
  })), children);
})));
if (false) {}
const WatsonHealthSaveSeries = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthSaveSeries({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56,15.1l-3.48-4.35A2,2,0,0,0,16.52,10H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16.35A2,2,0,0,0,21.56,15.1ZM9,12h6v3H9Zm6,16H9V22h6Zm2,0V22a2,2,0,0,0-2-2H9a2,2,0,0,0-2,2v6H4V12H7v3a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V12.6l3,3.75V28Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21H25V7H11V5H25a2,2,0,0,1,2,2Z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M32,14H30V2H18V0H30a2,2,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const Scale = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Scale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M13,17H7a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V19A2,2,0,0,0,13,17ZM7,25V19h6v6Z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M19,21v2h6a2,2,0,0,0,2-2V7a2,2,0,0,0-2-2H11A2,2,0,0,0,9,7v6h2V7H25V21"
  })), children);
})));
if (false) {}
const Scales = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Scales({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M20,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L25.896,7.5562a.8913.8913,0,0,0-.0454-.0816A1,1,0,0,0,25,7H18.8218A3.0155,3.0155,0,0,0,17,5.1841V2H15V5.1841A3.0155,3.0155,0,0,0,13.1782,7H7a1,1,0,0,0-.8945.5527l-4,8A1,1,0,0,0,2,16a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.6182,9h4.56A3.0147,3.0147,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159A3.0155,3.0155,0,0,0,18.8218,9h4.56l-3.2763,6.5527A1,1,0,0,0,20,16ZM7,19a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,19Zm2.3821-4H4.6179L7,10.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,10a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,19Zm0-8.7637L27.3821,15H22.6179Z"
  })), children);
})));
if (false) {}
const ScalesTipped = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ScalesTipped({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473l-4-8a1,1,0,0,0-1.2109-.5014l-6.3308,2.11A3.0322,3.0322,0,0,0,17,5.1841V2H15V5.1841a2.9949,2.9949,0,0,0-1.9956,2.76l-6.3208,2.107a1,1,0,0,0-.5781.5014l-4,8A1,1,0,0,0,2,19a5,5,0,0,0,10,0,1,1,0,0,0-.1055-.4473L8.41,11.584l5.237-1.7456A3.0285,3.0285,0,0,0,15,10.8154V28H6v2H26V28H17V10.8159a2.9951,2.9951,0,0,0,1.9956-2.76l4.03-1.3438-2.92,5.8408A1,1,0,0,0,20,13ZM7,22a2.9956,2.9956,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,7,22Zm2.3821-4H4.6179L7,13.2363ZM16,9a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,16,9Zm9,7a2.9958,2.9958,0,0,1-2.8152-2h5.63A2.9956,2.9956,0,0,1,25,16Zm0-8.7637L27.3821,12H22.6179Z"
  })), children);
})));
if (false) {}
const Scalpel = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Scalpel({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M28.83,5.17a4.1,4.1,0,0,0-5.66,0L.34,28H9.59a5,5,0,0,0,3.53-1.46L28.83,10.83a4,4,0,0,0,0-5.66ZM12.29,18.88l2.09-2.09,2.83,2.83-2.09,2.09Zm-.58,6.24A3,3,0,0,1,9.59,26H5.17l5.71-5.71,2.83,2.83ZM27.41,9.41l-8.79,8.8-2.83-2.83,8.8-8.79a2,2,0,0,1,2.82,0,2,2,0,0,1,0,2.82Z"
  })), children);
})));
if (false) {}
const WatsonHealthScalpelCursor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthScalpelCursor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4 4 4 4 13 6 13 6 6 13 6 13 4z"
  })), children);
})));
if (false) {}
const WatsonHealthScalpelLasso = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthScalpelLasso({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1338a4.0941,4.0941,0,0,0-5.6562,0L.3433,29.9619H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.79a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8406l2.086-2.0858,2.8293,2.8293L15.1224,23.67ZM11.71,27.083a2.9824,2.9824,0,0,1-2.1215.8789H5.1714l5.7073-5.7072,2.83,2.83ZM27.4141,11.376,18.6221,20.17l-2.8293-2.8292,8.7931-8.7928a2.0471,2.0471,0,0,1,2.8282,0,1.9993,1.9993,0,0,1,0,2.8281Z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M11,2H7a4.9843,4.9843,0,0,0-3.8633,8.1528A2.9586,2.9586,0,0,0,3,11a2.9945,2.9945,0,0,0,2,2.8154V14a2.0025,2.0025,0,0,1-2,2H2v2H3a4.0045,4.0045,0,0,0,4-4v-.1841A2.9959,2.9959,0,0,0,8.8157,12H11A5,5,0,0,0,11,2ZM6,12a1,1,0,1,1,1-1A1.0009,1.0009,0,0,1,6,12Zm5-2H8.8157A2.974,2.974,0,0,0,4.394,8.4746,2.9908,2.9908,0,0,1,7,4h4a3,3,0,0,1,0,6Z"
  })), children);
})));
if (false) {}
const WatsonHealthScalpelSelect = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthScalpelSelect({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8281,7.1719a4.0941,4.0941,0,0,0-5.6562,0L.3433,30H9.5889a4.9682,4.9682,0,0,0,3.5356-1.4648L28.8281,12.8281a3.9984,3.9984,0,0,0,0-5.6562ZM12.2928,20.8787l2.086-2.0859,2.8293,2.8294-2.0857,2.0862ZM11.71,27.1211A2.9824,2.9824,0,0,1,9.5889,28H5.1714l5.7073-5.7072,2.83,2.83Zm15.7037-15.707-8.792,8.7939-2.8293-2.8292,8.7931-8.7929a2.0473,2.0473,0,0,1,2.8282,0,1.9995,1.9995,0,0,1,0,2.8282Z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M15,2a2.9948,2.9948,0,0,0-2.8157,2H7.8156A2.9925,2.9925,0,1,0,4,7.8154v4.3687a3,3,0,1,0,2,0V7.8159A2.9959,2.9959,0,0,0,7.8156,6h4.3686A2.9947,2.9947,0,1,0,15,2ZM5,16a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,5,16ZM5,6A1,1,0,1,1,6,5,1.0008,1.0008,0,0,1,5,6ZM15,6a1,1,0,1,1,1-1A1.0008,1.0008,0,0,1,15,6Z"
  })), children);
})));
if (false) {}
const Scan = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Scan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M21,29H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H21V5H5V27H21Z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9H17V23H15z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9H29V23H27z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9H23V23H21z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 3141:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZN": function() { return /* binding */ TrashCan; }
/* harmony export */ });
/* unused harmony exports TemperatureHot, TemperatureInversion, TemperatureMax, TemperatureMin, TemperatureWater, Template, Tennis, TennisBall, Term, TermReference, Terminal, Terminal_3270, TestTool, TextAlignCenter, TextAlignJustify, TextAlignLeft, TextAlignMixed, TextAlignRight, TextAllCaps, TextBold, TextClearFormat, TextColor, TextCreation, TextFill, TextFont, TextFootnote, TextHighlight, TextIndent, TextIndentLess, TextIndentMore, TextItalic, TextKerning, TextLeading, TextLineSpacing, TextLink, TextLinkAnalysis, TextLongParagraph, TextMining, TextMiningApplier, TextNewLine, TextScale, TextSelection, TextShortParagraph, TextSmallCaps, TextStrikethrough, TextSubscript, TextSuperscript, TextTracking, TextUnderline, TextVerticalAlignment, TextWrap, Theater, ThisSideUp, Thumbnail_1, Thumbnail_2, ThumbsDown, ThumbsDownFilled, ThumbsUp, ThumbsUpDouble, ThumbsUpDoubleFilled, ThumbsUpFilled, Thunderstorm, ThunderstormScattered, ThunderstormScatteredNight, ThunderstormSevere, ThunderstormStrong, Ticket, Tides, Tif, Time, TimeFilled, TimePlot, Timer, TimingBelt, ToggleOff, ToggleOffFill, ToggleOn, ToggleOnFill, ToolBox, ToolKit, Tools, ToolsAlt, TopDataSets, TopPrograms, Tornado, TornadoWarning, TouchInteraction, Touch_1, Touch_1Down, Touch_1DownFilled, Touch_1Filled, Touch_2, Touch_2Filled, Tour, Trace, TrafficCone, TrafficEvent, TrafficFlow, TrafficFlowIncident, TrafficIncident, TrafficWeatherIncident, Train, TrainHeart, TrainProfile, TrainSpeed, TrainTicket, TrainTime, Tram, TransformBinary, TransformCode, TransformInstructions, TransformLanguage, Transgender, Translate, TransmissionLte, Transpose, Tree, TreeFallRisk, TreeView, TreeViewAlt, TriangleDownOutline, WatsonHealthTextAnnotationToggle, WatsonHealthThreshold, WatsonHealthThumbnailPreview */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _path22, _path23, _path24, _path25, _circle, _circle2, _circle3, _path26, _path27, _path28, _circle4, _circle5, _circle6, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _circle7, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _circle8, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385;
const TemperatureHot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TemperatureHot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 13H30V15H26z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.121 5.879H27.121V7.879H23.121z",
    transform: "rotate(-45 25.121 6.879)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.121 19.121H26.121V23.121H24.121z",
    transform: "rotate(-45 25.121 21.121)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 2H19V6H17z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18,8a6.0365,6.0365,0,0,0-1,.09v2.0518A3.9567,3.9567,0,0,1,18,10a4,4,0,0,1,0,8v2A6,6,0,0,0,18,8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9,30A6.9931,6.9931,0,0,1,4,18.1108V7A5,5,0,0,1,14,7V18.1108A6.9931,6.9931,0,0,1,9,30ZM9,4A3.0033,3.0033,0,0,0,6,7V18.9834l-.332.2983a5,5,0,1,0,6.664,0L12,18.9834V7A3.0033,3.0033,0,0,0,9,4Z"
  })), children);
})));
if (false) {}
const TemperatureInversion = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TemperatureInversion({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30,8H24v6h2V11.541A5.939,5.939,0,0,1,28,16a6.0039,6.0039,0,0,1-5.0945,5.9243A7.0273,7.0273,0,0,0,20,17.2617V6a4,4,0,0,0-8,0V17.2617a6.996,6.996,0,1,0,10.9292,6.68A7.9794,7.9794,0,0,0,27.2651,10H30ZM14,6a2,2,0,0,1,4,0v7H14Zm2,22a4.9965,4.9965,0,0,1-2.499-9.3252L14,18.3857V15h4v3.3857l.499.2891A4.9965,4.9965,0,0,1,16,28Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2,10a8.04,8.04,0,0,0,2.7349,6H2v2H8V12H6v2.4592A5.94,5.94,0,0,1,4,10a6.0066,6.0066,0,0,1,6-6V2A8.0092,8.0092,0,0,0,2,10Z"
  })), children);
})));
if (false) {}
const TemperatureMax = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TemperatureMax({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H27V12H20z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H30V18H20z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20 22H27V24H20z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10,20.1839V7H8V20.1839a3,3,0,1,0,2,0Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4H12.9744A4.9829,4.9829,0,0,0,4,7V18.1108a7,7,0,1,0,10,0V7a5.0019,5.0019,0,0,0-.1011-1H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
})));
if (false) {}
const TemperatureMin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TemperatureMin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H27V6H20z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10H30V12H20z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H27V18H20z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12,23a3,3,0,0,1-6,0Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30,22H15.9192A7.0107,7.0107,0,0,0,14,18.1108V7A5,5,0,0,0,4,7V18.1108A6.9946,6.9946,0,1,0,15.92,24H30ZM9,28a4.9933,4.9933,0,0,1-3.332-8.7183L6,18.9834V7a3,3,0,0,1,6,0V18.9834l.332.2983A4.9933,4.9933,0,0,1,9,28Z"
  })), children);
})));
if (false) {}
const TemperatureWater = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TemperatureWater({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14,9a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,9V7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,4a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,7a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,4a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,7H13V6A4,4,0,0,0,5,6V17.2617A7.0126,7.0126,0,1,0,13.8735,18H14a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,30,18V16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,26,13a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,22,16a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,18,13a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,14,16H13V9ZM7,6a2,2,0,0,1,4,0v6H7ZM9,28a4.9965,4.9965,0,0,1-2.499-9.3252L7,18.3857V14h4v4.3857l.499.2891A4.9965,4.9965,0,0,1,9,28Z"
  })), children);
})));
if (false) {}
const Template = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Template({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v4H6V6H26m0-2H6A2,2,0,0,0,4,6v4a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10,16V26H6V16h4m0-2H6a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2h4a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M26,16V26H16V16H26m0-2H16a2,2,0,0,0-2,2V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V16a2,2,0,0,0-2-2Z"
  })), children);
})));
if (false) {}
const Tennis = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tennis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "4",
    height: "4",
    x: "20",
    y: "2",
    rx: "2"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M11,16a1,1,0,0,1-.707-1.707l7-7a1,1,0,1,1,1.414,1.414l-7,7A.9962.9962,0,0,1,11,16Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.707,24.293a8.3948,8.3948,0,0,0-4.72-2.209c.1992-.1641.3931-.3364.5777-.521a9.2447,9.2447,0,0,0,1.7334-9.9141l-1.8768.6973c1.11,2.9805.6346,5.8975-1.2722,7.8022a6.6964,6.6964,0,0,1-5.561,1.8047,9.7746,9.7746,0,0,1-5.771-2.7856c-2.9727-2.97-4.0759-8.2276-.9805-11.32,1.9068-1.9053,4.8267-2.38,7.8094-1.271l.6987-1.875C10.6616,3.333,6.8591,3.9961,4.4207,6.4331c-3.9427,3.9385-2.6761,10.4956.98,14.1489a11.8136,11.8136,0,0,0,6.9766,3.36c.21.022.4153.0234.6223.0332V24h4.9968a6.8463,6.8463,0,0,1,4.2962,1.707L26.5859,30,28,28.5859Z"
  })), children);
})));
if (false) {}
const TennisBall = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TennisBall({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M19,4a8.9812,8.9812,0,0,0-8.1687,12.7549L2,25.5859,3.4141,27l8.4873-8.4873a9.0408,9.0408,0,0,0,1.5859,1.5859L10,23.5859,11.4141,25l3.8313-3.8311A8.9959,8.9959,0,1,0,19,4Zm6.9058,7.9058a7.005,7.005,0,0,1-5.8116-5.8116A7.005,7.005,0,0,1,25.9058,11.9058ZM12.0942,14.0942a7.005,7.005,0,0,1,5.8116,5.8116A7.005,7.005,0,0,1,12.0942,14.0942ZM19.93,19.9307a9.01,9.01,0,0,0-7.8611-7.8614,7.004,7.004,0,0,1,6-6,9.01,9.01,0,0,0,7.8611,7.8614A7.004,7.004,0,0,1,19.93,19.9307Z"
  })), children);
})));
if (false) {}
const Term = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Term({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M28,26H25V24h3V8H25V6h3a2.0023,2.0023,0,0,1,2,2V24A2.0027,2.0027,0,0,1,28,26Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "16",
    r: "2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "16",
    r: "2"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M7,26H4a2.0023,2.0023,0,0,1-2-2V8A2.002,2.002,0,0,1,4,6H7V8H4V24H7Z"
  })), children);
})));
if (false) {}
const TermReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TermReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,25h-3v-2h3V7h-3v-2h3c1.1025,0,2,.897,2,2v16c0,1.1025-.8975,2-2,2Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "9",
    cy: "15",
    r: "2",
    strokeWidth: "0"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4,17V7h3v-2h-3c-1.103,0-2,.897-2,2v10h2Z"
  })), children);
})));
if (false) {}
const Terminal = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Terminal({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z",
    transform: "translate(0 .01)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M10.76 16.18 13.58 19.01 10.76 21.84 12.17 23.25 16.41 19.01 12.17 14.77 10.76 16.18z"
  })), children);
})));
if (false) {}
const Terminal_3270 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Terminal_3270({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21H16V23H10z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2,2,0,0,0,4,6V26a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6A2,2,0,0,0,26,4Zm0,2v4H6V6ZM6,26V12H26V26Z"
  })), children);
})));
if (false) {}
const TestTool = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TestTool({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M23 9.2 20.4 6.6 19 8 23 12 30 5 28.6 3.6z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.4 10.6 4 8 6.6 5.4 4 4 5.4 6.6 8 4 10.6 5.4 12 8 9.4 10.6 12 12 10.6 9.4 8z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.4 10.6 20 8 22.6 5.4 20 4 21.4 6.6 24 4 26.6 5.4 28 8 25.4 10.6 28 12 26.6 9.4 24z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), children);
})));
if (false) {}
const TextAlignCenter = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAlignCenter({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H22V14H10z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H22V26H10z"
  })), children);
})));
if (false) {}
const TextAlignJustify = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAlignJustify({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26V26H6z"
  })), children);
})));
if (false) {}
const TextAlignLeft = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAlignLeft({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6H26V8H12z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H22V14H12z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18H26V20H12z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12 24H22V26H12z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M6 4H8V28H6z"
  })), children);
})));
if (false) {}
const TextAlignMixed = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAlignMixed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14,4H9V6h5V8H10a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2h6V6A2.0023,2.0023,0,0,0,14,4Zm0,8H10V10h4Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22 26 22 18 20 18 20 19 18 19 18 21 20 21 20 26 18 26 18 28 24 28 24 26 22 26z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V16H2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16H30V30H28z"
  })), children);
})));
if (false) {}
const TextAlignRight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAlignRight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H20V8H6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12H20V14H10z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H20V20H6z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M10 24H20V26H10z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H26V28H24z"
  })), children);
})));
if (false) {}
const TextAllCaps = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextAllCaps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8 1 10 7 10 7 24 9 24 9 10 15 10 15 8 1 8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8 17 10 23 10 23 24 25 24 25 10 31 10 31 8 17 8z"
  })), children);
})));
if (false) {}
const TextBold = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextBold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M18.25,25H9V7h8.5a5.25,5.25,0,0,1,4,8.65A5.25,5.25,0,0,1,18.25,25ZM12,22h6.23a2.25,2.25,0,1,0,0-4.5H12Zm0-7.5h5.5a2.25,2.25,0,1,0,0-4.5H12Z"
  })), children);
})));
if (false) {}
const TextClearFormat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextClearFormat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4384,16.5715l-7.985-7.9856a2.0014,2.0014,0,0,0-2.8291,0l-5.3584,5.3584L9,2H7L2,16H4l.999-3h6l.8035,2.4077L4.5858,22.6244a2,2,0,0,0,0,2.8282L9.1316,30h9.5908l10.716-10.717A1.9173,1.9173,0,0,0,29.4384,16.5715ZM5.6653,11l2.331-7,2.3355,7Zm12.229,17H9.96L6,24.0381l6.3123-6.3115L20.24,25.6538Zm3.76-3.76-7.9275-7.9272L20.0393,10l7.9268,7.9272Z"
  })), children);
})));
if (false) {}
const TextColor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextColor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M22,21h2L17,4H15L8,21h2l1.61-4h8.74Zm-9.57-6,3.44-8.37h.26L19.54,15Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H26V28H6z"
  })), children);
})));
if (false) {}
const TextCreation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextCreation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M27,22.14V9.86A4,4,0,1,0,22.14,5H9.86A4,4,0,1,0,5,9.86V22.14A4,4,0,1,0,9.86,27H22.14A4,4,0,1,0,27,22.14ZM26,4a2,2,0,1,1-2,2A2,2,0,0,1,26,4ZM4,6A2,2,0,1,1,6,8,2,2,0,0,1,4,6ZM6,28a2,2,0,1,1,2-2A2,2,0,0,1,6,28Zm16.14-3H9.86A4,4,0,0,0,7,22.14V9.86A4,4,0,0,0,9.86,7H22.14A4,4,0,0,0,25,9.86V22.14A4,4,0,0,0,22.14,25ZM26,28a2,2,0,1,1,2-2A2,2,0,0,1,26,28Z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11 11 11 11 13 15 13 15 22 17 22 17 13 21 13 21 11z"
  })), children);
})));
if (false) {}
const TextFill = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextFill({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V30H4z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M26,14.54a1,1,0,0,0-.25-.69L17.17,4.33A1.09,1.09,0,0,0,17,4.2V2H15V5L4.32,14.74a1,1,0,0,0-.06,1.41l8.57,9.52a1,1,0,0,0,.69.33h.05a1,1,0,0,0,.68-.26L24,16.8V21a1,1,0,0,0,2,0V14.57S26,14.55,26,14.54Zm-12.35,9-7.23-8L15,7.67V12h2V7.13l6.59,7.33Z"
  })), children);
})));
if (false) {}
const TextFont = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextFont({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M25,12H20v2h5a1.0008,1.0008,0,0,1,1,1v2H22a3.0033,3.0033,0,0,0-3,3v1a3.0033,3.0033,0,0,0,3,3h6V15A3.0033,3.0033,0,0,0,25,12ZM22,22a1.0008,1.0008,0,0,1-1-1V20a1.0008,1.0008,0,0,1,1-1h4v3Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M16,24h2L12,7H10L4,24H6l1.6936-5h6.6135ZM8.3711,17l2.4966-7.3711.2668.0005L13.63,17Z"
  })), children);
})));
if (false) {}
const TextFootnote = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextFootnote({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7 2 9 9 9 9 25 11 25 11 9 18 9 18 7 2 7z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11.076 29.256 9.219 26 10.522 26 7 24 7 24 10.523 20.744 9.22 20 11.077 23.417 12.444 20.9 15.8 22.5 17 25 13.667 27.5 17 29.1 15.8 26.583 12.443 30 11.076z"
  })), children);
})));
if (false) {}
const TextHighlight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextHighlight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15H5a3,3,0,0,1-3-3V10A3,3,0,0,1,5,7h5V5A1,1,0,0,0,9,4H3V2H9a3,3,0,0,1,3,3ZM5,9a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V9Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M20,23v2a1,1,0,0,0,1,1h5V22H21A1,1,0,0,0,20,23Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30H30V2Zm26-2H21a3,3,0,0,1-3-3V23a3,3,0,0,1,3-3h5V18a1,1,0,0,0-1-1H19V15h6a3,3,0,0,1,3,3Z"
  })), children);
})));
if (false) {}
const TextIndent = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextIndent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6H28V8H14z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12H28V14H14z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18H28V20H7z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M7 24H28V26H7z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M4 13.59 7.29 10 4 6.41 5.42 5 10.04 10 5.42 15 4 13.59z"
  })), children);
})));
if (false) {}
const TextIndentLess = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextIndentLess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H12V8H2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12H12V14H5z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H12V20H2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M5 24H12V26H5z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4H18V28H16z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M28.15 23.5 29.56 22.12 23.27 16 29.56 9.88 28.15 8.5 20.44 16 28.15 23.5z"
  })), children);
})));
if (false) {}
const TextIndentMore = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextIndentMore({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6H30V8H20z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H27V14H20z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H30V20H20z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24H27V26H20z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4H16V28H14z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M3.85 22.5 2.44 21.12 8.73 15 2.44 8.88 3.85 7.5 11.56 15 3.85 22.5z"
  })), children);
})));
if (false) {}
const TextItalic = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextItalic({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M25 9 25 7 12 7 12 9 17.14 9 12.77 23 7 23 7 25 20 25 20 23 14.86 23 19.23 9 25 9z"
  })), children);
})));
if (false) {}
const TextKerning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextKerning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24 18.83 24 21.12 21.71 19.71 20.29 15 25 19.71 29.71 21.12 28.29 18.83 26 30 26 30 24z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21 20 4 18 4 12 21 14 21z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M13 4 9 16 5 4 3 4 8 18 10 18 15 4 13 4z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18h2L25,4H23L18,18h2l1-3h6Zm-6.33-5L24,6l2.33,7Z"
  })), children);
})));
if (false) {}
const TextLeading = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextLeading({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13H30V15H14z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M15 28H30V30H15z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85,27H28L23.64,17H21.36L17,27h2.15l.8-2h5.1Zm-5.1-4,1.75-4.37L24.25,23Z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M25.85,12H28L23.64,2H21.36L17,12h2.15l.8-2h5.1Zm-5.1-4L22.5,3.63,24.25,8Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15.83 8.58 18.41 10 17 6 13 2 17 3.41 18.42 6 15.83z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M6 27.17 3.42 24.59 2 26 6 30 10 26 8.59 24.58 6 27.17z"
  })), children);
})));
if (false) {}
const TextLineSpacing = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextLineSpacing({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6H30V8H17z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12H27V14H17z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18H30V20H17z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H27V26H17z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 13.41 8 9.83 8 9.83 4.41 13.42 3 12 8 7 13 12 11.59 13.41z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 18.59 8 22.17 8 22.17 4.41 18.58 3 20 8 25 13 20 11.59 18.59z"
  })), children);
})));
if (false) {}
const TextLongParagraph = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextLongParagraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24H20V26H6z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H26V20H6z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6H26V8H6z"
  })), children);
})));
if (false) {}
const TextNewLine = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextNewLine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5859,14.4141,24.1719,18H6V8H4V18a2.0024,2.0024,0,0,0,2,2H24.1719L20.586,23.5859,22,25l6-6-6-6Z"
  })), children);
})));
if (false) {}
const TextScale = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextScale({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M30 5 30 8 22 8 22 26 19 26 19 8 11 8 11 5 30 5z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M7 26 7 14 2 14 2 12 14 12 14 14 9 14 9 26 7 26z"
  })), children);
})));
if (false) {}
const TextSelection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextSelection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28,27H21a3,3,0,0,1-3-3V22a3,3,0,0,1,3-3h5V17a1,1,0,0,0-1-1H19V14h6a3,3,0,0,1,3,3Zm-7-6a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h5V21Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M13,7h3V5H13a4,4,0,0,0-3,1.38A4,4,0,0,0,7,5H4V7H7A2,2,0,0,1,9,9v5H5v2H9v7a2,2,0,0,1-2,2H4v2H7a4,4,0,0,0,3-1.38A4,4,0,0,0,13,27h3V25H13a2,2,0,0,1-2-2V16h4V14H11V9A2,2,0,0,1,13,7Z"
  })), children);
})));
if (false) {}
const TextShortParagraph = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextShortParagraph({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18H20V20H6z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H26V14H6z"
  })), children);
})));
if (false) {}
const TextSmallCaps = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextSmallCaps({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M23 27 23 15 18 15 18 13 30 13 30 15 25 15 25 27 23 27z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27 11 8 2 8 2 6 22 6 22 8 13 8 13 27 11 27z"
  })), children);
})));
if (false) {}
const TextStrikethrough = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextStrikethrough({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28,15H17.9563c-.4522-.1237-.9037-.2324-1.3381-.3352-2.8077-.6641-4.396-1.1506-4.396-3.4231a2.8684,2.8684,0,0,1,.7866-2.145,4.7888,4.7888,0,0,1,3.0137-1.09c2.8291-.07,4.1347.8894,5.2011,2.35l1.6153-1.1792a7.4727,7.4727,0,0,0-6.83-3.1706,6.7726,6.7726,0,0,0-4.4,1.6611,4.8274,4.8274,0,0,0-1.3862,3.5735A4.3723,4.3723,0,0,0,11.9573,15H4v2H17.6519c1.9668.57,3.1432,1.3123,3.1733,3.3579a3.119,3.119,0,0,1-.8623,2.3931A5.8241,5.8241,0,0,1,16.2432,24a6.6344,6.6344,0,0,1-5.1451-2.6912L9.5649,22.593A8.5262,8.5262,0,0,0,16.2119,26c.0088-.0012.042,0,.1,0A7.67,7.67,0,0,0,21.36,24.1812a5.0779,5.0779,0,0,0,1.4648-3.8531A4.952,4.952,0,0,0,21.6753,17H28Z"
  })), children);
})));
if (false) {}
const TextSubscript = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextSubscript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M26 25 20 25 20 19 24 19 24 17 20 17 20 15 26 15 26 21 22 21 22 23 26 23 26 25z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7 5 9 12 9 12 25 14 25 14 9 21 9 21 7 5 7z"
  })), children);
})));
if (false) {}
const TextSuperscript = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextSuperscript({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M29 17 23 17 23 11 27 11 27 9 23 9 23 7 29 7 29 13 25 13 25 15 29 15 29 17z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7 4 9 11 9 11 25 13 25 13 9 20 9 20 7 4 7z"
  })), children);
})));
if (false) {}
const TextTracking = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextTracking({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M25.29 19.29 23.88 20.71 26.17 23 5.83 23 8.12 20.71 6.71 19.29 2 24 6.71 28.71 8.12 27.29 5.83 25 26.17 25 23.88 27.29 25.29 28.71 30 24 25.29 19.29z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M26,17h2L23,3H21L16,17h2l1-3h6Zm-6.33-5L22,5l2.33,7Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3 10 15 6 3 4 3 9 17 11 17 16 3 14 3z"
  })), children);
})));
if (false) {}
const TextUnderline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextUnderline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a7,7,0,0,1-7-7V5h2V16a5,5,0,0,0,10,0V5h2V16A7,7,0,0,1,16,23Z"
  })), children);
})));
if (false) {}
const TextVerticalAlignment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextVerticalAlignment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28H30V30H16z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16 23H30V25H16z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458,30H13L8.64,20H6.36L2,30H4.1542l.8-2h5.0916ZM5.7541,26,7.5,21.6347,9.2459,26Z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H30V17H2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7H30V9H16z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2H30V4H16z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8458,12H13L8.64,2H6.36L2,12H4.1542l.8-2h5.0916ZM5.7541,8,7.5,3.6347,9.2459,8Z"
  })), children);
})));
if (false) {}
const TextWrap = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextWrap({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M4 23H12V25H4z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5232,14H4v2H24.5a3.5,3.5,0,0,1,0,7H18.8281l2.586-2.5859L20,19l-5,5,5,5,1.4141-1.4141L18.8281,25H24.533a5.5,5.5,0,0,0-.01-11Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5H28V7H4z"
  })), children);
})));
if (false) {}
const WatsonHealthTextAnnotationToggle = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthTextAnnotationToggle({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M29.537,13.76,26.24,10.463a1.5862,1.5862,0,0,0-2.24,0L10,24.4674V30h5.5326L29.537,16a1.5862,1.5862,0,0,0,0-2.24ZM14.7042,28H12V25.2958l9.4409-9.4409,2.7042,2.7042ZM25.5591,17.145,22.855,14.4409l2.2672-2.2672,2.7042,2.7042Z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17 13 17 13 10 16 10 16 8 8 8 8 10 11 10 11 17z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4V4H20V8h2V4a2,2,0,0,0-2-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H8Z"
  })), children);
})));
if (false) {}
const TextLink = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextLink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7061,27.585a5.2615,5.2615,0,0,1-3.7227-8.9834l1.415,1.414a3.2638,3.2638,0,1,0,4.6153,4.6162l6.03-6.03a3.264,3.264,0,0,0-4.6162-4.6158l-1.414-1.414a5.2637,5.2637,0,0,1,7.4443,7.4438l-6.03,6.03A5.2461,5.2461,0,0,1,18.7061,27.585Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2642,29.9971A5.2619,5.2619,0,0,1,6.542,21.0137l6.03-6.03a5.2636,5.2636,0,1,1,7.4438,7.4438l-1.414-1.414a3.2639,3.2639,0,1,0-4.6158-4.6158l-6.03,6.03a3.264,3.264,0,0,0,4.6157,4.6162l1.414,1.4141A5.2452,5.2452,0,0,1,10.2642,29.9971Z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H10V12H2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H14V8H2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H14V4H2z"
  })), children);
})));
if (false) {}
const TextLinkAnalysis = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextLinkAnalysis({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10H16V12H8z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H20V8H8z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H20V4H8z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7111,28l5.6312-9.9961,7.4341,6.49A2,2,0,0,0,20.86,23.96l6.9707-10.4034-1.6622-1.1132-7,10.4472-.07.1035-7.4345-6.4907a2.0032,2.0032,0,0,0-3.0806.5308L4,25.1826V2H2V28a2.0023,2.0023,0,0,0,2,2H30V28Z"
  })), children);
})));
if (false) {}
const TextMining = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextMining({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18 28H26V30H18z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18 24H30V26H18z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20H30V22H18z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473 16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), children);
})));
if (false) {}
const TextMiningApplier = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TextMiningApplier({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M16.001 26.473 16 26.473 4.284 12.955 9.5 6 22.5 6 27.716 12.955 24.476 16.692 25.989 18.002 30.284 13.045 23.5 4 8.5 4 1.716 13.045 14.488 27.782 16.001 26.473z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19 27 24 20 29 20 19z"
  })), children);
})));
if (false) {}
const Theater = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Theater({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M20,25a6.9908,6.9908,0,0,1-5.833-3.1287l1.666-1.1074a5.0007,5.0007,0,0,0,8.334,0l1.666,1.1074A6.9908,6.9908,0,0,1,20,25Z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,24,14Z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M16,14a2,2,0,1,0,2,2A1.9806,1.9806,0,0,0,16,14Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M28,8H22V4a2.0023,2.0023,0,0,0-2-2H4A2.0023,2.0023,0,0,0,2,4V14a10.01,10.01,0,0,0,8.8027,9.9214A9.9989,9.9989,0,0,0,30,20V10A2.0023,2.0023,0,0,0,28,8ZM4,14V4H20V8H12a2.0023,2.0023,0,0,0-2,2V20a9.9628,9.9628,0,0,0,.168,1.78A8.0081,8.0081,0,0,1,4,14Zm24,6a8,8,0,0,1-16,0V10H28Z"
  })), children);
})));
if (false) {}
const ThisSideUp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThisSideUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.828 7 24 9 24 9 5.828 12.586 9.414 14 8 8 2 2 8 3.414 9.414 7 5.828z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.828 23 24 25 24 25 5.828 28.586 9.414 30 8 24 2 18 8 19.414 9.414 23 5.828z"
  })), children);
})));
if (false) {}
const WatsonHealthThreshold = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthThreshold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M26,4H6A2.0025,2.0025,0,0,0,4,6V26a2.0025,2.0025,0,0,0,2,2H26a2.0023,2.0023,0,0,0,2-2V6A2.0023,2.0023,0,0,0,26,4ZM6,6H26V16H24v2h2v2H24v2h2v2H24v2H22V24H20v2H18V24H16v2H14V24H12v2H10V24H8v2H6Z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20H10V22H8z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20H14V22H12z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20H18V22H16z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20H22V22H20z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16H10V18H8z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V18H16z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16H22V18H20z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12H22V14H20z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8H22V10H20z"
  })), children);
})));
if (false) {}
const Thumbnail_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Thumbnail_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H4a2,2,0,0,1-2-2V4A2,2,0,0,1,4,2H28a2,2,0,0,1,2,2V18A2,2,0,0,1,28,20ZM4,4V18H28V4Z"
  })), children);
})));
if (false) {}
const Thumbnail_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Thumbnail_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,30ZM4,24v4H8V24Z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M18,30H14a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,30Zm-4-6v4h4V24Z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24a2,2,0,0,1-2-2V24a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,30Zm-4-6v4h4V24Z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M8,20H4a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2H8a2,2,0,0,1,2,2v4A2,2,0,0,1,8,20ZM4,14v4H8V14Z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M18,20H14a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,18,20Zm-4-6v4h4V14Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M28,20H24a2,2,0,0,1-2-2V14a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2v4A2,2,0,0,1,28,20Zm-4-6v4h4V14Z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M8,10H4A2,2,0,0,1,2,8V4A2,2,0,0,1,4,2H8a2,2,0,0,1,2,2V8A2,2,0,0,1,8,10ZM4,4V8H8V4Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M18,10H14a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,18,10ZM14,4V8h4V4Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H24a2,2,0,0,1-2-2V4a2,2,0,0,1,2-2h4a2,2,0,0,1,2,2V8A2,2,0,0,1,28,10ZM24,4V8h4V4Z"
  })), children);
})));
if (false) {}
const WatsonHealthThumbnailPreview = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function WatsonHealthThumbnailPreview({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H4a2.0023,2.0023,0,0,0-2,2V28a2.002,2.002,0,0,0,2,2H28a2.0023,2.0023,0,0,0,2-2V14A2.0027,2.0027,0,0,0,28,12ZM20,28H12V27a1.0009,1.0009,0,0,1,1-1h6a1.0009,1.0009,0,0,1,1,1Zm8,0H22V27a3.0033,3.0033,0,0,0-3-3H13a3.0033,3.0033,0,0,0-3,3v1H4V14H28.002Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16,23a4,4,0,1,1,4-4A4.0042,4.0042,0,0,1,16,23Zm0-6a2,2,0,1,0,2,2A2.0023,2.0023,0,0,0,16,17Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M30,4V8a2.0027,2.0027,0,0,1-2,2H24a2.0027,2.0027,0,0,1-2-2V4a2.0027,2.0027,0,0,1,2-2h4A2.0027,2.0027,0,0,1,30,4ZM28,8l.002-4H24V8Z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M20,4V8a2.0027,2.0027,0,0,1-2,2H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h4A2.0027,2.0027,0,0,1,20,4ZM18,8l.002-4H14V8Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M10,4V8a2.0023,2.0023,0,0,1-2,2H4A2.0023,2.0023,0,0,1,2,8V4A2.0023,2.0023,0,0,1,4,2H8A2.0023,2.0023,0,0,1,10,4ZM8,8l.0015-4H4V8Z"
  })), children);
})));
if (false) {}
const ThumbsDown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsDown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M30,16V9a7.0078,7.0078,0,0,0-7-7H2V16H8.4648l3.5774,5.3662.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H17a3.0033,3.0033,0,0,0,3-3V20h6A4.0045,4.0045,0,0,0,30,16ZM8,14H4V4H8Zm20,2a2.0025,2.0025,0,0,1-2,2H18v8a1.0008,1.0008,0,0,1-1,1H14.8672l-.9094-6.3662L10,14.6973V4H23a5.0057,5.0057,0,0,1,5,5Z"
  })), children);
})));
if (false) {}
const ThumbsDownFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsDownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H7V16H2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M23,2H9V16.8027l3.0422,4.5635.8453,5.9165A2.0094,2.0094,0,0,0,14.8672,29H15a3.0033,3.0033,0,0,0,3-3V20h8a4.0045,4.0045,0,0,0,4-4V9A7.0078,7.0078,0,0,0,23,2Z"
  })), children);
})));
if (false) {}
const ThumbsUp = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsUp({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M26,12H20V6a3.0033,3.0033,0,0,0-3-3H14.8672a2.0094,2.0094,0,0,0-1.98,1.7173l-.8453,5.9165L8.4648,16H2V30H23a7.0078,7.0078,0,0,0,7-7V16A4.0045,4.0045,0,0,0,26,12ZM8,28H4V18H8Zm20-5a5.0057,5.0057,0,0,1-5,5H10V17.3027l3.9578-5.9365L14.8672,5H17a1.0008,1.0008,0,0,1,1,1v8h8a2.0025,2.0025,0,0,1,2,2Z"
  })), children);
})));
if (false) {}
const ThumbsUpFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsUpFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H7V30H2z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M23,30H9V15.1973l3.0422-4.5635.8453-5.9165A2.0094,2.0094,0,0,1,14.8672,3H15a3.0033,3.0033,0,0,1,3,3v6h8a4.0045,4.0045,0,0,1,4,4v7A7.0078,7.0078,0,0,1,23,30Z"
  })), children);
})));
if (false) {}
const ThumbsUpDouble = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsUpDouble({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7637,13.9999h-5.7637l-.0024-4.4316c0-2.1011-1.2324-3.5684-2.9976-3.5684h-1c-1.5273,0-1.7539,1.5273-1.8755,2.3477-.0225.1509-.6826,4.8052-.6826,4.8052l-2.0431,3.8472H2v13h16.3325c3.6763,0,6.6675-2.9912,6.6675-6.6675v-5.103c0-2.3369-1.8989-4.2295-4.2363-4.2295h0ZM4,27.9999v-9h1.9998l-.0017,9h-1.9981ZM23,23.3324c0,2.5737-2.0938,4.6675-4.6675,4.6675h-10.3325v-9.751l2.3735-4.4692s.7983-5.6035.8433-5.7798h.7832c.9697,0,.9976,1.4077.9976,1.5684l.0024,6.4316h7.7637c1.2344,0,2.2363.9951,2.2363,2.2295v5.103ZM31,13.2295v5.103c0,2.321-1.194,4.3667-2.9983,5.5613l-1.0042-1.7393c1.2073-.8446,2.0024-2.2402,2.0024-3.8221v-5.103c0-1.2344-1.0019-2.2295-2.2363-2.2295h-7.7637l-.0024-6.4315c0-.1608-.0279-1.5685-.9976-1.5685h-.7832c-.0174.0681-.1475.948-.3002,2.0001h-2.0273c.1234-.8691.2266-1.5944.2352-1.6523.1216-.8206.3482-2.3478,1.8755-2.3478h1c1.7652,0,2.9976,1.4673,2.9976,3.5685l.0024,4.4315h5.7637c2.3374.0001,4.2363,1.8927,4.2363,4.2296Z"
  })), children);
})));
if (false) {}
const ThumbsUpDoubleFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThumbsUpDoubleFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M31,13.2295v5.103c0,2.7286-1.6495,5.0769-4.0023,6.1077v-8.2107c0-2.3369-2.1663-4.2478-4.2363-4.2295h-5.7637s-.0024-3.4316-.0024-3.4316c-.0933-2.0102-1.1168-3.4102-2.1021-3.5719.0672-.4727.2256-1.6102.2313-1.6488.1216-.8206.3482-2.3478,1.8755-2.3478h1c1.7652,0,2.9976,1.4673,2.9976,3.5685l.0024,4.4315h5.7637c2.3374.0001,4.2363,1.8927,4.2363,4.2296ZM20.7614,14h0s-5.7637-.0001-5.7637-.0001l-.0024-4.4315c0-2.1012-1.2324-3.5685-2.9976-3.5685h-1c-1.5273,0-1.7539,1.5272-1.8755,2.3478-.0225.1509-.6826,4.8052-.6826,4.8052l-1.4423,2.7158-.0019,14.1313h11.3348c3.6763,0,6.6675-2.9912,6.6675-6.6675v-5.103c0-2.3369-1.8989-4.2295-4.2363-4.2295ZM4.9951,30l.0026-13H1.9977v13s2.9974,0,2.9974,0Z"
  })), children);
})));
if (false) {}
const Thunderstorm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Thunderstorm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5,22H23V20h.5a4.5,4.5,0,0,0,.36-9L23,11l-.1-.82a7,7,0,0,0-13.88,0L9,11,8.14,11a4.5,4.5,0,0,0,.36,9H9v2H8.5A6.5,6.5,0,0,1,7.2,9.14a9,9,0,0,1,17.6,0A6.5,6.5,0,0,1,23.5,22Z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M15.87 30.5 14.13 29.5 17.28 24 11.28 24 16.13 15.5 17.87 16.5 14.72 22 20.72 22 15.87 30.5z"
  })), children);
})));
if (false) {}
const ThunderstormScattered = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThunderstormScattered({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30 11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M27,11A5.9955,5.9955,0,0,0,15.6335,8.3311,7.3494,7.3494,0,0,0,13.5,8a7.5509,7.5509,0,0,0-7.1492,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9925,3.9925,0,0,1-.6731-7.9292L7.99,14.958l.1458-.6562a5.496,5.496,0,0,1,10.7294,0l.1458.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9853,5.9853,0,0,0,5.2163-8.9463A5.9941,5.9941,0,0,0,27,11Zm-4.0732,3.4893a5.96,5.96,0,0,0-2.2776-1.2452,7.5157,7.5157,0,0,0-3.1853-4.0688,3.9869,3.9869,0,1,1,5.4629,5.314Z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 16.233H29.732V18.233H26.732z",
    transform: "rotate(225 28.232 17.233)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29 10H32V12H29z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M26.732 3.768H29.732V5.768H26.732z",
    transform: "rotate(-45 28.232 4.768)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H22V3H20z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M12.268 3.768H15.268V5.768H12.268z",
    transform: "rotate(225 13.768 4.768)"
  })), children);
})));
if (false) {}
const ThunderstormScatteredNight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThunderstormScatteredNight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M13.338 30 11.602 29 13.889 25 10 25 13.993 18 15.73 19 13.446 23 17.337 23 13.338 30z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M29.844,13.0347a1.52,1.52,0,0,0-1.231-.8658,5.3562,5.3562,0,0,1-3.4094-1.7158A6.4652,6.4652,0,0,1,23.9187,4.06a1.6039,1.6039,0,0,0-.3-1.5459,1.4547,1.4547,0,0,0-1.3591-.4922l-.0191.0039a7.8544,7.8544,0,0,0-6.1054,6.48A7.3725,7.3725,0,0,0,13.5,8a7.5511,7.5511,0,0,0-7.1494,5.2441A5.9926,5.9926,0,0,0,8,25V23a3.9926,3.9926,0,0,1-.6733-7.9292l.663-.1128.1456-.6562a5.496,5.496,0,0,1,10.7294,0l.1456.6562.6626.1128A3.9925,3.9925,0,0,1,19,23v2a5.9549,5.9549,0,0,0,5.88-7.1455,7.502,7.502,0,0,0,4.8669-3.3A1.537,1.537,0,0,0,29.844,13.0347Zm-5.6926,2.9179a5.9658,5.9658,0,0,0-3.502-2.7085A7.5084,7.5084,0,0,0,18.0288,9.55a6.0085,6.0085,0,0,1,3.77-5.3335,8.4582,8.4582,0,0,0,1.9392,7.5967A7.4037,7.4037,0,0,0,27.64,14.041,5.4419,5.4419,0,0,1,24.1514,15.9526Z"
  })), children);
})));
if (false) {}
const ThunderstormSevere = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThunderstormSevere({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7887.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M15.901 30.496 14.165 29.504 17.309 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9516,15A4.399,4.399,0,0,1,28,15.5,4.5049,4.5049,0,0,1,23.5,20H23v2h.5A6.5075,6.5075,0,0,0,30,15.5c0-.17-.0312-.333-.0444-.5Z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.75,8h-1.5V4h1.5ZM25,9a1,1,0,1,0,1,1A1,1,0,0,0,25,9Z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9115,11.9355,25.6283.3706a.7181.7181,0,0,0-1.2568,0L18.0883,11.9355A.72.72,0,0,0,18.72,13H31.28A.72.72,0,0,0,31.9115,11.9355ZM24.25,4h1.5V8h-1.5ZM25,11a1,1,0,1,1,1-1A1,1,0,0,1,25,11Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M8.144,11.019l.8154-.0639.0991-.812a6.9863,6.9863,0,0,1,9.97-5.45L20,2.9468A8.9777,8.9777,0,0,0,7.2,9.1362,6.4929,6.4929,0,0,0,7.43,21.9043L6.1059,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.4471-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.3559-8.981Z"
  })), children);
})));
if (false) {}
const ThunderstormStrong = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ThunderstormStrong({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,21,30Z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M9,32a1,1,0,0,1-.8944-1.4474l2-4.0005a1,1,0,1,1,1.7888.8947l-2,4A.9981.9981,0,0,1,9,32Z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M15.901 30.496 14.165 29.504 17.31 24 11.31 24 16.165 15.504 17.901 16.496 14.756 22 20.757 22 15.901 30.496z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8008,9.1362a8.9943,8.9943,0,0,0-17.6006,0,6.4929,6.4929,0,0,0,.23,12.7681L6.106,24.5527a1,1,0,1,0,1.7885.8946l2-4a1,1,0,0,0-.447-1.3418A.9786.9786,0,0,0,9,20.01V20H8.5a4.4975,4.4975,0,0,1-.356-8.981l.8155-.0639.0991-.812a6.9938,6.9938,0,0,1,13.8838,0l.0986.812.8154.0639A4.4975,4.4975,0,0,1,23.5,20H23v2h.5A6.4974,6.4974,0,0,0,24.8008,9.1362Z"
  })), children);
})));
if (false) {}
const Ticket = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Ticket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M29,14a1,1,0,0,0,1-1V8a2,2,0,0,0-2-2H4A2,2,0,0,0,2,8v5a1,1,0,0,0,1,1,2,2,0,0,1,0,4,1,1,0,0,0-1,1v5a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V19a1,1,0,0,0-1-1,2,2,0,0,1,0-4Zm-1,5.87V24H21V21H19v3H4V19.87a4,4,0,0,0,0-7.74V8H19v3h2V8h7v4.13a4,4,0,0,0,0,7.74Z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H21V19H19z"
  })), children);
})));
if (false) {}
const Tides = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tides({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M14 7 9 2 4 7 5.413 8.416 8 5.833 8 14 10 14 10 5.833 12.586 8.414 14 7z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26.586 7.586 24 10.167 24 2 22 2 22 10.167 19.413 7.584 18 9 23 14 28 9 26.586 7.586z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,17a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,20a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,8,17a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,4,20H2v2H4a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,20,22H30V20Z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M28,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,24,25a.9894.9894,0,0,0-.9468.6787A3.44,3.44,0,0,1,20,28a3.4376,3.4376,0,0,1-3.0513-2.3164A1.007,1.007,0,0,0,16,25a.971.971,0,0,0-.9468.6787A3.44,3.44,0,0,1,12,28H2v2H12a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0A4.9316,4.9316,0,0,0,28,30h2V28Z"
  })), children);
})));
if (false) {}
const Tif = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tif({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M30 11 30 9 22 9 22 23 24 23 24 17 29 17 29 15 24 15 24 11 30 11z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M12 11 15 11 15 21 12 21 12 23 20 23 20 21 17 21 17 11 20 11 20 9 12 9 12 11z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11 5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
})));
if (false) {}
const Time = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Time({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 20 || size === "20" || size === "20px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20",
      fill: "currentColor",
      ...rest
    }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
      d: "M10,19c-5,0-9-4-9-9s4-9,9-9s9,4,9,9S15,19,10,19z M10,2.3c-4.3,0-7.7,3.5-7.7,7.7s3.5,7.7,7.7,7.7s7.7-3.5,7.7-7.7 S14.3,2.3,10,2.3z"
    })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
      d: "M13 13.9 9.4 10.3 9.4 4 10.6 4 10.6 9.7 13.9 13z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M20.59 22 15 16.41 15 7 17 7 17 15.58 22 20.59 20.59 22z"
  })), children);
})));
if (false) {}
const TimeFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TimeFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m16,2c-7.6001,0-14,6.3999-14,14s6.3999,14,14,14,14-6.3999,14-14S23.6001,2,16,2Zm4.5872,20l-5.5872-5.5898V7h2v8.582l5,5.0044-1.4128,1.4136Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M20.5872 22 15 16.4099 15 7 17 7 17 15.5822 22 20.5866 20.5872 22z"
  })), children);
})));
if (false) {}
const TimePlot = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TimePlot({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M23.586 13 21 10.414 21 6 23 6 23 9.586 25 11.586 23.586 13z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22,18a8,8,0,1,1,8-8A8.0092,8.0092,0,0,1,22,18ZM22,4a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,22,4Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63,18l7,6H30V22H16.37l-7-6H4V2H2V28a2.0025,2.0025,0,0,0,2,2H30V28H4V18Z"
  })), children);
})));
if (false) {}
const Timer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Timer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M15 11H17V20H15z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2H19V4H13z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M28,9,26.58,7.59,24.33,9.84a10.94,10.94,0,1,0,1.18,1.65ZM16,26a9,9,0,1,1,9-9A9,9,0,0,1,16,26Z"
  })), children);
})));
if (false) {}
const TimingBelt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TimingBelt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "24",
    r: "1",
    strokeWidth: "0"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m30,12c0-1.8237-1.2344-3.3496-2.9062-3.8286L7.2087,2.207c-.3838-.123-.7847-.207-1.2087-.207-2.2056,0-4,1.7944-4,4,0,.6025.1438,1.1689.3835,1.6816l8.1016,18.6782c.9185,2.1382,3.0442,3.6401,5.5149,3.6401,2.252,0,4.2161-1.249,5.2422-3.0889l8.002-12.5894c.4712-.6562.7559-1.4541.7559-2.3218Zm-14,6c-2.4155,0-4.4971,1.438-5.4475,3.5005l-5.0149-11.5474c.1536.0181.3042.0469.4624.0469,2.2056,0,4-1.7944,4-4,0-.3193-.0474-.6255-.1182-.9233l13.3882,4.0161c-.7771.73-1.27,1.7593-1.27,2.9072,0,2.1465,1.7029,3.8896,3.8267,3.9824l-4.0593,6.3809c-.7148-2.5146-3.0271-4.3633-5.7673-4.3633Zm12-6c0,1.1025-.8972,2-2,2s-2-.8975-2-2,.8972-2,2-2,2,.8975,2,2ZM6,4c1.1028,0,2,.8975,2,2s-.8972,2-2,2-2-.8975-2-2,.8972-2,2-2Zm10,24c-2.2056,0-4-1.7944-4-4s1.7944-4,4-4,4,1.7944,4,4-1.7944,4-4,4Z"
  })), children);
})));
if (false) {}
const ToggleOffFill = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToggleOffFill({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M22,8h-12c-4.4,0-8,3.6-8,8s3.6,8,8,8h12c4.4,0,8-3.6,8-8s-3.6-8-8-8ZM10,20c-2.2,0-4-1.8-4-4s1.8-4,4-4,4,1.8,4,4-1.8,4-4,4Z"
  })), children);
})));
if (false) {}
const ToggleOnFill = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToggleOnFill({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M10,24h12c4.4,0,8-3.6,8-8s-3.6-8-8-8h-12c-4.4,0-8,3.6-8,8s3.6,8,8,8ZM22,12c2.2,0,4,1.8,4,4s-1.8,4-4,4-4-1.8-4-4,1.8-4,4-4Z"
  })), children);
})));
if (false) {}
const ToggleOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToggleOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M22,23.991h-12c-4.4111,0-8-3.5887-8-8s3.5889-8,8-8h12c4.4111,0,8,3.5887,8,8s-3.5889,8-8,8ZM10,9.991c-3.3086,0-6,2.6917-6,6s2.6914,6,6,6h12c3.3086,0,6-2.6917,6-6s-2.6914-6-6-6c0,0-12,0-12,0ZM13,15.991c0-1.6569-1.3431-3-3-3s-3,1.3431-3,3,1.3431,3,3,3,3-1.3431,3-3Z"
  })), children);
})));
if (false) {}
const ToggleOn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToggleOn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M10,7.991h12c4.4111,0,8,3.5887,8,8s-3.5889,8-8,8h-12c-4.4111,0-8-3.5887-8-8S5.5889,7.991,10,7.991ZM22,21.991c3.3086,0,6-2.6917,6-6s-2.6914-6-6-6h-12c-3.3086,0-6,2.6917-6,6s2.6914,6,6,6h12ZM19,15.991c0,1.6569,1.3431,3,3,3s3-1.3431,3-3-1.3431-3-3-3-3,1.3431-3,3Z"
  })), children);
})));
if (false) {}
const ToolBox = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToolBox({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M27,9H24V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6V9H5a3,3,0,0,0-3,3V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V12A3,3,0,0,0,27,9ZM10,6H22V9H10ZM28,26H4V17h8v5h8V17h8ZM14,17h4v3H14ZM4,15V12a1,1,0,0,1,1-1H27a1,1,0,0,1,1,1v3Z"
  })), children);
})));
if (false) {}
const ToolKit = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToolKit({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9141,24.5l4.257-4.2568-1.414-1.4141L7.5,23.0859l-.793-.7929a.9994.9994,0,0,0-1.414,0l-4,4a.9994.9994,0,0,0,0,1.414l3,3a.9995.9995,0,0,0,1.414,0l4-4a.9994.9994,0,0,0,0-1.414ZM5,28.5859,3.4141,27,6,24.4141,7.5859,26Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24,30a6.0067,6.0067,0,0,1-6-6,5.84,5.84,0,0,1,.2109-1.5469l-8.664-8.6638A5.8483,5.8483,0,0,1,8,14,5.9757,5.9757,0,0,1,2.4228,5.8164l.5577-1.4219L6.293,7.707a1.0233,1.0233,0,0,0,1.4135,0,.999.999,0,0,0,0-1.4141L4.3936,2.979l1.4233-.5571A5.9772,5.9772,0,0,1,14,8a5.84,5.84,0,0,1-.2109,1.5469l8.664,8.6635A5.8548,5.8548,0,0,1,24,18a5.9755,5.9755,0,0,1,5.5771,8.1836L29.02,27.6055,25.707,24.293a1.0233,1.0233,0,0,0-1.4135,0,.999.999,0,0,0-.0005,1.4141L27.6055,29.02l-1.4219.5579A5.96,5.96,0,0,1,24,30ZM10.0625,11.4763,20.5234,21.9375l-.2392.6094A3.9754,3.9754,0,0,0,23.75,27.9922l-.8711-.8711a2.9992,2.9992,0,0,1,0-4.2424,3.0721,3.0721,0,0,1,4.2427.0005l.8706.8708a3.9759,3.9759,0,0,0-5.4458-3.4658l-.6094.2385-10.46-10.46.2392-.6094A3.9755,3.9755,0,0,0,8.2505,4.0078l.8706.8711a2.9992,2.9992,0,0,1,0,4.2424,3.0721,3.0721,0,0,1-4.2427-.0005L4.0078,8.25a3.975,3.975,0,0,0,5.4453,3.4656Z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1226,2.85a3.0716,3.0716,0,0,0-4.2422,0L17.4,10.33l1.4141,1.414,7.48-7.48a1.0244,1.0244,0,0,1,1.4141,0,1.002,1.002,0,0,1,0,1.4145l-7.48,7.48,1.414,1.4141,7.48-7.4795A3.0031,3.0031,0,0,0,29.1226,2.85Z"
  })), children);
})));
if (false) {}
const Tools = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tools({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1,2A9.8,9.8,0,0,0,6.7,3.6L13.1,10a2.1,2.1,0,0,1,.2,3,2.1,2.1,0,0,1-3-.2L3.7,6.4A9.84,9.84,0,0,0,2,12.1,10.14,10.14,0,0,0,12.1,22.2a10.9,10.9,0,0,0,2.6-.3l6.7,6.7a5,5,0,0,0,7.1-7.1l-6.7-6.7a10.9,10.9,0,0,0,.3-2.6A10,10,0,0,0,12.1,2Zm8,10.1a7.61,7.61,0,0,1-.3,2.1l-.3,1.1.8.8L27,22.8a2.88,2.88,0,0,1,.9,2.1A2.72,2.72,0,0,1,27,27a2.9,2.9,0,0,1-4.2,0l-6.7-6.7-.8-.8-1.1.3a7.61,7.61,0,0,1-2.1.3,8.27,8.27,0,0,1-5.7-2.3A7.63,7.63,0,0,1,4,12.1a8.33,8.33,0,0,1,.3-2.2l4.4,4.4a4.14,4.14,0,0,0,5.9.2,4.14,4.14,0,0,0-.2-5.9L10,4.2a6.45,6.45,0,0,1,2-.3,8.27,8.27,0,0,1,5.7,2.3A8.49,8.49,0,0,1,20.1,12.1Z"
  })), children);
})));
if (false) {}
const ToolsAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ToolsAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1,16l6.3-6.3c0.8-0.8,0.8-2,0-2.8l-4.2-4.2c-0.8-0.8-2-0.8-2.8,0L16,8.9L9.7,2.6c-0.8-0.8-2-0.8-2.8,0L2.6,6.8 c-0.8,0.8-0.8,2,0,2.8L8.9,16L2,22.9V30h7.1l6.9-6.9l6.3,6.3c0.8,0.8,2,0.8,2.8,0l4.2-4.2c0.8-0.8,0.8-2,0-2.8L23.1,16z M23.8,4 L28,8.2l-6.3,6.3l-4.2-4.2L23.8,4z M8.2,28H4v-4.2l6.3-6.3l4.2,4.2L8.2,28z M23.8,28L4,8.2L8.2,4l3.5,3.5L9.6,9.6l1.4,1.4l2.1-2.1 l4.2,4.2l-2.1,2.1l1.4,1.4l2.1-2.1l4.2,4.2L21,20.9l1.4,1.4l2.1-2.1l3.5,3.5L23.8,28z"
  })), children);
})));
if (false) {}
const TopDataSets = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TopDataSets({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M14,2.01c-.34-.01-.67-.01-1-.01C7.7,2,2,3.25,2,6v18c0,2.75,5.7,4,11,4,.33,0,.66,0,1-.01v-2.01c-.32.01-.66.02-1,.02-5.85,0-8.85-1.46-9-2v-3.5701c2.13,1.0701,5.64,1.5701,9,1.5701.33,0,.66,0,1-.01v-2.01c-.32.01-.66.02-1,.02-5.85,0-8.85-1.46-9-2v-3.5701c2.13,1.0701,5.64,1.5701,9,1.5701.33,0,.66,0,1-.01,4.99-.1501,10-1.4099,10-3.99v-6c0-2.5801-5.01-3.8401-10-3.99ZM22,11.99c-.15.52-2.82,1.8401-8,1.99-.32.01-.66.02-1,.02-5.85,0-8.85-1.46-9-2v-3.5701c2.13,1.0701,5.64,1.5701,9,1.5701.33,0,.67,0,1-.02,3.04-.0801,6.08-.5898,8-1.55v3.5601ZM14,7.98c-.32.01-.66.02-1,.02-5.84,0-8.84-1.46-9-1.98v-.01c.16-.55,3.16-2.01,9-2.01.34,0,.68.01,1,.02,5.15.1499,7.81,1.4399,8,1.98-.19.54-2.85,1.8301-8,1.98ZM30,28.585l-2.832-2.832c.524-.7905.833-1.7356.833-2.7529,0-2.7568-2.2432-5-5-5s-5,2.2432-5,5,2.2432,5,5,5c1.0173,0,1.9624-.3091,2.7529-.833l2.832,2.832,1.4141-1.4141ZM23.001,26c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3Z"
  })), children);
})));
if (false) {}
const TopPrograms = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TopPrograms({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M29.999,28.5859l-2.832-2.832c.524-.7905.833-1.7356.833-2.7529,0-2.7568-2.2432-5-5-5s-5,2.2432-5,5,2.2432,5,5,5c1.0173,0,1.9624-.3091,2.7529-.833l2.832,2.832,1.4141-1.4141ZM23,26.001c-1.6543,0-3-1.3457-3-3s1.3457-3,3-3,3,1.3457,3,3-1.3457,3-3,3ZM28,2H4c-1.103,0-2,.8975-2,2v20c0,1.1025.897,2,2,2h10v-2H4v-14h24v4h2V4c0-1.1025-.897-2-2-2ZM4,8v-4h24v4H4ZM7,6c0,.5523-.4477,1-1,1s-1-.4477-1-1,.4477-1,1-1,1,.4477,1,1ZM10,6c0,.5523-.4477,1-1,1s-1-.4477-1-1,.4477-1,1-1,1,.4477,1,1Z"
  })), children);
})));
if (false) {}
const Tornado = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tornado({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M16 26H20V28H16z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M12 22H18V24H12z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18H18V20H8z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14H20V16H8z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10H24V12H10z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H26V8H8z"
  })), children);
})));
if (false) {}
const TornadoWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TornadoWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4H18V6H2z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H16V10H4z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H14V14H2z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16H12V18H2z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20H12V22H4z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24H14V26H8z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M12 28H16V30H12z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
})));
if (false) {}
const Touch_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M20,8H18A5,5,0,0,0,8,8H6A7,7,0,0,1,20,8Z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M25,15a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,21,14a2.94,2.94,0,0,0-1.47.4A3,3,0,0,0,16,13.18V8h0a3,3,0,0,0-6,0V19.1L7.77,17.58h0A2.93,2.93,0,0,0,6,17a3,3,0,0,0-2.12,5.13l8,7.3A6.16,6.16,0,0,0,16,31h5a7,7,0,0,0,7-7V18A3,3,0,0,0,25,15Zm1,9a5,5,0,0,1-5,5H16a4.17,4.17,0,0,1-2.76-1L5.29,20.7A1,1,0,0,1,5,20a1,1,0,0,1,1.6-.8L12,22.9V8a1,1,0,0,1,2,0h0V19h2V16a1,1,0,0,1,2,0v3h2V17a1,1,0,0,1,2,0v2h2V18a1,1,0,0,1,2,0Z"
  })), children);
})));
if (false) {}
const Touch_1Filled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_1Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M13,2A6.0067,6.0067,0,0,0,7,8H9a4,4,0,0,1,8,0h2A6.0067,6.0067,0,0,0,13,2Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M21,30H16.5606a4,4,0,0,1-2.7088-1.0566L4.6513,20.4771A2.0018,2.0018,0,0,1,4.77,17.4219a2.0743,2.0743,0,0,1,2.6578.1728L11,20.8569V8a2,2,0,0,1,4,0v7a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v1a2,2,0,0,1,4,0v7A6,6,0,0,1,21,30Z"
  })), children);
})));
if (false) {}
const Touch_1Down = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_1Down({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20,24H18A5,5,0,0,1,8,24H6a7,7,0,0,0,14,0Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M28,14V8a7.0085,7.0085,0,0,0-7-7H16a6.1457,6.1457,0,0,0-4.1055,1.5664L3.8833,9.874a2.9986,2.9986,0,0,0,3.881,4.55l.0008.0012L10,12.8955V24a3,3,0,0,0,6,0h0l0-5.1843a2.939,2.939,0,0,0,3.5294-1.2171A2.963,2.963,0,0,0,21,18a2.9936,2.9936,0,0,0,2.5292-1.4014A2.963,2.963,0,0,0,25,17,3.0033,3.0033,0,0,0,28,14Zm-2,0a1,1,0,0,1-2,0V13H22v2a1,1,0,0,1-2,0V13H18v3a1,1,0,0,1-2,0V13H14V24h.0005A1,1,0,0,1,12,24V9.1045L6.6,12.8008a.9993.9993,0,0,1-1.3081-1.5044l7.9507-7.2515A4.1483,4.1483,0,0,1,16,3h5a5.0059,5.0059,0,0,1,5,5Z"
  })), children);
})));
if (false) {}
const Touch_1DownFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_1DownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30a6.0067,6.0067,0,0,1-6-6H9a4,4,0,0,0,8,0h2A6.0067,6.0067,0,0,1,13,30Z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M21,2H16.5606a4,4,0,0,0-2.7088,1.0566L4.6513,11.5229A2.0018,2.0018,0,0,0,4.77,14.5781a2.0743,2.0743,0,0,0,2.6578-.1728L11,11.1431V24a2,2,0,0,0,4,0V17a2,2,0,0,0,4,0V16a2,2,0,0,0,4,0V15a2,2,0,0,0,4,0V8A6,6,0,0,0,21,2Z"
  })), children);
})));
if (false) {}
const Touch_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M25,28H23V15A7,7,0,1,0,9,15V28H7V15a9,9,0,0,1,18,0Z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M21,20H11V15a5,5,0,0,1,10,0Zm-8-2h6V15a3,3,0,0,0-6,0Z"
  })), children);
})));
if (false) {}
const Touch_2Filled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Touch_2Filled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16,12a3.0033,3.0033,0,0,0-3,3v3h6V15A3.0033,3.0033,0,0,0,16,12Z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a9.0092,9.0092,0,0,0-9,9V28H25V15A9.01,9.01,0,0,0,16,6Zm5,14H11V15a5,5,0,0,1,10,0Z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M29,15H27A11,11,0,0,0,5,15H3a13,13,0,0,1,26,0Z"
  })), children);
})));
if (false) {}
const TouchInteraction = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TouchInteraction({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M26,21V20a1,1,0,0,1,2,0V30h2V20a3.0033,3.0033,0,0,0-3-3,2.964,2.964,0,0,0-1.4708.4014,2.9541,2.9541,0,0,0-4-1A2.9934,2.9934,0,0,0,19,15a2.96,2.96,0,0,0-1,.1846L18,10h0a3,3,0,0,0-6,0V21.1045L9.7651,19.5752l-.0008.001a2.999,2.999,0,0,0-3.881,4.55L12.3223,30l1.3479-1.478L7.2915,22.7036A.9908.9908,0,0,1,7,22a1.0005,1.0005,0,0,1,1.6-.8008L14,24.8955V10a1,1,0,0,1,2,0h0V21h2V18a1,1,0,0,1,2,0v3h2V19a1,1,0,0,1,2,0v2Z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22V10h6V4H4v6H8v2H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2H28a2.0021,2.0021,0,0,1,2,2v6A2.0021,2.0021,0,0,1,28,12Z"
  })), children);
})));
if (false) {}
const Tour = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tour({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "m24,18l-4.7788-6.4019c-.7979-1.0562-1.2212-2.302-1.2212-3.5981,0-3.3083,2.6914-6,6-6s6,2.6917,6,6c0,1.2961-.4233,2.542-1.2246,3.6028l-4.7754,6.3972Zm0-14c-2.2056,0-4,1.7944-4,4,0,.8577.2837,1.6865.8203,2.3972l3.1797,4.2595,3.1763-4.2549c.54-.7153.8237-1.5442.8237-2.4019,0-2.2056-1.7944-4-4-4Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m28,18v4H4V6h10v-2H4c-1.1045,0-2,.8955-2,2v16c0,1.1045.8955,2,2,2h8v4h-4v2h16v-2h-4v-4h8c1.1046,0,2-.8955,2-2v-4h-2Zm-10,10h-4v-4h4v4Z"
  })), children);
})));
if (false) {}
const Trace = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Trace({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M4,27.0001h9.0001v2H4c-1.1,0-2-.9-2-2V3.0001h2v7.9999h9v2H4v6h9v2H4v6.0001ZM10,2.9999v2h20v-2s-20,0-20,0ZM19.0001,13h10.9999v-2h-10.9999v2ZM19.0001,21h10.9999v-2h-10.9999v2ZM19.0001,29.0001h10.9999v-2h-10.9999v2Z"
  })), children);
})));
if (false) {}
const TrafficEvent = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficEvent({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M11 21H17V23H11z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2456,8,25.96,14H30V12H27.4688l-1.3-4.5488A2.0077,2.0077,0,0,0,24.2456,6H22.8972l-.7287-2.5488A2.0077,2.0077,0,0,0,20.2456,2H7.7544A2.0078,2.0078,0,0,0,5.8315,3.4507L4.5312,8H2v2H6.04L7.7544,4H20.2456l.5715,2H11.7544A2.008,2.008,0,0,0,9.8315,7.45L8.8171,11H7.7144a1.9981,1.9981,0,0,0-1.8916,1.3516L4.5715,16H2v2H4v7a2.0025,2.0025,0,0,0,2,2v3H8V27H20v3h2V27a2.0025,2.0025,0,0,0,2-2V18h2V16H23.4287l-1.251-3.6475A1.9988,1.9988,0,0,0,20.2856,11H10.897l.8574-3ZM22,19v2H20v2h2v2H6V23H8V21H6V19Zm-.3429-2H6.3428l1.3716-4H20.2856Z"
  })), children);
})));
if (false) {}
const TrafficFlow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficFlow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8 22 4 18 8 19.41 9.42 21 7.83 21 18 23 18 23 7.83 24.58 9.41 26 8z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M12.59 22.58 11 24.17 11 14 9 14 9 24.17 7.42 22.59 6 24 10 28 14 24 12.59 22.58z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V30H2z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
})));
if (false) {}
const TrafficFlowIncident = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficFlowIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M26 9.42 24.59 8 22.005 10.585 22 10.58 21.995 10.585 19.42 8.01 18 9.42 20.58 12 18 14.58 19.41 16 21.995 13.415 22 13.42 22.005 13.415 24.58 15.99 26 14.58 23.42 12 26 9.42z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.42 12.59 16 10.005 18.585 10 18.58 9.995 18.585 7.42 16.01 6 17.42 8.58 20 6 22.58 7.41 24 9.995 21.415 10 21.42 10.005 21.415 12.58 23.99 14 22.58 11.42 20 14 17.42z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H4V30H2z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), children);
})));
if (false) {}
const TrafficIncident = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M2 28H30V30H2z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M11.314 11.514H17.314V13.514H11.314z",
    transform: "rotate(-45 14.314 12.514)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0815,23.4329l4.1168,2.3176a2.009,2.009,0,0,0,2.3853-.3344l8.8326-8.8326a2.0088,2.0088,0,0,0,.334-2.3856l-2.2977-4.136,1.79-1.79L25.8283,6.8577,24.4141,8.2719l-4.95-4.95a2.0026,2.0026,0,0,0-2.8285,0L14.5146,1.2008,13.1,2.615l2.1213,2.1214L6.7364,13.2216,4.6151,11.1,3.2009,12.5145l2.1213,2.1213a2.0025,2.0025,0,0,0,0,2.8285l4.95,4.95L8.8577,23.8282l1.4143,1.4142Zm13.92-8.2636-8.8328,8.8328-4.5456-2.5255L23.4767,10.6235ZM9.5649,18.8785l1.4142-1.4142L9.5649,16.05,8.1506,17.4643,6.7364,16.05,18.05,4.7364l1.4143,1.4142L18.05,7.5648,19.4644,8.979l1.4142-1.4142L22.2928,8.979,10.9791,20.2927Z"
  })), children);
})));
if (false) {}
const TrafficWeatherIncident = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficWeatherIncident({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M2 24H4V30H2z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V30H28z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V6H15z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10H17V14H15z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18H17V22H15z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M15 26H17V30H15z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12A3.8978,3.8978,0,0,1,2,8.223a3.9017,3.9017,0,0,1,.6533-2.0639L5.17,2.4141a1.0381,1.0381,0,0,1,1.6592,0L9.3154,6.11A3.9693,3.9693,0,0,1,10,8.223,3.8978,3.8978,0,0,1,6,12Zm0-7.2368L4.3438,7.2257A1.89,1.89,0,0,0,4,8.223a1.9007,1.9007,0,0,0,2,1.7775A1.9007,1.9007,0,0,0,8,8.223a1.98,1.98,0,0,0-.375-1.0466Z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M11,11.7627,9.3438,14.2253A1.89,1.89,0,0,0,9,15.2226,1.9007,1.9007,0,0,0,11,17a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M6,15.7627,4.3438,18.2253A1.89,1.89,0,0,0,4,19.2226,1.9007,1.9007,0,0,0,6,21a1.9007,1.9007,0,0,0,2-1.7774,1.98,1.98,0,0,0-.375-1.0467Z"
  })), children);
})));
if (false) {}
const TrafficCone = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrafficCone({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7957,28,18.9746,2.7754A1,1,0,0,0,18,2H14a1,1,0,0,0-.9746.7754L7.2043,28H4v2H28V28ZM19.9736,16H12.0264l.9229-4h6.1014Zm.4616,2,.923,4H10.6418l.923-4Zm-5.64-14h2.4092l1.3845,6H13.4109ZM10.18,24H21.82l.923,4H9.2573Z"
  })), children);
})));
if (false) {}
const Train = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Train({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M21,3H11A5.0057,5.0057,0,0,0,6,8V20a4.99,4.99,0,0,0,3.582,4.77L7.7693,29H9.9451l1.7143-4h8.6812l1.7143,4h2.1758L22.418,24.77A4.99,4.99,0,0,0,26,20V8A5.0057,5.0057,0,0,0,21,3ZM11,5H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,5ZM24,19H21v2h2.8157A2.9948,2.9948,0,0,1,21,23H11a2.9948,2.9948,0,0,1-2.8157-2H11V19H8V17H24Zm0-4H8V9H24Z"
  })), children);
})));
if (false) {}
const TrainHeart = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrainHeart({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,2a2.6613,2.6613,0,0,0-1.9079.8059l-.3932.4053-.397-.4053a2.6612,2.6612,0,0,0-3.8157,0,2.7991,2.7991,0,0,0,0,3.8963L25.0019,11l4.2089-4.2978a2.7991,2.7991,0,0,0,0-3.8963A2.6613,2.6613,0,0,0,27.303,2Z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M22,13v3H6V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V13Zm0,7H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), children);
})));
if (false) {}
const TrainProfile = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrainProfile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25 2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M8,16H2V14H8V12H2V10H8a2.0021,2.0021,0,0,1,2,2v2A2.0021,2.0021,0,0,1,8,16Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M28.55,14.2305,19.97,6.3657A8.9775,8.9775,0,0,0,13.8882,4H2V6H12v4a2.0023,2.0023,0,0,0,2,2h9.1565l4.0417,3.7051A2.4723,2.4723,0,0,1,25.5273,20H2v2H25.5273a4.4726,4.4726,0,0,0,3.0225-7.77ZM14,10V6.0054A6.9774,6.9774,0,0,1,18.6182,7.84L20.9746,10Z"
  })), children);
})));
if (false) {}
const TrainSpeed = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrainSpeed({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M30 25 2 25 2 27 4 27 4 29 6 29 6 27 11 27 11 29 13 29 13 27 18 27 18 29 20 29 20 27 25 27 25 29 27 29 27 27 30 27 30 25z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7144,16.59,18.1494,8.64A14.9327,14.9327,0,0,0,9.6519,6H2V8H9.6519a12.9459,12.9459,0,0,1,7.3647,2.2871L18.0532,11H9v2H20.9624l7.6187,5.2378A.966.966,0,0,1,28.0342,20H2v2H28.0342a2.9661,2.9661,0,0,0,1.68-5.41Z"
  })), children);
})));
if (false) {}
const TrainTicket = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrainTicket({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1257,7.125a1.125,1.125,0,1,1,0-2.25h.875V2h-12V4.875h.875a1.125,1.125,0,0,1,0,2.25h-.875V10h12V7.125Z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0007,13v3h-16V10h9V8H6.185A2.9948,2.9948,0,0,1,9.0007,6h6V4h-6a5.0057,5.0057,0,0,0-5,5V21a4.99,4.99,0,0,0,3.582,4.77L5.77,30H7.9458L9.66,26h8.6812l1.7143,4h2.1758l-1.8127-4.23A4.99,4.99,0,0,0,24.0007,21V13Zm0,7h-3v2h2.8157a2.9948,2.9948,0,0,1-2.8157,2h-10A2.9948,2.9948,0,0,1,6.185,22H9.0007V20h-3V18h16Z"
  })), children);
})));
if (false) {}
const TrainTime = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrainTime({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M25.496 10.088 22.874 7.466 22.874 3 25.124 3 25.124 6.534 27.088 8.498 25.496 10.088z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M24,1a6,6,0,1,0,6,6A6.0066,6.0066,0,0,0,24,1Zm1.4971,9.0884L22.875,7.4658V3h2.25V6.5342l1.9639,1.9634Z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M6,16V10h9V8H6.1843A2.9948,2.9948,0,0,1,9,6h6V4H9A5.0057,5.0057,0,0,0,4,9V21a4.99,4.99,0,0,0,3.582,4.77L5.7693,30H7.9451l1.7143-4h8.6812l1.7143,4h2.1758L20.418,25.77A4.99,4.99,0,0,0,24,21V16Zm16,4H19v2h2.8157A2.9948,2.9948,0,0,1,19,24H9a2.9948,2.9948,0,0,1-2.8157-2H9V20H6V18H22Z"
  })), children);
})));
if (false) {}
const Tram = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tram({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M21,6H17V4h6V2H9V4h6V6H11a5.0057,5.0057,0,0,0-5,5V22a4.99,4.99,0,0,0,3.582,4.77L8.1978,30h2.1757l1.2859-3h8.6812l1.2859,3h2.1757L22.418,26.77A4.99,4.99,0,0,0,26,22V11A5.0057,5.0057,0,0,0,21,6ZM11,8H21a2.9948,2.9948,0,0,1,2.8157,2H8.1843A2.9948,2.9948,0,0,1,11,8ZM24,21H21v2h2.8157A2.9948,2.9948,0,0,1,21,25H11a2.9948,2.9948,0,0,1-2.8157-2H11V21H8V19H24Zm0-4H8V12H24Z"
  })), children);
})));
if (false) {}
const TransformBinary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TransformBinary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M23,20h-2c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C25,19.1,24.1,20,23,20z M21,14v4h2v-4H21z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12H17V20H15z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M11,20H9c-1.1,0-2-0.9-2-2v-4c0-1.1,0.9-2,2-2h2c1.1,0,2,0.9,2,2v4C13,19.1,12.1,20,11,20z M9,14v4h2v-4H9z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
})));
if (false) {}
const TransformCode = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TransformCode({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9005,4.7366c-1.325.4839-2.5369,1.2001-3.5983,2.0895l-1.2829-1.5289c1.2383-1.0377,2.6521-1.8732,4.1979-2.4378l.6832,1.8772ZM3.9009,9.0146c-.8087,1.3865-1.3839,2.9225-1.6776,4.5562l1.9838.3498c.2518-1.3993.7294-2.7205,1.4221-3.9081l-1.7283-.9979ZM4.1932,18.0818l-1.9678.347c.2878,1.6357.8603,3.1745,1.6635,4.5635l1.7302-.9989c-.6884-1.1906-1.1791-2.5095-1.4258-3.9116ZM8.3065,25.1687l-1.293,1.541c1.2365,1.042,2.6556,1.8721,4.2007,2.4393l.6859-1.8845c-1.3211-.489-2.5342-1.203-3.5936-2.0958ZM29.7747,13.5712c-.2878-1.6357-.8603-3.1745-1.6635-4.5635-.8185-1.4156-1.8817-2.67-3.1246-3.7173-1.2365-1.042-2.6557-1.872-4.2007-2.4392-1.493-.5482-3.1035-.8511-4.7858-.8511v2c1.4429,0,2.8219.2625,4.0999.7355,1.321.489,2.5342,1.2031,3.5934,2.0958.4588.3867.8842.8102,1.2835,1.2573.5247.5933.9986,1.2321,1.3982,1.9213.6902,1.1904,1.1827,2.5085,1.4306,3.9084.12.6777.1943,1.3708.1943,2.0817,0,.7123-.0859,1.4019-.2086,2.0792-.2529,1.397-.7322,2.7173-1.4267,3.9049-.7058,1.2069-1.6058,2.2883-2.6725,3.1831-1.061.8899-2.2716,1.6071-3.5941,2.0923-1.2819.4703-2.6584.7405-4.0981.7405v2c1.6817,0,3.2878-.3134,4.7828-.8594,1.5458-.5646,2.9597-1.4001,4.1979-2.4378,1.2458-1.044,2.2957-2.3068,3.1183-3.7174.8087-1.3865,1.3839-2.9225,1.6776-4.5562.1418-.7889.2234-1.5988.2234-2.4292,0-.8298-.0862-1.6384-.2253-2.4288ZM12.7233,14.1082l.9186-.9185.7781-.778-1.4195-1.4117-.6503.6503-1.4218,1.4217-1.729,1.7289-1.1994,1.1993,1.1991,1.1989,1.7292,1.729,1.4218,1.4216.6504.6503,1.4195-1.4118-.7781-.7779-.9186-.9185-1.1173-1.1171-.7748-.7745.7751-.775,1.1171-1.1171ZM19.2768,17.8918l-.9186.9185-.7781.7779,1.4195,1.4118.6504-.6503,1.4218-1.4216,1.7292-1.729,1.1991-1.1989-1.1994-1.1993-1.7291-1.7289-1.4217-1.4217-.6503-.6503-1.4195,1.4117.7781.778.9186.9185,1.1171,1.1171.7751.775-.7748.7745-1.1173,1.1171Z"
  })), children);
})));
if (false) {}
const TransformInstructions = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TransformInstructions({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M23,17v-2h-2.1c-0.1-0.6-0.4-1.2-0.7-1.8l1.5-1.5l-1.4-1.4l-1.5,1.5c-0.5-0.3-1.1-0.6-1.8-0.7V9h-2v2.1 c-0.6,0.1-1.2,0.4-1.8,0.7l-1.5-1.5l-1.4,1.4l1.5,1.5c-0.3,0.5-0.6,1.1-0.7,1.8H9v2h2.1c0.1,0.6,0.4,1.2,0.7,1.8l-1.5,1.5l1.4,1.4 l1.5-1.5c0.5,0.3,1.1,0.6,1.8,0.7V23h2v-2.1c0.6-0.1,1.2-0.4,1.8-0.7l1.5,1.5l1.4-1.4l-1.5-1.5c0.3-0.5,0.6-1.1,0.7-1.8H23z M16,19 c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S17.7,19,16,19z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
})));
if (false) {}
const TransformLanguage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TransformLanguage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19H18V21H10z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15H22V17H10z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11H22V13H10z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2v2c6.6,0,12,5.4,12,12s-5.4,12-12,12v2c7.7,0,14-6.3,14-14S23.7,2,16,2z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M8.2,25.1L7,26.7c1.2,1,2.6,1.9,4.2,2.4l0.7-1.9C10.5,26.7,9.3,26,8.2,25.1z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2,18l-2,0.4C2.5,20,3.1,21.6,3.9,23l1.7-1C4.9,20.8,4.4,19.4,4.2,18z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6,10L3.9,9c-0.8,1.4-1.4,3-1.6,4.6l2,0.3C4.4,12.5,4.9,11.2,5.6,10z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8,4.8l-0.7-1.9C9.6,3.5,8.2,4.3,7,5.3l1.3,1.5C9.3,6,10.5,5.3,11.8,4.8z"
  })), children);
})));
if (false) {}
const Transgender = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Transgender({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M22,2V4h4.5859l-6.4016,6.4014a6.9474,6.9474,0,0,0-8.3686,0L10.4143,9,13,6.4141,11.5857,5,9,7.5859,5.4141,4H10V2H2v8H4V5.4141L7.5859,9,5,11.5854,6.4143,13,9,10.4141l1.4014,1.4013A6.9785,6.9785,0,0,0,15,22.92V25H11v2h4v3h2V27h4V25H17V22.92a6.9785,6.9785,0,0,0,4.5984-11.1045L28,5.4141V10h2V2ZM16,21a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,16,21Z"
  })), children);
})));
if (false) {}
const Translate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Translate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M27.85,29H30L24,14H21.65l-6,15H17.8l1.6-4h6.85ZM20.2,23l2.62-6.56L25.45,23Z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M18,7V5H11V2H9V5H2V7H12.74a14.71,14.71,0,0,1-3.19,6.18A13.5,13.5,0,0,1,7.26,9H5.16a16.47,16.47,0,0,0,3,5.58A16.84,16.84,0,0,1,3,18l.75,1.86A18.47,18.47,0,0,0,9.53,16a16.92,16.92,0,0,0,5.76,3.84L16,18a14.48,14.48,0,0,1-5.12-3.37A17.64,17.64,0,0,0,14.8,7Z"
  })), children);
})));
if (false) {}
const TransmissionLte = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TransmissionLte({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M10.57,30l.9333-2h8.9928l.9333,2h2.2072L17,15.7778V11H15v4.7778L8.3631,30ZM16,18.3647,17.6965,22h-3.393ZM13.37,24h5.26l.9333,2H12.4369Z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7832,9.3325a7.0007,7.0007,0,0,1,10.4341,0l-1.49,1.334a5,5,0,0,0-7.4537,0Z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M7.1992,6.3994a11.0019,11.0019,0,0,1,17.6006,0L23.2,7.6a9.0009,9.0009,0,0,0-14.4014,0Z"
  })), children);
})));
if (false) {}
const Transpose = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Transpose({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M19,26H14V24h5a5.0055,5.0055,0,0,0,5-5V14h2v5A7.0078,7.0078,0,0,1,19,26Z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M8,30H4a2.0023,2.0023,0,0,1-2-2V14a2.0023,2.0023,0,0,1,2-2H8a2.0023,2.0023,0,0,1,2,2V28A2.0023,2.0023,0,0,1,8,30ZM4,14V28H8V14Z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M28,10H14a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2H28a2.0023,2.0023,0,0,1,2,2V8A2.0023,2.0023,0,0,1,28,10ZM14,4V8H28V4Z"
  })), children);
})));
if (false) {}
const TrashCan = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function TrashCan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path372 || (_path372 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 12H14V24H12z"
  })), _path373 || (_path373 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M18 12H20V24H18z"
  })), _path374 || (_path374 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4,6V8H6V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V8h2V6ZM8,28V8H24V28Z"
  })), _path375 || (_path375 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M12 2H20V4H12z"
  })), children);
});
if (false) {}
const Tree = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tree({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0023,2.0023,0,0,1,12,30Z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H19a2.0024,2.0024,0,0,1-2-2V17h6a4.0008,4.0008,0,0,0,3.981-4.396A4.1489,4.1489,0,0,0,22.7853,9H21.2016L21.025,8.221C20.452,5.6961,18.0308,4,15,4A6.02,6.02,0,0,0,9.5585,7.4859L9.25,8.1531l-.863-.1143A2.771,2.771,0,0,0,8,8a4,4,0,1,0,0,8v2A6,6,0,1,1,8,6c.0264,0,.0525,0,.0786.001A8.0271,8.0271,0,0,1,15,2c3.6788,0,6.6923,1.9776,7.7516,5h.0337a6.1641,6.1641,0,0,1,6.1872,5.4141A6.0011,6.0011,0,0,1,23,19l-4,0v9h3Z"
  })), children);
})));
if (false) {}
const TreeFallRisk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TreeFallRisk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z",
    "data-icon-path": "inner-path"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M26,19V17H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19V19Z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6638,5.0059l.96-1.7671A8.9324,8.9324,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4,6.8916,6.8916,0,0,1,18.6638,5.0059Z"
  })), children);
})));
if (false) {}
const TreeView = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TreeView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20V12H22v3H17V7a2,2,0,0,0-2-2H10V2H2v8h8V7h5V25a2,2,0,0,0,2,2h5v3h8V22H22v3H17V17h5v3ZM8,8H4V4H8ZM24,24h4v4H24Zm0-10h4v4H24Z"
  })), children);
})));
if (false) {}
const TreeViewAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TreeViewAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9h6a2,2,0,0,0,2-2V3a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2V4H11V3A2,2,0,0,0,9,1H3A2,2,0,0,0,1,3V7A2,2,0,0,0,3,9H9a2,2,0,0,0,2-2V6h4V26a2.0023,2.0023,0,0,0,2,2h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V25a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V17h4v1a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V14a2,2,0,0,0-2-2H23a2,2,0,0,0-2,2v1H17V6h4V7A2,2,0,0,0,23,9Zm0-6h6V7H23ZM9,7H3V3H9ZM23,25h6v4H23Zm0-11h6v4H23Z",
    transform: "translate(0 .005)"
  })), children);
})));
if (false) {}
const TriangleDownOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleDownOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2.1245,4.4883l13.0195,23.9868c.1865.3438.5212.5249.856.5249.3345,0,.6689-.1812.8555-.5249L29.875,4.4883c.0862-.1582.1255-.3257.125-.4883-.0017-.5229-.4114-1-.9805-1H2.9802c-.5691,0-.9788.4771-.9802,1-.0005.1626.0386.3301.1245.4883Zm25.1985.5117l-11.323,20.8677L4.677,5h22.646Z"
  })), children);
})));
if (false) {}




/***/ }),

/***/ 5090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n5": function() { return /* binding */ User; }
/* harmony export */ });
/* unused harmony exports QU1, QU2, QU3, TriangleDownSolid, TriangleLeftOutline, TriangleLeftSolid, TriangleOutline, TriangleRightOutline, TriangleRightSolid, TriangleSolid, Trigger, Trophy, TrophyFilled, TropicalStorm, TropicalStormModelTracks, TropicalStormTracks, TropicalWarning, Tsq, Tsunami, Tsv, Tuning, TwoFactorAuthentication, TwoPersonLift, Txt, TxtReference, TypePattern, Types, Umbrella, Undefined, UndefinedFilled, Undo, UngroupObjects, Unknown, UnknownFilled, Unlink, Unlocked, Unsaved, UpToTop, UpdateComplete, UpdateNow, Upgrade, Upload, Upstream, Url, UsageIncludedUseCase, Usb, UseCaseDefinition, UseCaseUsage, UserAccess, UserAccessLocked, UserAccessUnlocked, UserActivity, UserAdmin, UserAvatar, UserAvatarFilled, UserAvatarFilledAlt, UserCertification, UserData, UserFavorite, UserFavoriteAlt, UserFavoriteAltFilled, UserFeedback, UserFilled, UserFollow, UserIdentification, UserMilitary, UserMultiple, UserOnline, UserProfile, UserProfileAlt, UserRole, UserService, UserServiceDesk, UserSettings, UserSimulation, UserSpeaker, UserSponsor, UserXRay, UvIndex, UvIndexAlt, UvIndexFilled, ValueVariable, ValueVariableAlt, Van, VegetationAsset, VegetationEncroachment, VegetationHeight, VehicleApi, VehicleConnected, VehicleInsights, VehicleServices, Version, VersionMajor, VersionMinor, VersionPatch, VerticalFold, VerticalView, Video, VideoAdd, VideoChat, VideoFilled, VideoOff, VideoOffFilled, VideoPlayer, View, ViewFilled, ViewMode_1, ViewMode_2, ViewNext, ViewOff, ViewOffFilled, VintageMac, VirtualColumn, VirtualColumnKey, VirtualDesktop, VirtualMachine, VirtualPrivateCloud, VirtualPrivateCloudAlt, VisualInspection, VisualRecognition, Vlan, VlanIbm, VmdkDisk, VoiceActivate */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _Icon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1239);
/**
 * Copyright IBM Corp. 2016, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */






var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _circle, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _circle2, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _circle3, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _circle4, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _circle5, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _circle6, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _circle7, _path323, _path324, _path325, _path326, _circle8, _circle9, _path327, _circle0, _path328, _path329, _path330, _path331, _path332, _path333;
const didWarnAboutDeprecation = {};
const TriangleDownSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleDownSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.0194,3c.5692,0,.979.4772.9806,1,.0005.1628-.0388.3299-.1249.4885l-13.0196,23.9867c-.1865.3435-.521.5248-.8555.5248s-.6694-.1812-.8559-.5248L2.1246,4.4885c-.0861-.1586-.1251-.3257-.1246-.4885.0016-.5228.4111-1,.9803-1h26.0391Z"
  })), children);
})));
if (false) {}
const TriangleLeftOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleLeftOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m27.5117,2.1245L3.5249,15.144c-.3438.1865-.5249.5212-.5249.856,0,.3345.1812.6689.5249.8555l23.9868,13.0195c.1582.0862.3257.1255.4883.125.5229-.0017,1-.4114,1-.9805V2.9802c0-.5691-.4771-.9788-1-.9802-.1626-.0005-.3301.0386-.4883.1245Zm-.5117,25.1985L6.1323,16,27,4.677v22.646Z"
  })), children);
})));
if (false) {}
const TriangleLeftSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleLeftSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29,29.0194c0,.5692-.4772.979-1,.9806-.1628.0005-.3299-.0388-.4885-.1249L3.5248,16.8556c-.3435-.1865-.5248-.521-.5248-.8555s.1812-.6694.5248-.8559L27.5115,2.1246c.1586-.0861.3257-.1251.4885-.1246.5228.0016,1,.4111,1,.9803v26.0391Z"
  })), children);
})));
if (false) {}
const TriangleOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m29.8755,27.5117L16.856,3.5249c-.1865-.3438-.5212-.5249-.856-.5249-.3345,0-.6689.1812-.8555.5249L2.125,27.5117c-.0862.1582-.1255.3257-.125.4883.0017.5229.4114,1,.9805,1h26.0393c.5691,0,.9788-.4771.9802-1,.0005-.1626-.0386-.3301-.1245-.4883Zm-25.1985-.5117L16,6.1323l11.323,20.8677H4.677Z"
  })), children);
})));
if (false) {}
const TriangleRightOutline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleRightOutline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m4.4883,29.8755l23.9868-13.0195c.3438-.1865.5249-.5212.5249-.856,0-.3345-.1812-.6689-.5249-.8555L4.4883,2.125c-.1582-.0862-.3257-.1255-.4883-.125-.5229.0017-1,.4114-1,.9805v26.0393c0,.5691.4771.9788,1,.9802.1626.0005.3301-.0386.4883-.1245Zm.5117-25.1985l20.8677,11.323L5,27.323V4.677Z"
  })), children);
})));
if (false) {}
const TriangleRightSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleRightSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m3,2.9806c0-.5692.4772-.979,1-.9806.1628-.0005.3299.0388.4885.1249l23.9867,13.0196c.3435.1865.5248.521.5248.8555s-.1812.6694-.5248.8559L4.4885,29.8754c-.1586.0861-.3257.1251-.4885.1246-.5228-.0016-1-.4111-1-.9803V2.9806Z"
  })), children);
})));
if (false) {}
const TriangleSolid = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TriangleSolid({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2.9806,29c-.5692,0-.979-.4772-.9806-1-.0005-.1628.0388-.3299.1249-.4885L15.1444,3.5248c.1865-.3435.521-.5248.8555-.5248s.6694.1812.8559.5248l13.0195,23.9867c.0861.1586.1251.3257.1246.4885-.0016.5228-.4111,1-.9803,1H2.9806Z"
  })), children);
})));
if (false) {}
const Trigger = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Trigger({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2,19l1.4,1.4,5.6-5.6,5.6,5.6,1.4-1.4-7-7-7,7ZM28.6,11.6l-5.6,5.6-5.6-5.6-1.4,1.4,7,7,7-7-1.4-1.4ZM9,22c-1.1046,0-2,.8954-2,2s.8954,2,2,2,2-.8954,2-2-.8954-2-2-2ZM23,10c1.1046,0,2-.8954,2-2s-.8954-2-2-2-2,.8954-2,2,.8954,2,2,2Z"
  })), children);
})));
if (false) {}
const Trophy = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Trophy({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm14,0a6,6,0,0,1-6.1855,5.9971A6.1991,6.1991,0,0,1,10,13.7065V6H22Zm4-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
})));
if (false) {}
const TrophyFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TrophyFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M26,7H24V6a2.0023,2.0023,0,0,0-2-2H10A2.0023,2.0023,0,0,0,8,6V7H6A2.0023,2.0023,0,0,0,4,9v3a4.0045,4.0045,0,0,0,4,4h.322A8.1689,8.1689,0,0,0,15,21.9341V26H10v2H22V26H17V21.9311A7.9661,7.9661,0,0,0,23.74,16H24a4.0045,4.0045,0,0,0,4-4V9A2.0023,2.0023,0,0,0,26,7ZM8,14a2.0023,2.0023,0,0,1-2-2V9H8Zm18-2a2.0023,2.0023,0,0,1-2,2V9h2Z"
  })), children);
})));
if (false) {}
const TropicalStorm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TropicalStorm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6521,4.1821l-2.177,2.5142L19.0713,8.3174,20.7864,9.605A7.9361,7.9361,0,0,1,23.9963,16l.0008.0576.0017.0415c.018.4317.2412,10.1113-14.6538,11.7222l2.18-2.5176,1.4039-1.6211L11.2139,22.395A7.9361,7.9361,0,0,1,8.0037,16l-.0008-.0576-.0017-.0415C7.9832,15.47,7.7605,5.8071,22.6521,4.1821M24.9978,2c-.0164,0-.0327,0-.0493.001C5.2532,2.9146,6.0037,16,6.0037,16a9.975,9.975,0,0,0,4.0095,7.9946L6.2368,28.3555A1.0044,1.0044,0,0,0,7.0022,30c.0164,0,.0327,0,.0493-.001C26.7468,29.0854,25.9963,16,25.9963,16a9.9756,9.9756,0,0,0-4.0092-7.9946l3.7761-4.3609A1.0044,1.0044,0,0,0,24.9978,2Z"
  })), children);
})));
if (false) {}
const TropicalStormModelTracks = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TropicalStormModelTracks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10,17a4,4,0,1,1,4-4A4.0045,4.0045,0,0,1,10,17Zm0-6a2,2,0,1,0,2,2A2.0021,2.0021,0,0,0,10,11Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8188,6.65c.1163-.1211,1.8643-1.919,2.8882-2.9434A1,1,0,0,0,17,2C11.812,2,2,4.2988,2,13a7.8938,7.8938,0,0,0,3.1812,6.35c-.1612.1675-1.9507,2.0054-2.8882,2.9429A1,1,0,0,0,3,24c5.188,0,15-2.2988,15-11A7.8927,7.8927,0,0,0,14.8188,6.65ZM9.7065,20.793a20.94,20.94,0,0,1-4.0932.9853c.1621-.166,2.7685-2.9053,2.7685-2.9053l-1.1743-.6074A5.9064,5.9064,0,0,1,4,13c0-3.667,2.1177-6.2886,6.2935-7.793a20.94,20.94,0,0,1,4.0932-.9853c-.227.2324-2.769,2.9057-2.769,2.9057l1.1748.607A5.9075,5.9075,0,0,1,16,13C16,16.667,13.8823,19.2886,9.7065,20.793Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17l-5-5-5,5,1.4126,1.4155L24,15.8325V19a9.01,9.01,0,0,1-9,9H12v2h3A11.0125,11.0125,0,0,0,26,19V15.8325l2.5859,2.5816Z"
  })), children);
})));
if (false) {}
const TropicalStormTracks = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TropicalStormTracks({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16,21a5,5,0,1,1,5-5A5.0057,5.0057,0,0,1,16,21Zm0-8a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,16,13Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.86,12.4805h0a12.9277,12.9277,0,0,0-4.8575-4.9991q.2044-.213.4424-.4589h0c.82-.8482,1.93-1.9825,3.2622-3.3155A1,1,0,0,0,25,2c-.354,0-8.7363.0488-14.269,4.3018h0A12.15,12.15,0,0,0,7.481,9.998c-.1416-.1367-.295-.2841-.4585-.4423C6.1743,8.7349,5.04,7.6255,3.707,6.293A1,1,0,0,0,2,7c0,.3594.05,8.874,4.4058,14.4023a12.1023,12.1023,0,0,0,3.5918,3.1163c-.21.2177-.4346.4516-.6563.68h0c-.7954.8208-1.8286,1.8745-3.0483,3.0943A1,1,0,0,0,7,30c.2856,0,7.061-.0352,12.459-3.1055a12.9618,12.9618,0,0,0,5.06-4.8925q.3062.2937.68.6567c.82.7954,1.8745,1.8286,3.0943,3.0483A1,1,0,0,0,30,25C30,24.7119,29.9644,17.8877,26.86,12.4805Zm-3.03,6.1074-.5469,1.3672A10.5415,10.5415,0,0,1,18.47,25.1562,24.3514,24.3514,0,0,1,9.584,27.8135c.4409-.4492,3.8281-3.9824,3.8281-3.9824l-1.3682-.5474a9.8021,9.8021,0,0,1-4.0668-3.1191c-2.5406-3.2242-3.4585-7.7623-3.79-10.58.5435.5337,3.9815,3.8266,3.9815,3.8266l.5468-1.3672A9.8569,9.8569,0,0,1,11.95,7.8877h0C15.1665,5.415,19.6309,4.5146,22.4155,4.187c-.5332.5435-3.8276,3.9819-3.8276,3.9819l1.3677.5469a10.52,10.52,0,0,1,5.17,4.7608v0a24.29,24.29,0,0,1,2.688,8.94C27.3643,21.9751,23.83,18.5879,23.83,18.5879Z"
  })), children);
})));
if (false) {}
const TropicalWarning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TropicalWarning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9487,25.6836a1,1,0,0,0-1.8955-.0049A3.44,3.44,0,0,1,23,28a3.44,3.44,0,0,1-3.0532-2.3213,1,1,0,0,0-1.8955.0049A3.4376,3.4376,0,0,1,15,28h-.4336C13.9241,26.7939,12,22.312,12,12v-.1313l1.1169.7446A6.46,6.46,0,0,1,14.4346,13.79l1.0007-1.8418a8.4469,8.4469,0,0,0-1.209-.9986L12.8025,10h1.5308a6.9861,6.9861,0,0,1,1.9934.3071l.9755-1.7954A9.0059,9.0059,0,0,0,14.3333,8H13.1169A7.0329,7.0329,0,0,1,18,6h.6669l1.0867-2H18a9.0361,9.0361,0,0,0-7,3.3638A9.0362,9.0362,0,0,0,4,4H2V6H4A7.0308,7.0308,0,0,1,8.8828,8H7.6665a9.06,9.06,0,0,0-5.4,1.8L.4,11.2l1.2,1.6L3.4668,11.4a7.04,7.04,0,0,1,4.2-1.4H9.1973l-1.4239.9492A8.457,8.457,0,0,0,4,18H6a6.46,6.46,0,0,1,2.8828-5.3867L10,11.8687V12c0,8.9365,1.3994,13.7539,2.355,16H2v2H15a4.9316,4.9316,0,0,0,4-1.9873,5.0192,5.0192,0,0,0,8,0,4.9955,4.9955,0,0,0,3,1.8833V27.8125A3.7616,3.7616,0,0,1,27.9487,25.6836Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M23.75,10h-1.5V6h1.5ZM23,11a1,1,0,1,0,1,1A1,1,0,0,0,23,11Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9115,13.9355,23.6284,2.3706a.7181.7181,0,0,0-1.2568,0L16.0885,13.9355A.72.72,0,0,0,16.72,15H29.28A.72.72,0,0,0,29.9115,13.9355ZM22.25,6h1.5v4h-1.5ZM23,13a1,1,0,1,1,1-1A1,1,0,0,1,23,13Z"
  })), children);
})));
if (false) {}
const Tsq = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tsq({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H30V28H19z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M19 22H30V24H19z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30,20h-11V12h11v8Zm-9-2h7v-4h-7v4Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H30V10H19z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M19 4H30V6H19z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.293 18.707 8 16.4143 8 12 10 12 10 15.5857 11.707 17.293 10.293 18.707z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9,24c-4.4111,0-8-3.5889-8-8s3.5889-8,8-8,8,3.5889,8,8-3.5889,8-8,8Zm0-14c-3.3083,0-6,2.6917-6,6s2.6917,6,6,6,6-2.6917,6-6-2.6917-6-6-6Z"
  })), children);
})));
if (false) {}
const Tsunami = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tsunami({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M30,26H24A10.0349,10.0349,0,0,1,17.0732,8.7378,11.9629,11.9629,0,0,0,12.9937,8a6.9027,6.9027,0,0,0-6.0308,3.42C4.9966,14.4348,4,19.34,4,26H2c0-7.0542,1.106-12.3274,3.2871-15.6726A8.906,8.906,0,0,1,12.9937,6h.0068a14.762,14.762,0,0,1,6.4619,1.592,1,1,0,0,1,.0869,1.7222A8.0249,8.0249,0,0,0,24,24h6Z"
  })), children);
})));
if (false) {}
const Tsv = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tsv({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M28 9 26 22 24 9 22 9 24.516 23 27.484 23 30 9 28 9z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M18,23H12V21h6V17H14a2.002,2.002,0,0,1-2-2V11a2.002,2.002,0,0,1,2-2h6v2H14v4h4a2.002,2.002,0,0,1,2,2v4A2.002,2.002,0,0,1,18,23Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11 5 11 5 23 7 23 7 11 10 11 10 9 2 9 2 11z"
  })), children);
})));
if (false) {}
const Tuning = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Tuning({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m24,30v-4.1c2.3-.5,4-2.5,4-4.9,0-2.4-1.7-4.4-4-4.9V2s-2,0-2,0v14.1c-2.3.5-4,2.5-4,4.9,0,2.4,1.7,4.4,4,4.9v4.1s2,0,2,0Zm-4-9c0-1.7,1.3-3,3-3s3,1.3,3,3c0,1.7-1.3,3-3,3s-3-1.3-3-3Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m8,2v4.1c-2.3.5-4,2.5-4,4.9,0,2.4,1.7,4.4,4,4.9v14.1s2,0,2,0v-14.1c2.3-.5,4-2.5,4-4.9,0-2.4-1.7-4.4-4-4.9V2s-2,0-2,0Zm4,9c0,1.7-1.3,3-3,3s-3-1.3-3-3,1.3-3,3-3,3,1.3,3,3Z"
  })), children);
})));
if (false) {}
const TwoFactorAuthentication = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TwoFactorAuthentication({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23.18 9 21.179 7.589 22.589 11 26 17 20 15.59 18.59 11 23.18z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H24V28h4V16H24V8a4.0045,4.0045,0,0,0-4-4V2a6.0067,6.0067,0,0,1,6,6v6h2a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M20,14H18V8A6,6,0,0,0,6,8v6H4a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V16A2,2,0,0,0,20,14ZM8,8a4,4,0,0,1,8,0v6H8ZM20,28H4V16H20Z"
  })), children);
})));
if (false) {}
const TwoPersonLift = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TwoPersonLift({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M26.96,30l-1.9215-6.7253a1.0008,1.0008,0,0,1,.3369-1.0554L29.874,18.62,28.52,13.2014l-2.7382,3.4234A1.0026,1.0026,0,0,1,25,17H20V15h4.52l3.6993-4.6248a1,1,0,0,1,1.7509.3824l2,8a.9989.9989,0,0,1-.3447,1.0232l-4.48,3.5845,1.7389,6.0854Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M23,5.5A3.5,3.5,0,1,1,26.5,9,3.5042,3.5042,0,0,1,23,5.5Zm2,0A1.5,1.5,0,1,0,26.5,4,1.5017,1.5017,0,0,0,25,5.5Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0039,19A2.0039,2.0039,0,0,1,18,16.9961V15.0039A2.0039,2.0039,0,0,1,20.0039,13H22V10H10v3h1.9961A2.0039,2.0039,0,0,1,14,15.0039v1.9922A2.0039,2.0039,0,0,1,11.9961,19H10v3H22V19Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04,30l1.9215-6.7253a1.0013,1.0013,0,0,0-.3369-1.0555L2.126,18.62l1.3545-5.4185,2.7382,3.4234A1.0026,1.0026,0,0,0,7,17h5V15H7.4805L3.7812,10.3752a1,1,0,0,0-1.7509.3824l-2,8A.9989.9989,0,0,0,.375,19.7808l4.4805,3.5844-1.739,6.0855Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,9A3.5,3.5,0,1,1,9,5.5,3.5042,3.5042,0,0,1,5.5,9Zm0-5A1.5,1.5,0,1,0,7,5.5,1.5017,1.5017,0,0,0,5.5,4Z"
  })), children);
})));
if (false) {}
const Txt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Txt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21 11 24 11 24 23 26 23 26 11 29 11 29 9 21 9 21 11z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9 18 9 16 15 14 9 12 9 14.75 16 12 23 14 23 16 17 18 23 20 23 17.25 16 20 9z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3 11 6 11 6 23 8 23 8 11 11 11 11 9 3 9 3 11z"
  })), children);
})));
if (false) {}
const TxtReference = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TxtReference({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M4 20 4 22 8.586 22 2 28.586 3.414 30 10 23.414 10 28 12 28 12 20 4 20z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21 4 24 4 24 16 26 16 26 4 29 4 29 2 21 2 21 4z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20 2 18 2 16 8 14 2 12 2 14.752 9 12 16 14 16 16 10 18 16 20 16 17.245 9 20 2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4 6 4 6 16 8 16 8 4 11 4 11 2 3 2 3 4z"
  })), children);
})));
if (false) {}
const TypePattern = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function TypePattern({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M30 15 17 15 17 2 15 2 15 15 2 15 2 17 15 17 15 30 17 30 17 17 30 17 30 15z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M25.586 20 27 21.414 23.414 25 27 28.586 25.586 30 20.586 25 25.586 20z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30H3a1,1,0,0,1-.8945-1.4473l4-8a1.0412,1.0412,0,0,1,1.789,0l4,8A1,1,0,0,1,11,30ZM4.6182,28H9.3818L7,23.2363Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28,12H22a2.0023,2.0023,0,0,1-2-2V4a2.0023,2.0023,0,0,1,2-2h6a2.0023,2.0023,0,0,1,2,2v6A2.0023,2.0023,0,0,1,28,12ZM22,4v6h6.001L28,4Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12a5,5,0,1,1,5-5A5.0059,5.0059,0,0,1,7,12ZM7,4a3,3,0,1,0,3,3A3.0033,3.0033,0,0,0,7,4Z"
  })), children);
})));
if (false) {}
const Types = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Types({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16 22 24 20.586 22.586 27.172 16 20.586 9.414 22 8 30 16z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a.9967.9967,0,0,1-.707-.293l-5-5a.9994.9994,0,0,1,0-1.414l5-5a.9994.9994,0,0,1,1.414,0l5,5a.9994.9994,0,0,1,0,1.414l-5,5A.9967.9967,0,0,1,16,22Zm-3.5859-6L16,19.5859,19.5859,16,16,12.4141Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M2 16 10 8 11.414 9.414 4.828 16 11.414 22.586 10 24 2 16z"
  })), children);
})));
if (false) {}
const QU1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QU1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21 22 9 17 9 17 11 20 11 20 21 17 21 17 23 25 23 25 21 22 21z"
  })), children);
})));
if (false) {}
const QU2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QU2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23H17V17a2,2,0,0,1,2-2h4V11H17V9h6a2,2,0,0,1,2,2v4a2,2,0,0,1-2,2H19v4h6Z"
  })), children);
})));
if (false) {}
const QU3 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function QU3({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M13,23H9a2,2,0,0,1-2-2V9H9V21h4V9h2V21A2,2,0,0,1,13,23Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M23,9H17v2h6v4H18v2h5v4H17v2h6a2,2,0,0,0,2-2V11A2,2,0,0,0,23,9Z"
  })), children);
})));
if (false) {}
const Umbrella = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Umbrella({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9854,15.83A14.3808,14.3808,0,0,0,17,4.0464V2H15V4.0464A14.3808,14.3808,0,0,0,2.0146,15.83,1,1,0,0,0,3.51,16.86,4.8551,4.8551,0,0,1,6,16a4.8653,4.8653,0,0,1,4.1406,2.5107,1.0393,1.0393,0,0,0,1.7188,0A5.02,5.02,0,0,1,15,16.1255V25.5a2.5,2.5,0,0,1-5,0V25H8v.5a4.5,4.5,0,0,0,9,0V16.1255a5.02,5.02,0,0,1,3.1406,2.3852.9994.9994,0,0,0,1.7188,0A4.8653,4.8653,0,0,1,26,16a4.8551,4.8551,0,0,1,2.49.86,1,1,0,0,0,1.4957-1.03ZM6,14a5.4079,5.4079,0,0,0-1.5034.2134,12.4411,12.4411,0,0,1,8.488-7.8145A14.5157,14.5157,0,0,0,9.939,15.333,6.5439,6.5439,0,0,0,6,14Zm10,0a6.5528,6.5528,0,0,0-4.0564,1.4307c.0378-2.22.6089-6.49,4.0563-9.1763,3.4308,2.6768,4.0091,6.9487,4.0525,9.1728A6.553,6.553,0,0,0,16,14Zm10,0a6.5439,6.5439,0,0,0-3.939,1.333,14.5164,14.5164,0,0,0-3.0456-8.9341,12.4411,12.4411,0,0,1,8.488,7.8145A5.4079,5.4079,0,0,0,26,14Z"
  })), children);
})));
if (false) {}
const Undefined = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Undefined({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H21V18H11z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
})));
if (false) {}
const UndefinedFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UndefinedFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M21,18H11v-4h10V18z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M11 14H21V18H11z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const Undo = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Undo({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M20,10H7.8149l3.5874-3.5859L10,5,4,11,10,17l1.4023-1.4146L7.8179,12H20a6,6,0,0,1,0,12H12v2h8a8,8,0,0,0,0-16Z"
  })), children);
})));
if (false) {}
const UngroupObjects = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UngroupObjects({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M30,14V10H26v2H20V6h2V2H18V4H6V2H2V6H4V18H2v4H6V20h6v6H10v4h4V28H26v2h4V26H28V14ZM6,6H18V18H6ZM26,26H14V20h4v2h4V18H20V14h6Z"
  })), children);
})));
if (false) {}
const Unknown = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Unknown({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "22.5",
    r: "1.5"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17,19h-2v-4h2c1.103,0,2-0.897,2-2s-0.897-2-2-2h-2c-1.103,0-2,0.897-2,2v0.5h-2V13c0-2.206,1.794-4,4-4h2 c2.206,0,4,1.794,4,4s-1.794,4-4,4V19z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2c-0.533,0-1.067,0.203-1.473,0.609L2.609,14.527 C2.203,14.933,2,15.466,2,16s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30c0.533,0,1.067-0.203,1.473-0.609 l11.917-11.917C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,28.036L3.965,16L16,3.964L28.036,16L16,28.036z"
  })), children);
})));
if (false) {}
const UnknownFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UnknownFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M29.391,14.527L17.473,2.609C17.067,2.203,16.533,2,16,2s-1.067,0.203-1.473,0.609L2.609,14.527C2.203,14.933,2,15.466,2,16 s0.203,1.067,0.609,1.473l11.917,11.917C14.933,29.797,15.467,30,16,30s1.067-0.203,1.473-0.609l11.917-11.917 C29.797,17.067,30,16.534,30,16S29.797,14.933,29.391,14.527z M16,24c-0.828,0-1.5-0.671-1.5-1.5S15.172,21,16,21s1.5,0.671,1.5,1.5 S16.828,24,16,24z M17.125,17.248v1.877h-2.25V15H17c1.034,0,1.875-0.841,1.875-1.875S18.034,11.25,17,11.25h-2 c-1.034,0-1.875,0.841-1.875,1.875v0.5h-2.25v-0.5C10.875,10.851,12.726,9,15,9h2c2.274,0,4.125,1.851,4.125,4.125 C21.125,15.358,19.342,17.182,17.125,17.248z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M16,21c0.828,0,1.5,0.672,1.5,1.5S16.828,24,16,24c-0.828,0-1.5-0.672-1.5-1.5S15.172,21,16,21 z M17.125,17.248c2.217-0.066,4-1.89,4-4.123C21.125,10.851,19.274,9,17,9h-2c-2.274,0-4.125,1.851-4.125,4.125v0.5h2.25v-0.5 c0-1.034,0.841-1.875,1.875-1.875h2c1.034,0,1.875,0.841,1.875,1.875S18.034,15,17,15h-2.125v4.125h2.25V17.248z",
    "data-icon-path": "inner-path"
  })), children);
})));
if (false) {}
const Unlink = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Unlink({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3.59H7V8.42H5z",
    transform: "rotate(-45.01 5.996 6.005)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23.58H27V28.409999999999997H25z",
    transform: "rotate(-44.99 25.995 25.999)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2H13V6H11z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11H6V13H2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19H30V21H26z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M19 26H21V30H19z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M16.58,21.07l-3.71,3.72a4,4,0,1,1-5.66-5.66l3.72-3.72L9.51,14,5.8,17.72a6,6,0,0,0-.06,8.54A6,6,0,0,0,10,28a6.07,6.07,0,0,0,4.32-1.8L18,22.49Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M15.41,10.93l3.72-3.72a4,4,0,1,1,5.66,5.66l-3.72,3.72L22.49,18l3.71-3.72a6,6,0,0,0,.06-8.54A6,6,0,0,0,22,4a6.07,6.07,0,0,0-4.32,1.8L14,9.51Z"
  })), children);
})));
if (false) {}
const Unlocked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Unlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
      d: "M12,7H6V4c0-1.1,0.9-2,2-2s2,0.9,2,2h1c0-1.7-1.3-3-3-3S5,2.3,5,4v3H4C3.4,7,3,7.4,3,8v6c0,0.6,0.4,1,1,1h8c0.6,0,1-0.4,1-1 V8C13,7.4,12.6,7,12,7z M12,14H4V8h8V14z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M24,14H12V8a4,4,0,0,1,8,0h2A6,6,0,0,0,10,8v6H8a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H24a2,2,0,0,0,2-2V16A2,2,0,0,0,24,14Zm0,14H8V16H24Z"
  })), children);
})));
if (false) {}
const Unsaved = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Unsaved({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.4 28.6 18 25 21.6 21.4 18 20 19.4 23.6 23 20 26.6 21.4 28 25 24.4 28.6 28 30 26.6 26.4 23z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M16,26l-4,0v-8l4,0v-2l-4,0c-1.1,0-2,0.9-2,2v8H6V6h4v4c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V6.4l4,4l0,5.6h2l0-6 c0-0.3-0.1-0.5-0.3-0.7l-5-5C22.5,4.1,22.3,4,22,4H6C4.9,4,4,4.9,4,6v20c0,1.1,0.9,2,2,2l10,0V26z M12,6h8v4h-8V6z"
  })), children);
})));
if (false) {}
const UpToTop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UpToTop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14 6 24 7.4 25.4 16 16.8 24.6 25.4 26 24z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M4 8H28V10H4z"
  })), children);
})));
if (false) {}
const UpdateComplete = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UpdateComplete({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30c-7.72,0-14-6.28-14-14h2c0,6.617,5.383,12,12,12v2ZM12,8h-4.922c2.258-2.524,5.467-4,8.922-4,6.617,0,12,5.383,12,12h2c0-7.72-6.28-14-14-14-3.828,0-7.393,1.558-10,4.234V2h-2v8h8v-2ZM22,27.18l-2.59-2.59-1.41,1.41,4,4,8-8-1.41-1.41s-6.59,6.59-6.59,6.59Z"
  })), children);
})));
if (false) {}
const UpdateNow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UpdateNow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.586 25 23.586 25 21 23 21 23 24.414 25.586 27 27 25.586z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24,31a7,7,0,1,1,7-7A7.0078,7.0078,0,0,1,24,31Zm0-12a5,5,0,1,0,5,5A5.0055,5.0055,0,0,0,24,19Z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M16,28A12.0134,12.0134,0,0,1,4,16H2A14.0158,14.0158,0,0,0,16,30Z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M12,8H7.0784A11.9843,11.9843,0,0,1,28,16h2A13.9778,13.9778,0,0,0,6,6.2344V2H4v8h8Z"
  })), children);
})));
if (false) {}
const Upgrade = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Upgrade({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M21,24H11a2,2,0,0,0-2,2v2a2,2,0,0,0,2,2H21a2,2,0,0,0,2-2V26A2,2,0,0,0,21,24Zm0,4H11V26H21Z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M28.707,14.293l-12-12a.9994.9994,0,0,0-1.414,0l-12,12A1,1,0,0,0,4,16H9v4a2.0023,2.0023,0,0,0,2,2H21a2.0027,2.0027,0,0,0,2-2V16h5a1,1,0,0,0,.707-1.707ZM21,14v6H11V14H6.4141L16,4.4141,25.5859,14Z"
  })), children);
})));
if (false) {}
const Upload = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Upload({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
      d: "M3 9 3.7 9.7 7.5 5.9 7.5 15 8.5 15 8.5 5.9 12.3 9.7 13 9 8 4z"
    })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
      d: "M3,4V2h10v2h1V2c0-0.6-0.4-1-1-1H3C2.4,1,2,1.4,2,2v2H3z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18 7.41 19.41 15 11.83 15 30 17 30 17 11.83 24.59 19.41 26 18 16 8 6 18z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M6,8V4H26V8h2V4a2,2,0,0,0-2-2H6A2,2,0,0,0,4,4V8Z"
  })), children);
})));
if (false) {}
const Upstream = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Upstream({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m10,24c0,3.3137,2.6863,6,6,6s6-2.6863,6-6-2.6863-6-6-6-6,2.6863-6,6Zm2,0c0-2.2056,1.7944-4,4-4s4,1.7944,4,4-1.7944,4-4,4-4-1.7944-4-4Z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "m30,5c0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.1836c0,1.7217-.752,3.3438-2,4.4673v-2.4673h-2v6h6v-2h-2.7168c1.6938-1.4995,2.7168-3.6816,2.7168-6v-5.1836c1.1626-.4136,2-1.5122,2-2.8164Zm-3,1c-.5522,0-1-.4478-1-1s.4478-1,1-1,1,.4478,1,1-.4478,1-1,1Z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "m18.586,11.5859l-1.5859,1.5859v-5.3555c1.1626-.4136,2-1.5122,2-2.8164,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.3555l-1.5859-1.5859-1.4141,1.4141,4,4,4-4-1.4141-1.4141Zm-2.5859-7.5859c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1Z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m8,15v2.4673c-1.248-1.1235-2-2.7456-2-4.4673v-5.1836c1.1626-.4136,2-1.5122,2-2.8164,0-1.6567-1.3433-3-3-3s-3,1.3433-3,3c0,1.3042.8374,2.4028,2,2.8164v5.1836c0,2.3184,1.0229,4.5005,2.7168,6h-2.7168v2h6v-6h-2Zm-3-11c.5522,0,1,.4478,1,1s-.4478,1-1,1-1-.4478-1-1,.4478-1,1-1Z"
  })), children);
})));
if (false) {}
const Url = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Url({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "M24 21 24 9 22 9 22 23 30 23 30 21 24 21z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m20,15v-4c0-1.103-.8975-2-2-2h-6v14h2v-6h1.4807l2.3345,6h2.1453l-2.3331-6h.3726c1.1025,0,2-.8975,2-2Zm-6-4h4v4h-4v-4Z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,23h-4c-1.103,0-2-.8975-2-2v-12h2v12h4v-12h2v12c0,1.1025-.897,2-2,2Z"
  })), children);
})));
if (false) {}
const UsageIncludedUseCase = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UsageIncludedUseCase({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m13,28V5.8281l7.5859,7.5859,1.4141-1.4141L12,2,2,12l1.4143,1.4141,7.5857-7.5854v22.1714c0,1.1045.8955,2,2,2h15v-2h-15Z"
  })), children);
})));
if (false) {}
const Usb = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Usb({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M24,15V6a2,2,0,0,0-2-2H10A2,2,0,0,0,8,6v9a2,2,0,0,0-2,2V28H8V17H24V28h2V17A2,2,0,0,0,24,15ZM10,6H22v9H10Z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10H15V12H12z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10H20V12H17z"
  })), children);
})));
if (false) {}
const UseCaseDefinition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UseCaseDefinition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.0735,21.9922c1.7068,0,2.9407-.7773,3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828,1.386-1.859,1.386-1.2002,0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787,1.8086-2.0787.9294,0,1.4871.5409,1.6899,1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603,0-4.0735,1.7744-4.0735,4.5969,0,2.8394,1.4705,4.6311,4.0735,4.6311Z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.5126,21.9922c3.3129,0,4.5468-1.572,4.5468-5.0369v-6.9631h-2.1973v7.2507c0,1.8422-.6423,2.772-2.3324,2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0,3.4648,1.2,5.0369,4.5126,5.0369Z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m2,4v24c0,1.1046.8954,2,2,2h24c1.1046,0,2-.8954,2-2V4c0-1.1046-.8954-2-2-2H4c-1.1046,0-2,.8954-2,2Zm26,24H4V4h24v24Z"
  })), children);
})));
if (false) {}
const UseCaseUsage = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UseCaseUsage({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m22.0735,21.9922c1.7068,0,2.9407-.7773,3.5151-2.3325l-1.6561-.7942c-.3212.7942-.828,1.386-1.859,1.386-1.2002,0-1.8086-.8284-1.8086-2.062v-1.6057c0-1.2341.6084-2.0787,1.8086-2.0787.9294,0,1.4871.5409,1.6899,1.2845l1.7748-.7947c-.524-1.386-1.6903-2.2307-3.4647-2.2307-2.603,0-4.0735,1.7744-4.0735,4.5969,0,2.8394,1.4705,4.6311,4.0735,4.6311Z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m11.5126,21.9922c3.3129,0,4.5468-1.572,4.5468-5.0369v-6.9631h-2.1973v7.2507c0,1.8422-.6423,2.772-2.3324,2.772s-2.3324-.9298-2.3324-2.772v-7.2507h-2.1973v6.9631c0,3.4648,1.2,5.0369,4.5126,5.0369Z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m21,30h-10c-4.9626,0-9-4.0374-9-9v-10C2,6.0374,6.0374,2,11,2h10c4.9626,0,9,4.0374,9,9v10c0,4.9626-4.0374,9-9,9ZM11,4c-3.8599,0-7,3.1401-7,7v10c0,3.8599,3.1401,7,7,7h10c3.8599,0,7-3.1401,7-7v-10c0-3.8599-3.1401-7-7-7h-10Z"
  })), children);
})));
if (false) {}
const User = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function User({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path114 || (_path114 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M8,2c1.4,0,2.5,1.1,2.5,2.5S9.4,7,8,7S5.5,5.9,5.5,4.5S6.6,2,8,2 M8,1C6.1,1,4.5,2.6,4.5,4.5S6.1,8,8,8s3.5-1.6,3.5-3.5 S9.9,1,8,1z"
    })), _path115 || (_path115 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
      d: "M13,15h-1v-2.5c0-1.4-1.1-2.5-2.5-2.5h-3C5.1,10,4,11.1,4,12.5V15H3v-2.5C3,10.6,4.6,9,6.5,9h3c1.9,0,3.5,1.6,3.5,3.5V15z"
    })), children);
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path116 || (_path116 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z"
  })), _path117 || (_path117 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M26,30H24V25a5,5,0,0,0-5-5H13a5,5,0,0,0-5,5v5H6V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
});
if (false) {}
const UserAccess = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAccess({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M30,12a1.9922,1.9922,0,0,0-.5117.0742L28.4331,11.019a3.8788,3.8788,0,0,0,0-4.038l1.0552-1.0552a2.0339,2.0339,0,1,0-1.4141-1.4141L27.019,5.5669a3.8788,3.8788,0,0,0-4.038,0L21.9258,4.5117a2.0339,2.0339,0,1,0-1.4141,1.4141L21.5669,6.981a3.8788,3.8788,0,0,0,0,4.038l-1.0552,1.0552a2.0339,2.0339,0,1,0,1.4141,1.4141l1.0552-1.0552a3.8788,3.8788,0,0,0,4.038,0l1.0552,1.0552A1.9957,1.9957,0,1,0,30,12ZM23,9a2,2,0,1,1,2,2A2.0025,2.0025,0,0,1,23,9Z"
  })), children);
})));
if (false) {}
const UserAccessLocked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAccessLocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,8v-3c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v3c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2Zm-6-3c0-1.1025.8972-2,2-2s2,.8975,2,2v3h-4v-3Zm-2,11v-6h8v6h-8Z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3,1.3431-3,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
})));
if (false) {}
const UserAccessUnlocked = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAccessUnlocked({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3,1.3431-3,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m28,8h-6v-3c0-1.1025.8972-2,2-2s2,.8975,2,2h2c0-2.2056-1.7944-4-4-4s-4,1.7944-4,4v3c-1.1028,0-2,.8975-2,2v6c0,1.1025.8972,2,2,2h8c1.1028,0,2-.8975,2-2v-6c0-1.1025-.8972-2-2-2Zm0,8h-8v-6h8v6Z"
  })), children);
})));
if (false) {}
const UserActivity = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserActivity({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M25,23h-.0215a1.0016,1.0016,0,0,1-.94-.7256L20.8711,11.19l-1.9346,5.1607A1.0005,1.0005,0,0,1,18,17H14V15h3.3066l2.7569-7.3511a1.0005,1.0005,0,0,1,1.8984.0762l3.1113,10.8921,1.9786-5.9336A.9988.9988,0,0,1,28,12h4v2H28.7207l-2.7725,8.3164A.9984.9984,0,0,1,25,23Z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V23a3.0033,3.0033,0,0,0-3-3H6a3.0033,3.0033,0,0,0-3,3v7H1V23a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M8,8a3,3,0,1,1-3,3A3,3,0,0,1,8,8M8,6a5,5,0,1,0,5,5A5,5,0,0,0,8,6Z"
  })), children);
})));
if (false) {}
const UserAdmin = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAdmin({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M25 16.18 22.41 13.59 21 15 25 19 32 12 30.59 10.59 25 16.18z"
  })), children);
})));
if (false) {}
const UserAvatar = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAvatar({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
      d: "M8,1C4.1,1,1,4.1,1,8s3.1,7,7,7s7-3.1,7-7S11.9,1,8,1z M5,13.2v-1.5c0-0.9,0.6-1.6,1.5-1.7h3c0.9,0.1,1.5,0.8,1.5,1.7v1.5 C9.1,14.3,6.9,14.3,5,13.2L5,13.2z M12,12l0-0.8c0-0.9-1.1-2.1-2.5-2.2h-3C5.1,9.1,4,10.3,4,11.7l0,0.5v0.3c-2.5-2.2-2.7-6-0.5-8.5 s6-2.7,8.5-0.5s2.7,6,0.5,8.5c-0.1,0.2-0.3,0.3-0.5,0.5V12z"
    })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
      d: "M8,3C6.6,3,5.5,4.1,5.5,5.5S6.6,8,8,8s2.5-1.1,2.5-2.5S9.4,3,8,3z M8,7C7.2,7,6.5,6.3,6.5,5.5S7.2,4,8,4s1.5,0.7,1.5,1.5 S8.8,7,8,7z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Zm0,8a3,3,0,1,1,3-3A3.0034,3.0034,0,0,1,16,16Z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2ZM10,26.3765V25a3.0033,3.0033,0,0,1,3-3h6a3.0033,3.0033,0,0,1,3,3v1.3765a11.8989,11.8989,0,0,1-12,0Zm13.9925-1.4507A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
})));
if (false) {}
const UserAvatarFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAvatarFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M8.0071,24.93A4.9958,4.9958,0,0,1,13,20h6a4.9959,4.9959,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0ZM20.5,12.5A4.5,4.5,0,1,1,16,8,4.5,4.5,0,0,1,20.5,12.5Z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7489,24.93A13.9893,13.9893,0,1,0,2,16a13.899,13.899,0,0,0,3.2511,8.93l-.02.0166c.07.0845.15.1567.2222.2392.09.1036.1864.2.28.3008.28.3033.5674.5952.87.87.0915.0831.1864.1612.28.2417.32.2759.6484.5372.99.7813.0441.0312.0832.0693.1276.1006v-.0127a13.9011,13.9011,0,0,0,16,0V27.48c.0444-.0313.0835-.0694.1276-.1006.3412-.2441.67-.5054.99-.7813.0936-.08.1885-.1586.28-.2417.3025-.2749.59-.5668.87-.87.0933-.1006.1894-.1972.28-.3008.0719-.0825.1522-.1547.2222-.2392ZM16,8a4.5,4.5,0,1,1-4.5,4.5A4.5,4.5,0,0,1,16,8ZM8.0071,24.93A4.9957,4.9957,0,0,1,13,20h6a4.9958,4.9958,0,0,1,4.9929,4.93,11.94,11.94,0,0,1-15.9858,0Z"
  })), children);
})));
if (false) {}
const UserAvatarFilledAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserAvatarFilledAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M16,8a5,5,0,1,0,5,5A5,5,0,0,0,16,8Z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A14,14,0,1,0,30,16,14.0158,14.0158,0,0,0,16,2Zm7.9925,22.9258A5.0016,5.0016,0,0,0,19,20H13a5.0016,5.0016,0,0,0-4.9925,4.9258,12,12,0,1,1,15.985,0Z"
  })), children);
})));
if (false) {}
const UserCertification = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserCertification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10 26.593 13 30 13.414 27.5 15.667 28 19 25 17.125 22 19 22.5 15.667 20 13.414 23.5 13 25 10z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserData = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserData({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H30V16H28z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M23 5H25V16H23z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10H20V16H18z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V24a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v6H2V24a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a3,3,0,1,1-3,3A3,3,0,0,1,9,9M9,7a5,5,0,1,0,5,5A5,5,0,0,0,9,7Z"
  })), children);
})));
if (false) {}
const UserFavorite = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFavorite({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M27.303,12a2.6616,2.6616,0,0,0-1.9079.8058l-.3932.4054-.397-.4054a2.6615,2.6615,0,0,0-3.8157,0,2.7992,2.7992,0,0,0,0,3.8964L25.0019,21l4.2089-4.2978a2.7992,2.7992,0,0,0,0-3.8964A2.6616,2.6616,0,0,0,27.303,12Z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M2,30H4V25a5.0059,5.0059,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v5h2V25a7.0082,7.0082,0,0,0-7-7H9a7.0082,7.0082,0,0,0-7,7Z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserFavoriteAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFavoriteAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7663,4.2558A4.2121,4.2121,0,0,0,23,4.0321a4.2121,4.2121,0,0,0-5.7663.2237,4.319,4.319,0,0,0,0,6.0447L22.998,16.14,23,16.1376l.002.0019,5.7643-5.839A4.319,4.319,0,0,0,28.7663,4.2558ZM27.342,8.8948l-4.34,4.3973L23,13.29l-.002.002-4.34-4.3973a2.3085,2.3085,0,0,1,0-3.2338,2.2639,2.2639,0,0,1,3.1561,0l1.181,1.2074L23,6.8634l.0049.005,1.181-1.2074a2.2639,2.2639,0,0,1,3.1561,0A2.3085,2.3085,0,0,1,27.342,8.8948Z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
})));
if (false) {}
const UserFavoriteAltFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFavoriteAltFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4938,3a3.4735,3.4735,0,0,0-2.48,1.0393l-.5111.5228-.5161-.5228a3.4792,3.4792,0,0,0-4.96,0,3.59,3.59,0,0,0,0,5.0251l5.4766,5.5427,5.4716-5.5427a3.59,3.59,0,0,0,0-5.0251A3.4738,3.4738,0,0,0,26.4938,3Z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
})));
if (false) {}
const UserFeedback = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFeedback({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m19,3h10c1.1035,0,2,.8965,2,2v6c0,1.1035-.8965,2-2,2h-2.4229s-1.7314,3-1.7314,3l-1.7324-1,2.3096-4h3.5771s0-6,0-6h-10s0,6,0,6h3v2h-3c-1.1035,0-2-.8965-2-2v-6c0-1.1035.8965-2,2-2Z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m15,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5H1v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m8,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3c.0019-1.6561,1.3439-2.9981,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
})));
if (false) {}
const UserFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M6,30H26V25a7.0082,7.0082,0,0,0-7-7H13a7.0082,7.0082,0,0,0-7,7Z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a7,7,0,1,0,7-7A7,7,0,0,0,9,9Z"
  })), children);
})));
if (false) {}
const UserFollow = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserFollow({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M32 14 28 14 28 10 26 10 26 14 22 14 22 16 26 16 26 20 28 20 28 16 32 16 32 14z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), children);
})));
if (false) {}
const UserIdentification = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserIdentification({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M22,11h4a1,1,0,0,1,1,1v2a0,0,0,0,1,0,0H21a0,0,0,0,1,0,0V12A1,1,0,0,1,22,11Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: "24",
    cy: "8",
    r: "2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M30,18H18a2.0023,2.0023,0,0,1-2-2V4a2.002,2.002,0,0,1,2-2H30a2.0023,2.0023,0,0,1,2,2V16A2.0027,2.0027,0,0,1,30,18ZM18,4V16H30.001L30,4Z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z"
  })), children);
})));
if (false) {}
const UserMilitary = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserMilitary({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M25 13 23.407 16 20 16.414 22.5 18.667 22 22 25 20.125 28 22 27.5 18.667 30 16.414 26.5 16 25 13z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 13.414 25 9.834 25 9.834 28.587 13.416 30 12 25 7 20 12 21.414 13.414z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M21.414 8.414 25 4.834 25 4.834 28.587 8.416 30 7 25 2 20 7 21.414 8.414z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
})));
if (false) {}
const UserMultiple = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserMultiple({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M30,30H28V25a5.0057,5.0057,0,0,0-5-5V18a7.0078,7.0078,0,0,1,7,7Z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5.0059,5.0059,0,0,0-5-5H9a5.0059,5.0059,0,0,0-5,5v5H2V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M20,2V4a5,5,0,0,1,0,10v2A7,7,0,0,0,20,2Z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserOnline = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserOnline({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: "26",
    cy: "16",
    r: "4"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserProfile = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserProfile({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4H32V6H22z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9H32V11H22z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H29V16H22z"
  })), children);
})));
if (false) {}
const UserRole = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserRole({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M28.07 21 22 15 28.07 9 29.5 10.41 24.86 15 29.5 19.59 28.07 21z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M22,30H20V25a5,5,0,0,0-5-5H9a5,5,0,0,0-5,5v5H2V25a7,7,0,0,1,7-7h6a7,7,0,0,1,7,7Z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserService = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserService({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m23.019,10.4332c-.595.3514-1.2795.5668-2.019.5668-2.2056,0-4-1.7944-4-4,0-.3557.0615-.6943.1492-1.0228l2.4368,2.4368.0005-.0004c.3621.3621.8621.5864,1.4136.5864,1.103,0,2-.897,2-2,0-.5515-.2242-1.0515-.5864-1.4136l.0005-.0004-2.4368-2.4368c.3284-.0875.667-.1491,1.0227-.1491,2.2056,0,4,1.7944,4,4,0,.7396-.2155,1.4241-.5669,2.0191l5.5669,5.5668-1.4141,1.4141-5.5669-5.5668Z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m16,30h-2v-5c-.0018-1.6561-1.3439-2.9982-3-3h-4c-1.6561.0018-2.9982,1.3439-3,3v5h-2v-5c.0033-2.7601,2.2399-4.9967,5-5h4c2.7601.0033,4.9967,2.2399,5,5v5Z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    strokeWidth: "0",
    d: "m9,10c1.6569,0,3,1.3431,3,3s-1.3431,3-3,3-3-1.3431-3-3c.0019-1.6561,1.3439-2.9981,3-3m0-2c-2.7614,0-5,2.2386-5,5s2.2386,5,5,5,5-2.2386,5-5-2.2386-5-5-5Z"
  })), children);
})));
if (false) {}
const UserServiceDesk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserServiceDesk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M25.334,11.95l1.2055-1.206a1.178,1.178,0,0,1,1.2593-.2584l1.4693.5868A1.1736,1.1736,0,0,1,30,12.1489v2.692A1.1681,1.1681,0,0,1,28.8229,16l-.05-.0015C18.4775,15.3578,16.4,6.6357,16.0073,3.2976a1.1681,1.1681,0,0,1,1.0315-1.29A1.1492,1.1492,0,0,1,17.1751,2h2.5994a1.1626,1.1626,0,0,1,1.0764.7322l.5866,1.47a1.1635,1.1635,0,0,1-.2529,1.26L19.9791,6.668S20.6733,11.3682,25.334,11.95Z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
})));
if (false) {}
const UserSettings = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserSettings({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M30,10V8H27.8989a4.9678,4.9678,0,0,0-.7319-1.7529l1.49-1.49-1.414-1.414-1.49,1.49A4.9678,4.9678,0,0,0,24,4.1011V2H22V4.1011a4.9678,4.9678,0,0,0-1.7529.7319l-1.49-1.49-1.414,1.414,1.49,1.49A4.9678,4.9678,0,0,0,18.1011,8H16v2h2.1011a4.9678,4.9678,0,0,0,.7319,1.7529l-1.49,1.49,1.414,1.414,1.49-1.49A4.9678,4.9678,0,0,0,22,13.8989V16h2V13.8989a4.9678,4.9678,0,0,0,1.7529-.7319l1.49,1.49,1.414-1.414-1.49-1.49A4.9678,4.9678,0,0,0,27.8989,10Zm-7,2a3,3,0,1,1,3-3A3.0033,3.0033,0,0,1,23,12Z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30H14V25a3.0033,3.0033,0,0,0-3-3H7a3.0033,3.0033,0,0,0-3,3v5H2V25a5.0059,5.0059,0,0,1,5-5h4a5.0059,5.0059,0,0,1,5,5Z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M9,10a3,3,0,1,1-3,3,3,3,0,0,1,3-3M9,8a5,5,0,1,0,5,5A5,5,0,0,0,9,8Z"
  })), children);
})));
if (false) {}
const UserSimulation = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserSimulation({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 12.866H29.232V14.866H25.232z",
    transform: "rotate(30 27.232 13.866)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M26 8H30V10H26z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 12.866H6.768V14.866H2.768z",
    transform: "rotate(150 4.768 13.866)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V25a5.0059,5.0059,0,0,0-5-5H13a5.0059,5.0059,0,0,0-5,5v5H6V25a7.0082,7.0082,0,0,1,7-7h6a7.0082,7.0082,0,0,1,7,7Z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M16,4a5,5,0,1,1-5,5,5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,16,2Z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M25.232 3.134H29.232V5.134H25.232z",
    transform: "rotate(-30 27.232 4.134)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8H6V10H2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M2.768 3.134H6.768V5.134H2.768z",
    transform: "rotate(210 4.768 4.134)"
  })), children);
})));
if (false) {}
const UserSpeaker = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserSpeaker({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4146,19,27.7,17.2852A2.97,2.97,0,0,0,28,16a3,3,0,1,0-3,3,2.97,2.97,0,0,0,1.2864-.3L28,20.4141V28H22V25a7.0078,7.0078,0,0,0-7-7H9a7.008,7.008,0,0,0-7,7v5H30V20.4141A1.988,1.988,0,0,0,29.4146,19ZM4,25a5.006,5.006,0,0,1,5-5h6a5.0059,5.0059,0,0,1,5,5v3H4Z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M12,4A5,5,0,1,1,7,9a5,5,0,0,1,5-5m0-2a7,7,0,1,0,7,7A7,7,0,0,0,12,2Z"
  })), children);
})));
if (false) {}
const UserSponsor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserSponsor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8301 13.3662 30.8301 11.6338 28 13.2681 28 10 26 10 26 13.2676 23.1699 11.6338 22.1699 13.3662 25 15 22.1699 16.6338 23.1699 18.3662 26 16.7324 26 20 28 20 28 16.7319 30.8301 18.3662 31.8301 16.6338 29 15 31.8301 13.3662z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m22,30h-2v-5c-.0033-2.7601-2.2399-4.9967-5-5h-6c-2.7601.0033-4.9967,2.2399-5,5v5h-2v-5c.0045-3.8641,3.1359-6.9955,7-7h6c3.8641.0045,6.9955,3.1359,7,7v5Z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m12,4c2.7614,0,5,2.2386,5,5s-2.2386,5-5,5-5-2.2386-5-5c.0031-2.7601,2.2399-4.9969,5-5m0-2c-3.866,0-7,3.134-7,7s3.134,7,7,7,7-3.134,7-7-3.134-7-7-7Z"
  })), children);
})));
if (false) {}
const UserXRay = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserXRay({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M28 9 28 7 25 7 25 5 23 5 23 7 20 7 20 9 23 9 23 12 20 12 20 14 23 14 23 16 25 16 25 14 28 14 28 12 25 12 25 9 28 9z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M31,3H17a1,1,0,0,0-1,1V17a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V4A1,1,0,0,0,31,3ZM28,9H25v3h3v2H25v2H23V14H20V12h3V9H20V7h3V5h2V7h3Z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M15,30H13V26a2.9465,2.9465,0,0,0-3-3H6a2.9465,2.9465,0,0,0-3,3v4H1V26a4.9514,4.9514,0,0,1,5-5h4a4.9514,4.9514,0,0,1,5,5Z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M8,11a3,3,0,0,1,0,6,3,3,0,0,1,0-6M8,9A5,5,0,0,0,8,19,5,5,0,0,0,8,9Z"
  })), children);
})));
if (false) {}
const UserProfileAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UserProfileAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M19 13H26V15H19z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M19 8H30V10H19z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3H30V5H19z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M11,30H7a2.0059,2.0059,0,0,1-2-2V21a2.0059,2.0059,0,0,1-2-2V13a2.9465,2.9465,0,0,1,3-3h6a2.9465,2.9465,0,0,1,3,3v6a2.0059,2.0059,0,0,1-2,2v7A2.0059,2.0059,0,0,1,11,30ZM6,12a.9448.9448,0,0,0-1,1v6H7v9h4V19h2V13a.9448.9448,0,0,0-1-1Z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M9,9a4,4,0,1,1,4-4h0A4.0118,4.0118,0,0,1,9,9ZM9,3a2,2,0,1,0,2,2h0A2.0059,2.0059,0,0,0,9,3Z"
  })), children);
})));
if (false) {}
const UvIndex = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UvIndex({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5.9121l1.7444,2.9326.7822,1.315,1.4739-.4107,3.1206-.87L22.2512,12,21.84,13.4731l1.315.7823L26.0876,16l-2.9323,1.7441-1.315.7818L22.2512,20l.87,3.1211-3.1208-.87L18.5266,21.84l-.7822,1.315L16,26.0879l-1.7444-2.9326-.7822-1.315L12,22.251l-3.1208.87L9.7488,20l.4109-1.4741-1.315-.7818L5.9124,16l2.9323-1.7446,1.315-.7823L9.7488,12l-.87-3.1206L12,9.749l1.4739.4107.7822-1.315L16,5.9121M16,2,12.5366,7.8223,6,6l1.8223,6.5366L2,16l5.8223,3.4629L6,26l6.5366-1.8223L16,30l3.4634-5.8223L26,26l-1.8223-6.5371L30,16l-5.8223-3.4634L26,6,19.4634,7.8223,16,2Z"
  })), children);
})));
if (false) {}
const UvIndexAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UvIndexAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M13,30H9a2.0027,2.0027,0,0,1-2-2V20H9v8h4V20h2v8A2.0027,2.0027,0,0,1,13,30Z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20 23.25 20 21 29.031 18.792 20 17 20 19.5 30 22.5 30 25 20z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2H17V7H15z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M21.668 6.854H26.625999999999998V8.854H21.668z",
    transform: "rotate(-45 24.147 7.853)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M25 15H30V17H25z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M2 15H7V17H2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M6.854 5.375H8.854V10.333H6.854z",
    transform: "rotate(-45 7.854 7.853)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M22,17H20V16a4,4,0,0,0-8,0v1H10V16a6,6,0,0,1,12,0Z"
  })), children);
})));
if (false) {}
const UvIndexFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function UvIndexFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M16,30l-3.4634-5.8223L6,26l1.8223-6.5369L2,16l5.8223-3.4631L6,6l6.5366,1.8223L16,2l3.4634,5.8223L26,6l-1.8223,6.5369L30,16l-5.8223,3.4631L26,26l-6.5366-1.8223Z"
  })), children);
})));
if (false) {}
const ValueVariable = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ValueVariable({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M26,28H22V26h4V6H22V4h4a2.0021,2.0021,0,0,1,2,2V26A2.0021,2.0021,0,0,1,26,28Z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11 18 11 16 14.897 14 11 12 11 14.905 16 12 21 14 21 16 17.201 18 21 20 21 17.098 16 20 11z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M10,28H6a2.0021,2.0021,0,0,1-2-2V6A2.0021,2.0021,0,0,1,6,4h4V6H6V26h4Z"
  })), children);
})));
if (false) {}
const ValueVariableAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ValueVariableAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M3,15.874v.2676c1.1201.2939,2,1.1743,2,2.8584v8h4v2h-4c-1.1028,0-2-.8975-2-2v-8c0-1.5498-.8799-2-2-2v-2c1.1201,0,2-.4766,2-2V5c0-1.1025.8972-2,2-2h4v2h-4v8c0,1.6841-.8799,2.5801-2,2.874ZM29,15.874v.2676c-1.1201.2939-2,1.1743-2,2.8584v8h-4s0,2,0,2h4c1.1028,0,2-.8975,2-2v-8c0-1.5498.8799-2,2-2v-2c-1.1201,0-2-.4766-2-2V5c0-1.1025-.8972-2-2-2h-4s0,2,0,2h4v8c0,1.6841.8799,2.5801,2,2.874ZM10.3401,21.8939c-.4089,0-.7344-.1158-.977-.3471-.2421-.2314-.3631-.5464-.3631-.9447,0-.3767.1129-.6807.3392-.9123.2258-.2314.5274-.3472.9043-.3472.3443,0,.6108.101.799.3025.1882.2019.2828.4825.2828.8422v.0654l.1129.0818c.1617-.0863.3687-.2776.622-.5742.2528-.2965.5325-.6767.8397-1.1405.3067-.4637.6347-.992.9846-1.5852s.7024-1.2349,1.0579-1.9251l-.0483-2.7824c-.0112-.69-.1938-1.0352-.5493-1.0352-.2156,0-.4603.0943-.7344.2825-.2746.1886-.6327.5034-1.0741.9447l-.5005-.4844c.6886-.7856,1.2944-1.3536,1.8167-1.7035.5218-.3498,1.0416-.5249,1.5583-.5249.6027,0,1.0436.2181,1.3239.654.2797.436.4303,1.1439.4521,2.1234l.0325,1.8247h.1612c.4628-.8935.8773-1.6363,1.2435-2.2284.3657-.5919.713-1.063,1.0416-1.4129.328-.3498.651-.5975.9689-.7428.3174-.1453.6591-.2181,1.0253-.2181.4089,0,.7344.1158.977.3472.2421.2315.3631.5465.3631.9446,0,.377-.1129.681-.3392.9123-.2258.2317-.5274.3472-.9043.3472-.3443,0-.6108-.0954-.799-.2861-.1887-.1908-.2828-.4605-.2828-.8094v-.1146l-.1129-.0818c-.1404.0757-.323.2589-.5493.55-.2258.2912-.4816.6685-.767,1.1324-.2853.4637-.5951,1.0084-.9282,1.6339-.3341.6256-.6841,1.3103-1.0497,2.0543l.0483,2.6368c.0107.6904.1938,1.0352.5493,1.0352.2151,0,.4598-.0941.7344-.2825.2746-.1883.6322-.5031,1.0736-.9447l.501.4844c-.3448.3984-.6647.7375-.9607,1.0173-.2965.2801-.5813.5087-.856.6863s-.5386.3095-.7914.3956-.5086.1292-.767.1292c-.6032,0-1.0441-.2179-1.3239-.6539-.2802-.436-.4308-1.1438-.4521-2.1235l-.0325-1.8247h-.1455c-.4521.8397-.8748,1.5502-1.2674,2.1315-.3931.5813-.767,1.0552-1.1225,1.421-.355.3661-.7049.6326-1.0492.7994-.3448.1667-.6998.2502-1.066.2502Z"
  })), children);
})));
if (false) {}
const Van = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Van({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M29.81,16l-7-9.56A1,1,0,0,0,22,6H3A1,1,0,0,0,2,7V24a1,1,0,0,0,1,1H5.14a4,4,0,0,0,7.72,0h6.28a4,4,0,0,0,7.72,0H29a1,1,0,0,0,1-1V16.56A1,1,0,0,0,29.81,16ZM20,8h1.49l5.13,7H20ZM9,26a2,2,0,1,1,2-2A2,2,0,0,1,9,26Zm14,0a2,2,0,1,1,2-2A2,2,0,0,1,23,26Zm5-3H26.86a4,4,0,0,0-7.72,0H12.86a4,4,0,0,0-7.72,0H4V8H18v9H28Z"
  })), children);
})));
if (false) {}
const VegetationAsset = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VegetationAsset({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: "21.5",
    cy: "10.5",
    r: "1.5"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5,1a2.4518,2.4518,0,0,0-1.2061.3105L18.9834,5.6084l.0027.0054a5.497,5.497,0,1,0,7.3257,7.5444l.0031.0015,4.4-8.5A2.5,2.5,0,0,0,28.5,1Zm-7,13A3.5,3.5,0,1,1,25,10.5,3.5042,3.5042,0,0,1,21.5,14ZM28.9414,3.7354,26.5571,8.3408A5.5279,5.5279,0,0,0,23.658,5.4424l4.5949-2.377A.5165.5165,0,0,1,29,3.5.4985.4985,0,0,1,28.9414,3.7354Z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M19,20h7V18H17V28a2.0027,2.0027,0,0,0,2,2h3V28H19Z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H9V28h3V15.5664L8.4854,13.4575l1.0292-1.7148,3.5147,2.1084A2.0115,2.0115,0,0,1,14,15.5664V28A2.0024,2.0024,0,0,1,12,30Z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3079,2.2852A9.4882,9.4882,0,0,0,15,2,8.0275,8.0275,0,0,0,8.0786,6.001C8.0525,6,8.0264,6,8,6A6,6,0,0,0,8,18V16A4,4,0,0,1,8,8a2.7009,2.7009,0,0,1,.387.0391l.863.1142.3086-.6675A6.0192,6.0192,0,0,1,15,4a7.499,7.499,0,0,1,1.731.2148Z"
  })), children);
})));
if (false) {}
const VegetationEncroachment = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VegetationEncroachment({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m19,20h7v-2h-9v10c.0015,1.104.896,1.9985,2,2h3v-2h-3v-8Z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "m12,30h-3v-2h3v-12.4336l-3.5146-2.1089,1.0292-1.7148,3.5147,2.1084c.6007.3632.9686,1.0133.9707,1.7153v12.4336c-.0013,1.104-.896,1.9987-2,2Z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M30 6.4102 28.59 5 25 8.5898 21.41 5 20 6.4102 23.59 10 20 13.5898 21.41 15 25 11.4102 28.59 15 30 13.5898 26.41 10 30 6.4102z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m17.3079,2.2852c-.7283-.1821-1.4995-.2852-2.3079-.2852-2.8545.0083-5.4897,1.5317-6.9214,4.001-.0261-.001-.0522-.001-.0786-.001-3.3137,0-6,2.6865-6,6s2.6863,6,6,6v-2c-2.209,0-4-1.791-4-4s1.791-4,4-4c.1299.0039.259.0166.387.0391l.863.1143.3086-.6675c.9834-2.1196,3.1047-3.4785,5.4414-3.4858.6079,0,1.1819.0854,1.731.2148l.5769-1.9297Z"
  })), children);
})));
if (false) {}
const VegetationHeight = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VegetationHeight({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m13,8l-5,5,1.4102,1.4102,2.5898-2.5801v16.1699h-3v2h3c1.104-.0015,1.9988-.896,2-2V11.8301l2.5898,2.5801,1.4102-1.4102-5-5Z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m22,30h-3c-1.104-.0013-1.9987-.896-2-2v-11h6c2.2096-.0001,4.0007-1.7915,4.0006-4.001,0-.1319-.0065-.2637-.0196-.395-.277-2.0943-2.0835-3.6461-4.1957-3.604h-1.5837l-.1766-.779c-.573-2.5249-2.9942-4.221-6.025-4.221-2.3366.0074-4.4579,1.3664-5.4415,3.4859l-.3085.6672-.863-.1143c-.1279-.022-.2573-.0349-.387-.0388-2.2091,0-4,1.7909-4,4s1.7909,4,4,4v2c-3.3137,0-6-2.6863-6-6s2.6863-6,6-6c.0264,0,.0525,0,.0786.001,1.4317-2.4694,4.067-3.9928,6.9214-4.001,3.6788,0,6.6923,1.9776,7.7516,5h.0337c3.1405-.0351,5.8053,2.2967,6.1872,5.4141.323,3.2985-2.0892,6.2344-5.3877,6.5573-.1943.019-.3895.0286-.5848.0286h-4v9h3v2Z"
  })), children);
})));
if (false) {}
const VehicleApi = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VehicleApi({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M28,11a1.9907,1.9907,0,0,0-.8247.1821L24.8337,9.51A3.45,3.45,0,0,0,25,8.5a3.45,3.45,0,0,0-.1663-1.01l2.3416-1.6723A1.9975,1.9975,0,1,0,26,4c0,.064.0129.124.0188.1865L23.7273,5.8232A3.4652,3.4652,0,0,0,21.5,5a3.5,3.5,0,0,0,0,7,3.4652,3.4652,0,0,0,2.2273-.8232l2.2915,1.6367C26.0129,12.876,26,12.936,26,13a2,2,0,1,0,2-2Zm-6.5-1A1.5,1.5,0,1,1,23,8.5,1.5017,1.5017,0,0,1,21.5,10Z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,19.9336l-7.7324-2.7783L18.374,13.0967A2.99,2.99,0,0,0,16.0537,12H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,17.2949A4.9884,4.9884,0,0,0,2,20.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V20.875A1,1,0,0,0,29.3379,19.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V20.1074A2.9977,2.9977,0,0,1,4.52,18.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,14h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,21.5781Z"
  })), children);
})));
if (false) {}
const VehicleConnected = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VehicleConnected({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M25,11H23a2.0021,2.0021,0,0,0-2-2V7A4.0045,4.0045,0,0,1,25,11Z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M29,11H27a6.0067,6.0067,0,0,0-6-6V3A8.0092,8.0092,0,0,1,29,11Z"
  })), children);
})));
if (false) {}
const VehicleInsights = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VehicleInsights({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M28 2H30V9H28z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H26V9H24z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M20 4H22V9H20z"
  })), children);
})));
if (false) {}
const VehicleServices = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VehicleServices({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3379,17.9336l-7.7324-2.7783L18.374,11.0967A2.99,2.99,0,0,0,16.0537,10H8.0576a2.9982,2.9982,0,0,0-2.48,1.3115L2.8662,15.2949A4.9884,4.9884,0,0,0,2,18.1074V26a1,1,0,0,0,1,1H5.1421a3.9806,3.9806,0,0,0,7.7158,0h6.2842a3.9806,3.9806,0,0,0,7.7158,0H29a1,1,0,0,0,1-1V18.875A1,1,0,0,0,29.3379,17.9336ZM9,28a2,2,0,1,1,2-2A2.0027,2.0027,0,0,1,9,28Zm14,0a2,2,0,1,1,2-2A2.0025,2.0025,0,0,1,23,28Zm5-3H26.8579a3.9806,3.9806,0,0,0-7.7158,0H12.8579a3.9806,3.9806,0,0,0-7.7158,0H4V18.1074A2.9977,2.9977,0,0,1,4.52,16.4189l2.711-3.9814A.9992.9992,0,0,1,8.0576,12h7.9961a.9928.9928,0,0,1,.7647.3545l3.3994,4.2685a1.0007,1.0007,0,0,0,.4443.3184L28,19.5781Z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5547,6a2,2,0,0,1,2-2H30a3.9756,3.9756,0,0,0-7.304,1H16V7h6.696A3.9756,3.9756,0,0,0,30,8H26.5547A2,2,0,0,1,24.5547,6Z"
  })), children);
})));
if (false) {}
const Version = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Version({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2V4H26V19h2V4a2.0023,2.0023,0,0,0-2-2Z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M11,7V9H21V24h2V9a2.0023,2.0023,0,0,0-2-2Z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M6,12H16a2.0023,2.0023,0,0,1,2,2V28a2.0023,2.0023,0,0,1-2,2H6a2.0023,2.0023,0,0,1-2-2V14A2.0023,2.0023,0,0,1,6,12Zm10,2L6,13.9988V28H16Z"
  })), children);
})));
if (false) {}
const VersionMajor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VersionMajor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 17.4141 16 14.8345 16 14.8345 13.4125 17.4156 12 16 16 12 20 16 18.5859 17.4141z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 11.4141 16 8.8345 16 8.8345 13.4125 11.4156 12 10 16 6 20 10 18.5859 11.4141z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 23.4141 16 20.8345 16 20.8345 13.4125 23.4156 12 22 16 18 20 22 18.5859 23.4141z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
})));
if (false) {}
const VersionMinor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VersionMinor({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 15.4141 16 12.8345 16 12.8345 13.4125 15.4156 12 14 16 10 20 14 18.5859 15.4141z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 21.4141 16 18.8345 16 18.8345 13.4125 21.4156 12 20 16 16 20 20 18.5859 21.4141z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
})));
if (false) {}
const VersionPatch = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VersionPatch({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5859 18.4141 16 15.8345 16 15.8345 13.4125 18.4156 12 17 16 13 20 17 18.5859 18.4141z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "m1.5858,17.4142c-.3905-.3905-.5858-.9024-.5858-1.4142s.1953-1.0237.5858-1.4142L14.5858,1.5858c.3905-.3905.9023-.5858,1.4142-.5858s1.0237.1953,1.4142.5858l13,13c.3905.3905.5858.9024.5858,1.4142s-.1953,1.0237-.5858,1.4142l-13,13c-.3905.3905-.9024.5858-1.4142.5858s-1.0237-.1953-1.4142-.5858L1.5858,17.4142ZM16,3L3,16l13,13,13-13L16,3Z"
  })), children);
})));
if (false) {}
const VerticalFold = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VerticalFold({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M11,24l1.414,1.414,2.586-2.586v7.172h2v-7.172l2.586,2.586,1.414-1.414-5-5-5,5ZM21,8l-1.414-1.414-2.586,2.586V2h-2v7.172l-2.586-2.586-1.414,1.414,5,5,5-5ZM2,17h4v-2H2v2ZM12,15h-4v2h4v-2ZM14,17h4v-2h-4v2ZM20,17h4v-2h-4v2ZM26,15v2h4v-2h-4Z"
  })), children);
})));
if (false) {}
const VerticalView = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VerticalView({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M12,30H4a2.0021,2.0021,0,0,1-2-2V4A2.0021,2.0021,0,0,1,4,2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,12,30ZM4,4V28h8V4Z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M28,30H20a2.0021,2.0021,0,0,1-2-2V4a2.0021,2.0021,0,0,1,2-2h8a2.0021,2.0021,0,0,1,2,2V28A2.0021,2.0021,0,0,1,28,30ZM20,4V28h8V4Z"
  })), children);
})));
if (false) {}
const Video = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Video({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26ZM4,8V24H21V18a1,1,0,0,1,1.58-.81L28,21.06V10.94l-5.42,3.87A1,1,0,0,1,21,14V8Z"
  })), children);
})));
if (false) {}
const VideoAdd = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoAdd({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M18 15 14 15 14 11 12 11 12 15 8 15 8 17 12 17 12 21 14 21 14 17 18 17 18 15z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
})));
if (false) {}
const VideoChat = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoChat({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H17V14H8z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17H13V19H8z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2.0023,2.0023,0,0,1-2-2V8A2.0023,2.0023,0,0,1,4,6H21a2.0023,2.0023,0,0,1,2,2v4.0566l5.4189-3.87A.9995.9995,0,0,1,30,9V23a.9995.9995,0,0,1-1.5811.8135L23,19.9434V24A2.0023,2.0023,0,0,1,21,26ZM4,8V24.001L21,24V18a.9995.9995,0,0,1,1.5811-.8135L28,21.0566V10.9434l-5.4189,3.87A.9995.9995,0,0,1,21,14V8Z"
  })), children);
})));
if (false) {}
const VideoFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M21,26H4a2,2,0,0,1-2-2V8A2,2,0,0,1,4,6H21a2,2,0,0,1,2,2v4.06l5.42-3.87A1,1,0,0,1,30,9V23a1,1,0,0,1-1.58.81L23,19.94V24A2,2,0,0,1,21,26Z"
  })), children);
})));
if (false) {}
const VideoOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoOff({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11ZM28,21.06l-5.42-3.87A1,1,0,0,0,21,18v6H9.44L21,12.44V14a1,1,0,0,0,1.58.81L28,10.94Z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M4,24V8H20V6H4A2,2,0,0,0,2,8V24Z"
  })), children);
})));
if (false) {}
const VideoOffFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M20.31,6H4A2,2,0,0,0,2,8V24a2.85,2.85,0,0,0,0,.29Z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M29.46,8.11a1,1,0,0,0-1,.08L23,12.06V10.44l7-7L28.56,2,2,28.56,3.44,30l4-4H21a2,2,0,0,0,2-2V19.94l5.42,3.87A1,1,0,0,0,30,23V9A1,1,0,0,0,29.46,8.11Z"
  })), children);
})));
if (false) {}
const VideoPlayer = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VideoPlayer({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M13 11 13 21 21 16 13 11z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "m28,6H4c-1.103,0-2,.8975-2,2v16c0,1.1025.897,2,2,2h24c1.103,0,2-.8975,2-2V8c0-1.1025-.897-2-2-2Zm0,18H4V8h24v16Z"
  })), children);
})));
if (false) {}
const View = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function View({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
      d: "M15.5,7.8C14.3,4.7,11.3,2.6,8,2.5C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3c1.2,3.1,4.1,5.2,7.5,5.3 c3.3-0.1,6.3-2.2,7.5-5.3C15.5,8.1,15.5,7.9,15.5,7.8z M8,12.5c-2.7,0-5.4-2-6.5-4.5c1-2.5,3.8-4.5,6.5-4.5s5.4,2,6.5,4.5 C13.4,10.5,10.6,12.5,8,12.5z"
    })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
      d: "M8,5C6.3,5,5,6.3,5,8s1.3,3,3,3s3-1.3,3-3S9.7,5,8,5z M8,10c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S9.1,10,8,10z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z"
  })), children);
})));
if (false) {}
const ViewFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "16",
    r: "4"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5A6.5,6.5,0,1,1,22.5,16,6.51,6.51,0,0,1,16,22.5Z"
  })), children);
})));
if (false) {}
const ViewMode_1 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewMode_1({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H28V21H4z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v6H6V6H26m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
})));
if (false) {}
const ViewMode_2 = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewMode_2({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M4 26H28V28H4z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M4 19H28V21H4z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M12,6v6H6V6h6m0-2H6A2,2,0,0,0,4,6v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M26,6v6H20V6h6m0-2H20a2,2,0,0,0-2,2v6a2,2,0,0,0,2,2h6a2,2,0,0,0,2-2V6a2,2,0,0,0-2-2Z"
  })), children);
})));
if (false) {}
const ViewOff = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewOff({
  children,
  size = 16,
  ...rest
}, ref) {
  if (size === 16 || size === "16" || size === "16px") {
    return /*#__PURE__*/React.createElement(Icon, {
      width: size,
      height: size,
      ref: ref,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16",
      fill: "currentColor",
      ...rest
    }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
      d: "M2.6,11.3l0.7-0.7C2.6,9.8,1.9,9,1.5,8c1-2.5,3.8-4.5,6.5-4.5c0.7,0,1.4,0.1,2,0.4l0.8-0.8C9.9,2.7,9,2.5,8,2.5 C4.7,2.6,1.7,4.7,0.5,7.8c0,0.1,0,0.2,0,0.3C1,9.3,1.7,10.4,2.6,11.3z"
    })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
      d: "M6,7.9c0.1-1,0.9-1.8,1.8-1.8l0.9-0.9C7.2,4.7,5.5,5.6,5.1,7.2C5,7.7,5,8.3,5.1,8.8L6,7.9z"
    })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
      d: "M15.5,7.8c-0.6-1.5-1.6-2.8-2.9-3.7L15,1.7L14.3,1L1,14.3L1.7,15l2.6-2.6c1.1,0.7,2.4,1,3.7,1.1c3.3-0.1,6.3-2.2,7.5-5.3 C15.5,8.1,15.5,7.9,15.5,7.8z M10,8c0,1.1-0.9,2-2,2c-0.3,0-0.7-0.1-1-0.3L9.7,7C9.9,7.3,10,7.6,10,8z M8,12.5c-1,0-2.1-0.3-3-0.8 l1.3-1.3c1.4,0.9,3.2,0.6,4.2-0.8c0.7-1,0.7-2.4,0-3.4l1.4-1.4c1.1,0.8,2,1.9,2.6,3.2C13.4,10.5,10.6,12.5,8,12.5z"
    })), children);
  }
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24,22.51l1.43-1.42A14.06,14.06,0,0,1,3.07,16C5.1,10.93,10.7,7,16,7a12.38,12.38,0,0,1,4,.72l1.55-1.56A14.72,14.72,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16,16,0,0,0,5.24,22.51Z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15.73a4,4,0,0,1,3.7-3.7l1.81-1.82a6,6,0,0,0-7.33,7.33Z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66A16.4,16.4,0,0,0,25.2,8.22L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.1A15.29,15.29,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM20,16a4,4,0,0,1-6,3.44L19.44,14A4,4,0,0,1,20,16Zm-4,9a13.05,13.05,0,0,1-6-1.58l2.54-2.54a6,6,0,0,0,8.35-8.35l2.87-2.87A14.54,14.54,0,0,1,28.93,16C26.9,21.07,21.3,25,16,25Z"
  })), children);
})));
if (false) {}
const ViewOffFilled = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewOffFilled({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M30.94,15.66a16.4,16.4,0,0,0-5.73-7.45L30,3.41,28.59,2,2,28.59,3.41,30l5.1-5.09A15.38,15.38,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,22.5a6.46,6.46,0,0,1-3.83-1.26L14,19.43A4,4,0,0,0,19.43,14l1.81-1.81A6.49,6.49,0,0,1,16,22.5Z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53,21.81l5-5A6.84,6.84,0,0,1,9.5,16,6.51,6.51,0,0,1,16,9.5a6.84,6.84,0,0,1,.79.05l3.78-3.77A14.39,14.39,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A15.86,15.86,0,0,0,4.53,21.81Z"
  })), children);
})));
if (false) {}
const ViewNext = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function ViewNext({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M20.587 22 15 16.41 15 7 16.998 7 16.998 15.582 22 20.587 20.587 22z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M16,2A13.9158,13.9158,0,0,1,26,6.2343V2h2v8H20V8h4.9217A11.9818,11.9818,0,1,0,28,16h2A14,14,0,1,1,16,2Z"
  })), children);
})));
if (false) {}
const VintageMac = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VintageMac({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M22,16h-12V6h12v10ZM12,8v6h8v-6h-8ZM24,4v20H8V4h16M24,2H8c-1.1,0-2,.9-2,2v20c0,1.1.9,2,2,2h16c1.1,0,2-.9,2-2V4c0-1.1-.9-2-2-2ZM10,18h2v2h-2v-2ZM16,18h6v2h-6v-2ZM9,28h14v2h-14v-2Z"
  })), children);
})));
if (false) {}
const VirtualColumn = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualColumn({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M25 11 26.414 12.414 23.828 15 30 15 30 17 23.828 17 26.414 19.586 25 21 20 16 25 11z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M30,28H20a2.0023,2.0023,0,0,1-2-2V6a2.0023,2.0023,0,0,1,2-2H30V6H20V26H30Z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M12,28H2V26H12V6H2V4H12a2.0023,2.0023,0,0,1,2,2V26A2.0023,2.0023,0,0,1,12,28Z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11 5.586 12.414 8.172 15 2 15 2 17 8.172 17 5.586 19.586 7 21 12 16 7 11z"
  })), children);
})));
if (false) {}
const VirtualColumnKey = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualColumnKey({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: "24.5",
    cy: "9.5",
    r: "1.5"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4143,22H12V16.5857l6.03-6.03A5.3518,5.3518,0,0,1,18,10a6,6,0,1,1,6,6,5.3583,5.3583,0,0,1-.5559-.03ZM14,20h2.5857l6.1706-6.1709.5174.0957A3.935,3.935,0,0,0,24,14a4.0507,4.0507,0,1,0-3.925-3.2729l.0952.5166L14,17.4143Z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M28,18v8H10V6h4V4H4A2.0025,2.0025,0,0,0,2,6V26a2.0025,2.0025,0,0,0,2,2H28a2.0025,2.0025,0,0,0,2-2V18ZM4,6H8V26H4Z"
  })), children);
})));
if (false) {}
const VirtualDesktop = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualDesktop({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M21,16H11a2.0023,2.0023,0,0,0-2,2v6a2.0023,2.0023,0,0,0,2,2h4v2H12v2h8V28H17V26h4a2.0023,2.0023,0,0,0,2-2V18A2.0023,2.0023,0,0,0,21,16ZM11,24V18H21l.0015,6Z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8218,10.124a9.9992,9.9992,0,0,0-19.6436,0A7.4914,7.4914,0,0,0,7,24.9746v-2a5.4945,5.4945,0,0,1,.123-10.9541l.8365-.0566.09-.834a7.9979,7.9979,0,0,1,15.9014,0l.09.834.8365.0566A5.4945,5.4945,0,0,1,25,22.9746v2a7.4914,7.4914,0,0,0,.8218-14.8506Z"
  })), children);
})));
if (false) {}
const VirtualMachine = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualMachine({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M20,13H12a2.0025,2.0025,0,0,0-2,2V28a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V15A2.0025,2.0025,0,0,0,20,13Zm0,2,0,3H12V15Zm0,5,0,3H12V20Zm-8,8V25h8v3Z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M25.91,10.13a.121.121,0,0,1-.0967-.0952A10.0061,10.0061,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.1858,10.0347a.1212.1212,0,0,1-.0964.0957A7.5019,7.5019,0,0,0,7.4912,25H8V23H7.4954a5.5108,5.5108,0,0,1-5.4387-6.3,5.6992,5.6992,0,0,1,4.7138-4.6606l1.0166-.1836a.1306.1306,0,0,0,.1045-.1035l.18-.9351a8.28,8.28,0,0,1,6.8469-6.7427,7.957,7.957,0,0,1,2.8471.1245,8.22,8.22,0,0,1,6.1475,6.545l.1941,1.0083a.13.13,0,0,0,.1045.1035l1.0576.1914a5.7819,5.7819,0,0,1,3.1011,1.539A5.5052,5.5052,0,0,1,24.5076,23H24v2h.5076A7.5019,7.5019,0,0,0,25.91,10.13Z"
  })), children);
})));
if (false) {}
const VirtualPrivateCloud = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualPrivateCloud({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M20,20V17a4,4,0,0,0-8,0v3a2.0025,2.0025,0,0,0-2,2v6a2.0025,2.0025,0,0,0,2,2h8a2.0025,2.0025,0,0,0,2-2V22A2.0025,2.0025,0,0,0,20,20Zm-6-3a2,2,0,0,1,4,0v3H14ZM12,28V22h8l.0012,6Z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8288,10.1152A10.0067,10.0067,0,0,0,17.89,2.1816,10.0025,10.0025,0,0,0,6.17,10.1152,7.502,7.502,0,0,0,7.4912,25H8V23H7.4953a5.5019,5.5019,0,0,1-.9694-10.9165l1.3488-.2441.2591-1.3457a8.0109,8.0109,0,0,1,15.7312,0l.259,1.3457,1.3489.2441A5.5019,5.5019,0,0,1,24.5076,23H24v2h.5076a7.502,7.502,0,0,0,1.3212-14.8848Z"
  })), children);
})));
if (false) {}
const VirtualPrivateCloudAlt = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VirtualPrivateCloudAlt({
  children,
  size = 16,
  ...rest
}, ref) {
  if (false) {}
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4141,22,10,8.5859V2H2v8H8.5859L22,23.4141V30h8V22ZM8,8H4V4H8ZM28,28H24V24h4Z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M30,6a3.9915,3.9915,0,0,0-7.8579-1H13V7h9.1421A3.9945,3.9945,0,0,0,25,9.8579V19h2V9.8579A3.9962,3.9962,0,0,0,30,6ZM26,8a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,26,8Z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M19,25H9.8579A3.9945,3.9945,0,0,0,7,22.1421V13H5v9.1421A3.9915,3.9915,0,1,0,9.8579,27H19ZM6,28a2,2,0,1,1,2-2A2.0023,2.0023,0,0,1,6,28Z"
  })), children);
})));
if (false) {}
const VisualInspection = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VisualInspection({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M26,24.5859l-5.1147-5.1147c.9407-1.3201,1.3683-3.0299.9602-4.8428-.4971-2.2083-2.2783-3.9913-4.4888-4.4786-4.3566-.9604-8.1675,2.8505-7.207,7.2071.4873,2.2105,2.2703,3.9918,4.4787,4.4888,1.8129.408,3.5228-.0197,4.8429-.9605l5.1147,5.1147,1.4141-1.4141h0ZM17.0848,19.8568c-3.0406.805-5.7481-1.9051-4.9404-4.9449.3548-1.3352,1.4352-2.4146,2.7707-2.7682,3.0406-.805,5.7481,1.9051,4.9404,4.9449-.3548,1.3352-1.4352,2.4146-2.7707,2.7682ZM29.0663,16.3569l-.0654-.1709c-1.9897-5.2383-7.5781-9.1865-13.0005-9.1865s-11.0107,3.9482-12.9995,9.1841l-.0664.1733c-.1978.5166-.7764.7739-1.2915.5767-.5161-.1978-.7739-.7759-.5767-1.2915l.0654-.1709c2.2671-5.9688,8.6597-10.4717,14.8687-10.4717s12.6016,4.5029,14.8696,10.4741l.0645.1685M16.0004,27c-6.2088-.0002-12.6006-4.5031-14.8691-10.4741l-.064-.166c-.1987-.5151.0581-1.0942.5732-1.293.5146-.1982,1.0938.0576,1.293.5732l.0659.1709c1.9907,5.2405,7.5788,9.1887,13.001,9.189v2Z"
  })), children);
})));
if (false) {}
const VisualRecognition = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VisualRecognition({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "12",
    r: "2"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M28,5H16.24A8,8,0,1,0,6,16.92V27a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V7A2,2,0,0,0,28,5ZM4,10A6,6,0,0,1,15.19,7H8V9h7.91A6.64,6.64,0,0,1,16,10a6.64,6.64,0,0,1-.09,1H10v2h5.19A6,6,0,0,1,4,10ZM28,27H8l5-5,1.59,1.59a2,2,0,0,0,2.82,0L23,18l5,5Zm0-6.83-3.59-3.59a2,2,0,0,0-2.82,0L16,22.17l-1.59-1.59a2,2,0,0,0-2.82,0L8,24.17V17.74A8.24,8.24,0,0,0,10,18a8,8,0,0,0,8-8,7.9,7.9,0,0,0-.59-3H28Z"
  })), children);
})));
if (false) {}
const Vlan = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function Vlan({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M30,17V15H17V11h2a2.0023,2.0023,0,0,0,2-2V4a2.0023,2.0023,0,0,0-2-2H13a2.0023,2.0023,0,0,0-2,2V9a2.0023,2.0023,0,0,0,2,2h2v4H2v2H8v4H6a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H10V17H22v4H20a2.0023,2.0023,0,0,0-2,2v5a2.0023,2.0023,0,0,0,2,2h6a2.0023,2.0023,0,0,0,2-2V23a2.0023,2.0023,0,0,0-2-2H24V17ZM13,4h6V9H13ZM12,28H6V23h6Zm14,0H20V23h6Z"
  })), children);
})));
if (false) {}
const VlanIbm = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VlanIbm({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M16,22a4,4,0,1,0,4,4A4.0045,4.0045,0,0,0,16,22Zm0,6a2,2,0,1,1,2-2A2.002,2.002,0,0,1,16,28Z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M30,5a3,3,0,1,0-4,2.8154V15H17V9H15v6H6V7.8159a3.0007,3.0007,0,1,0-2,0V15a2.002,2.002,0,0,0,2,2h9v3h2V17h9a2.002,2.002,0,0,0,2-2V7.8159A2.9958,2.9958,0,0,0,30,5ZM5,4A1,1,0,1,1,4,5,1.0013,1.0013,0,0,1,5,4ZM27,6a1,1,0,1,1,1-1A1.0013,1.0013,0,0,1,27,6Z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "5",
    r: "2"
  })), children);
})));
if (false) {}
const VmdkDisk = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VmdkDisk({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "24.5",
    r: "1.5"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 14.964H21.5V20.035H19.5z",
    transform: "rotate(-45 20.5 17.5)"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: "16",
    cy: "13",
    r: "2"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M16,6a7,7,0,0,0,0,14V18a5,5,0,1,1,5-5h2A7,7,0,0,0,16,6Z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M26,2H6A2,2,0,0,0,4,4V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V4A2,2,0,0,0,26,2Zm0,26H6V4H26Z"
  })), children);
})));
if (false) {}
const VoiceActivate = /*#__PURE__*/(/* unused pure expression or super */ null && (React.forwardRef(function VoiceActivate({
  children,
  size = 16,
  ...rest
}, ref) {
  return /*#__PURE__*/React.createElement(Icon, {
    width: size,
    height: size,
    ref: ref,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    ...rest
  }, _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M26,30H24V27H20a5.0055,5.0055,0,0,1-5-5V20.7207l-2.3162-.772a1,1,0,0,1-.5412-1.4631L15,13.7229V11a9.01,9.01,0,0,1,9-9h5V4H24a7.0078,7.0078,0,0,0-7,7v3a.9991.9991,0,0,1-.1426.5144l-2.3586,3.9312,1.8174.6057A1,1,0,0,1,17,20v2a3.0033,3.0033,0,0,0,3,3h5a1,1,0,0,1,1,1Z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12H23V14H19z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3325,25.2168a7.0007,7.0007,0,0,1,0-10.4341l1.334,1.49a5,5,0,0,0,0,7.4537Z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M6.3994,28.8008a11.0019,11.0019,0,0,1,0-17.6006L7.6,12.8a9.0009,9.0009,0,0,0,0,14.4014Z"
  })), children);
})));
if (false) {}




/***/ })

}]);